@file:Suppress("unused", "SpellCheckingInspection")

package xim.poc.game.configuration.constants

val mskillNull_0 = MobSkillId(0)
val mskillFootKick_1 = MobSkillId(1)
val mskillDustCloud_2 = MobSkillId(2)
val mskillWhirlClaws_3 = MobSkillId(3)
val mskillLambChop_4 = MobSkillId(4)
val mskillRage_5 = MobSkillId(5)
val mskillSheepCharge_6 = MobSkillId(6)
val mskillSheepBleat_7 = MobSkillId(7)
val mskillSheepSong_8 = MobSkillId(8)
val mskillRage_9 = MobSkillId(9)
val mskillRamCharge_10 = MobSkillId(10)
val mskillRumble_11 = MobSkillId(11)
val mskillGreatBleat_12 = MobSkillId(12)
val mskillPetribreath_13 = MobSkillId(13)
val mskillRoar_14 = MobSkillId(14)
val mskillRazorFang_15 = MobSkillId(15)
val mskillRangedAttack_16 = MobSkillId(16)
val mskillClawCyclone_17 = MobSkillId(17)
val mskillSheepCharge_18 = MobSkillId(18)
val mskillSandblast_19 = MobSkillId(19)
val mskillSandpit_20 = MobSkillId(20)
val mskillVenomSpray_21 = MobSkillId(21)
val mskillPitAmbush_22 = MobSkillId(22)
val mskillMandibularBite_23 = MobSkillId(23)
val mskillSonicWave_24 = MobSkillId(24)
val mskillStomping_25 = MobSkillId(25)
val mskillBackKick_26 = MobSkillId(26)
val mskillSpinningTail_27 = MobSkillId(27)
val mskillColdStare_28 = MobSkillId(28)
val mskillWhistle_29 = MobSkillId(29)
val mskillBerserk_30 = MobSkillId(30)
val mskillHealingBreeze_31 = MobSkillId(31)
val mskillViciousClaw_32 = MobSkillId(32)
val mskillStoneThrow_33 = MobSkillId(33)
val mskillSpinningClaw_34 = MobSkillId(34)
val mskillClawStorm_35 = MobSkillId(35)
val mskillBlankGaze_36 = MobSkillId(36)
val mskillWhistleCall_37 = MobSkillId(37)
val mskillEyeScratch_38 = MobSkillId(38)
val mskillMagicFruit_39 = MobSkillId(39)
val mskillDrillBranch_40 = MobSkillId(40)
val mskillPineconeBomb_41 = MobSkillId(41)
val mskillLeafstorm_42 = MobSkillId(42)
val mskillEntangle_43 = MobSkillId(43)
val mskillHeadButt_44 = MobSkillId(44)
val mskillDreamFlower_45 = MobSkillId(45)
val mskillWildOats_46 = MobSkillId(46)
val mskillHundredFists_47 = MobSkillId(47)
val mskillPhotosynthesis_48 = MobSkillId(48)
val mskillLeafDagger_49 = MobSkillId(49)
val mskillScream_50 = MobSkillId(50)
val mskillSubstitute_51 = MobSkillId(51)
val mskillFrogkick_52 = MobSkillId(52)
val mskillSpore_53 = MobSkillId(53)
val mskillQueasyshroom_54 = MobSkillId(54)
val mskillNumbshroom_55 = MobSkillId(55)
val mskillShakeshroom_56 = MobSkillId(56)
val mskillCounterspore_57 = MobSkillId(57)
val mskillSilenceGas_58 = MobSkillId(58)
val mskillDarkSpore_59 = MobSkillId(59)
val mskillImpale_60 = MobSkillId(60)
val mskillVampiricLash_61 = MobSkillId(61)
val mskillSomersault_62 = MobSkillId(62)
val mskillBadBreath_63 = MobSkillId(63)
val mskillSweetBreath_64 = MobSkillId(64)
val mskillNeedleshot_65 = MobSkillId(65)
val mskill1000Needles_66 = MobSkillId(66)
val mskillWildCarrot_67 = MobSkillId(67)
val mskillPhotosynthesis_68 = MobSkillId(68)
val mskillRandomKiss_69 = MobSkillId(69)
val mskillAbsorbingKiss_70 = MobSkillId(70)
val mskillDeepKiss_71 = MobSkillId(71)
val mskillDrillBranch_72 = MobSkillId(72)
val mskillPineconeBomb_73 = MobSkillId(73)
val mskillShuffle_74 = MobSkillId(74)
val mskillLeafstorm_75 = MobSkillId(75)
val mskillEntangle_76 = MobSkillId(76)
val mskillDoubleDown_77 = MobSkillId(77)
val mskillSharpSting_78 = MobSkillId(78)
val mskillPollen_79 = MobSkillId(79)
val mskillFinalSting_80 = MobSkillId(80)
val mskillNoisyBuzz_81 = MobSkillId(81)
val mskillPowerAttack_82 = MobSkillId(82)
val mskillHiFreqField_83 = MobSkillId(83)
val mskillRhinoAttack_84 = MobSkillId(84)
val mskillRhinoGuard_85 = MobSkillId(85)
val mskillVulcanianImpact_86 = MobSkillId(86)
val mskillSpoil_87 = MobSkillId(87)
val mskillStickyThread_88 = MobSkillId(88)
val mskillPoisonBreath_89 = MobSkillId(89)
val mskillCocoon_90 = MobSkillId(90)
val mskillVelociousBlade_91 = MobSkillId(91)
val mskillNumbingBreath_92 = MobSkillId(92)
val mskillColdBreath_93 = MobSkillId(93)
val mskillMandibleBite_94 = MobSkillId(94)
val mskillPoisonSting_95 = MobSkillId(95)
val mskillStunningTail_96 = MobSkillId(96)
val mskillDeathScissors_97 = MobSkillId(97)
val mskillWildRage_98 = MobSkillId(98)
val mskillEarthPounder_99 = MobSkillId(99)
val mskillSharpStrike_100 = MobSkillId(100)
val mskillHeavyBlow_101 = MobSkillId(101)
val mskillHeavyWhisk_102 = MobSkillId(102)
val mskillBionicBoost_103 = MobSkillId(103)
val mskillFlyingHipPress_104 = MobSkillId(104)
val mskillEarthshock_105 = MobSkillId(105)
val mskillDoubleClaw_106 = MobSkillId(106)
val mskillGrapple_107 = MobSkillId(107)
val mskillFilamentedHold_108 = MobSkillId(108)
val mskillSpinningTop_109 = MobSkillId(109)
val mskillTailBlow_110 = MobSkillId(110)
val mskillFireball_111 = MobSkillId(111)
val mskillBlockhead_112 = MobSkillId(112)
val mskillBrainCrush_113 = MobSkillId(113)
val mskillBalefulGaze_114 = MobSkillId(114)
val mskillPlaguebreath_115 = MobSkillId(115)
val mskillInfrasonics_116 = MobSkillId(116)
val mskillSecretion_117 = MobSkillId(117)
val mskillRipperFang_118 = MobSkillId(118)
val mskillBacklashTail_119 = MobSkillId(119)
val mskillFoulBreath_120 = MobSkillId(120)
val mskillFrostBreath_121 = MobSkillId(121)
val mskillThunderbolt_122 = MobSkillId(122)
val mskillChompRush_123 = MobSkillId(123)
val mskillScytheTail_124 = MobSkillId(124)
val mskillChameleonSkin_125 = MobSkillId(125)
val mskillTailRoll_126 = MobSkillId(126)
val mskillTusk_127 = MobSkillId(127)
val mskillScutum_128 = MobSkillId(128)
val mskillBoneCrunch_129 = MobSkillId(129)
val mskillAwfulEye_130 = MobSkillId(130)
val mskillHeavyBellow_131 = MobSkillId(131)
val mskillVanityDive_132 = MobSkillId(132)
val mskillEmptyBeleaguer_133 = MobSkillId(133)
val mskillMirage_134 = MobSkillId(134)
val mskillAuraofPersistence_135 = MobSkillId(135)
val mskillUltrasonics_136 = MobSkillId(136)
val mskillSonicBoom_137 = MobSkillId(137)
val mskillBloodDrain_138 = MobSkillId(138)
val mskillJetStream_139 = MobSkillId(139)
val mskillSmiteofFury_140 = MobSkillId(140)
val mskillFlurryofRage_141 = MobSkillId(141)
val mskillWhispersofIre_142 = MobSkillId(142)
val mskillBlindVortex_143 = MobSkillId(143)
val mskillGigaScream_144 = MobSkillId(144)
val mskillDreadDive_145 = MobSkillId(145)
val mskillFeatherBarrier_146 = MobSkillId(146)
val mskillStormwind_147 = MobSkillId(147)
val mskillSmiteofRage_148 = MobSkillId(148)
val mskillDireWhorl_149 = MobSkillId(149)
val mskillHammerBeak_150 = MobSkillId(150)
val mskillPoisonPick_151 = MobSkillId(151)
val mskillSoundVacuum_152 = MobSkillId(152)
val mskillTailRod_153 = MobSkillId(153)
val mskillSoundBlast_154 = MobSkillId(154)
val mskillBalefulGaze_155 = MobSkillId(155)
val mskillRangedAttack_156 = MobSkillId(156)
val mskillEagleEyeShot_157 = MobSkillId(157)
val mskillSuction_158 = MobSkillId(158)
val mskillAcidMist_159 = MobSkillId(159)
val mskillSandBreath_160 = MobSkillId(160)
val mskillDrainkiss_161 = MobSkillId(161)
val mskillRegeneration_162 = MobSkillId(162)
val mskillScissionThrust_163 = MobSkillId(163)
val mskillTPDrainkiss_164 = MobSkillId(164)
val mskillMPDrainkiss_165 = MobSkillId(165)
val mskillSonicBlade_166 = MobSkillId(166)
val mskillBrainDrain_167 = MobSkillId(167)
val mskillFullforceBlow_168 = MobSkillId(168)
val mskillGastricBomb_169 = MobSkillId(169)
val mskillSandspin_170 = MobSkillId(170)
val mskillTremors_171 = MobSkillId(171)
val mskillMPAbsorption_172 = MobSkillId(172)
val mskillSoundVacuum_173 = MobSkillId(173)
val mskillBuffDrain_174 = MobSkillId(174)
val mskillFluidSpread_175 = MobSkillId(175)
val mskillFluidToss_176 = MobSkillId(176)
val mskillDigest_177 = MobSkillId(177)
val mskillSoporific_178 = MobSkillId(178)
val mskillPalsyPollen_179 = MobSkillId(179)
val mskillGloeosuccus_180 = MobSkillId(180)
val mskillDeathRay_181 = MobSkillId(181)
val mskillHexEye_182 = MobSkillId(182)
val mskillPetroGaze_183 = MobSkillId(183)
val mskillCatharsis_184 = MobSkillId(184)
val mskillMicroquake_185 = MobSkillId(185)
val mskillBubbleShower_186 = MobSkillId(186)
val mskillBubbleCurtain_187 = MobSkillId(187)
val mskillBigScissors_188 = MobSkillId(188)
val mskillScissorGuard_189 = MobSkillId(189)
val mskillIntimidate_190 = MobSkillId(190)
val mskillPercussiveFoin_191 = MobSkillId(191)
val mskillMetallicBody_192 = MobSkillId(192)
val mskillIntimidate_193 = MobSkillId(193)
val mskillAquaBall_194 = MobSkillId(194)
val mskillSplashBreath_195 = MobSkillId(195)
val mskillScrewdriver_196 = MobSkillId(196)
val mskillWaterWall_197 = MobSkillId(197)
val mskillWaterShield_198 = MobSkillId(198)
val mskillAquaLens_199 = MobSkillId(199)
val mskillTentacle_200 = MobSkillId(200)
val mskillGravityWheel_201 = MobSkillId(201)
val mskillInkJet_202 = MobSkillId(202)
val mskillHardMembrane_203 = MobSkillId(203)
val mskillCrossAttack_204 = MobSkillId(204)
val mskillRegeneration_205 = MobSkillId(205)
val mskillMaelstrom_206 = MobSkillId(206)
val mskillWhirlwind_207 = MobSkillId(207)
val mskillPsychomancy_208 = MobSkillId(208)
val mskillHowling_209 = MobSkillId(209)
val mskillPoisonBreath_210 = MobSkillId(210)
val mskillRotGas_211 = MobSkillId(211)
val mskillDirtyClaw_212 = MobSkillId(212)
val mskillShadowClaw_213 = MobSkillId(213)
val mskillMethaneBreath_214 = MobSkillId(214)
val mskillMindWall_215 = MobSkillId(215)
val mskillGraveReel_216 = MobSkillId(216)
val mskillEctosmash_217 = MobSkillId(217)
val mskillFearTouch_218 = MobSkillId(218)
val mskillTerrorTouch_219 = MobSkillId(219)
val mskillCurse_220 = MobSkillId(220)
val mskillDarkSphere_221 = MobSkillId(221)
val mskillHellSlash_222 = MobSkillId(222)
val mskillHorrorCloud_223 = MobSkillId(223)
val mskillPetrifactiveBreath_224 = MobSkillId(224)
val mskillFrenziedRage_225 = MobSkillId(225)
val mskillPounce_226 = MobSkillId(226)
val mskillChargedWhisker_227 = MobSkillId(227)
val mskillBlackCloud_228 = MobSkillId(228)
val mskillBloodSaber_229 = MobSkillId(229)
val mskillWhipTongue_230 = MobSkillId(230)
val mskillTransmogrification_231 = MobSkillId(231)
val mskillAcidBreath_232 = MobSkillId(232)
val mskillStinkingGas_233 = MobSkillId(233)
val mskillUndeadMold_234 = MobSkillId(234)
val mskillCalloftheGrave_235 = MobSkillId(235)
val mskillAbyssBlast_236 = MobSkillId(236)
val mskillRampantGnaw_237 = MobSkillId(237)
val mskillBigHorn_238 = MobSkillId(238)
val mskillSnort_239 = MobSkillId(239)
val mskillRabidDance_240 = MobSkillId(240)
val mskillLowing_241 = MobSkillId(241)
val mskillTriclip_242 = MobSkillId(242)
val mskillBackSwish_243 = MobSkillId(243)
val mskillMow_244 = MobSkillId(244)
val mskillFrightfulRoar_245 = MobSkillId(245)
val mskillMortalRay_246 = MobSkillId(246)
val mskillUnblestArmor_247 = MobSkillId(247)
val mskillGasShell_248 = MobSkillId(248)
val mskillVenomShell_249 = MobSkillId(249)
val mskillPalsynyxis_250 = MobSkillId(250)
val mskillPainfulWhip_251 = MobSkillId(251)
val mskillSuctorialTentacle_252 = MobSkillId(252)
val mskillSelfDestruct_253 = MobSkillId(253)
val mskillBerserk_254 = MobSkillId(254)
val mskillSelfDestruct_255 = MobSkillId(255)
val mskillHeatWave_256 = MobSkillId(256)
val mskillSmiteofRage_257 = MobSkillId(257)
val mskillWhirlofRage_258 = MobSkillId(258)
val mskillToxicSpit_259 = MobSkillId(259)
val mskillGeistWall_260 = MobSkillId(260)
val mskillNumbingNoise_261 = MobSkillId(261)
val mskillNimbleSnap_262 = MobSkillId(262)
val mskillCyclotail_263 = MobSkillId(263)
val mskillDoubleRay_264 = MobSkillId(264)
val mskillSpinningAttack_265 = MobSkillId(265)
val mskillSpectralBarrier_266 = MobSkillId(266)
val mskillMysteriousLight_267 = MobSkillId(267)
val mskillMindDrain_268 = MobSkillId(268)
val mskillBatteryCharge_269 = MobSkillId(269)
val mskillBerserk_270 = MobSkillId(270)
val mskillFreezeRush_271 = MobSkillId(271)
val mskillColdWave_272 = MobSkillId(272)
val mskillHypothermalCombustion_273 = MobSkillId(273)
val mskillMementoMori_274 = MobSkillId(274)
val mskillSilenceSeal_275 = MobSkillId(275)
val mskillEnvoutement_276 = MobSkillId(276)
val mskillDanseMacabre_277 = MobSkillId(277)
val mskillKartstrahl_278 = MobSkillId(278)
val mskillBlitzstrahl_279 = MobSkillId(279)
val mskillPanzerfaust_280 = MobSkillId(280)
val mskillBerserk_281 = MobSkillId(281)
val mskillPanzerschreck_282 = MobSkillId(282)
val mskillTyphoon_283 = MobSkillId(283)
val mskillTremorousTread_284 = MobSkillId(284)
val mskillGravityField_285 = MobSkillId(285)
val mskillEmptySeed_286 = MobSkillId(286)
val mskillMeltdown_287 = MobSkillId(287)
val mskillCamisado_288 = MobSkillId(288)
val mskillSomnolence_289 = MobSkillId(289)
val mskillNoctoshield_290 = MobSkillId(290)
val mskillUltimateTerror_291 = MobSkillId(291)
val mskillBlindeye_292 = MobSkillId(292)
val mskillEyesOnMe_293 = MobSkillId(293)
val mskillHypnosis_294 = MobSkillId(294)
val mskillMindBreak_295 = MobSkillId(295)
val mskillBindingWave_296 = MobSkillId(296)
val mskillAiryShield_297 = MobSkillId(297)
val mskillPetCharm_298 = MobSkillId(298)
val mskillMagicBarrier_299 = MobSkillId(299)
val mskillDreamShroud_300 = MobSkillId(300)
val mskillLevel5Petrify_301 = MobSkillId(301)
val mskillNightmare_302 = MobSkillId(302)
val mskillSoulDrain_303 = MobSkillId(303)
val mskillHecatombWave_304 = MobSkillId(304)
val mskillElectromagneticField_305 = MobSkillId(305)
val mskillReactiveArmor_306 = MobSkillId(306)
val mskillDemonicHowl_307 = MobSkillId(307)
val mskillCondemnation_308 = MobSkillId(308)
val mskillQuadrastrike_309 = MobSkillId(309)
val mskillQuadrastrike_310 = MobSkillId(310)
val mskillSlingBomb_311 = MobSkillId(311)
val mskillFormationAttack_312 = MobSkillId(312)
val mskillRefueling_313 = MobSkillId(313)
val mskillCircleofFlames_314 = MobSkillId(314)
val mskillSelfDestruct_315 = MobSkillId(315)
val mskillSelfDestruct_316 = MobSkillId(316)
val mskillSelfDestruct_317 = MobSkillId(317)
val mskillSelfDestruct_318 = MobSkillId(318)
val mskillSelfDestruct_319 = MobSkillId(319)
val mskillBackHeel_320 = MobSkillId(320)
val mskillJettatura_321 = MobSkillId(321)
val mskillNihilitySong_322 = MobSkillId(322)
val mskillChokeBreath_323 = MobSkillId(323)
val mskillFantod_324 = MobSkillId(324)
val mskillBlow_325 = MobSkillId(325)
val mskillCacodemonia_326 = MobSkillId(326)
val mskillBeatdown_327 = MobSkillId(327)
val mskillUppercut_328 = MobSkillId(328)
val mskillHekatonPunch_329 = MobSkillId(329)
val mskillBlankGaze_330 = MobSkillId(330)
val mskillAntiphase_331 = MobSkillId(331)
val mskillDeathTrap_332 = MobSkillId(332)
val mskillMortalRay_333 = MobSkillId(333)
val mskillGoblinRush_334 = MobSkillId(334)
val mskillBombToss_335 = MobSkillId(335)
val mskillBombToss_336 = MobSkillId(336)
val mskillBerserk_337 = MobSkillId(337)
val mskillVulcanianImpact_338 = MobSkillId(338)
val mskillHeatWave_339 = MobSkillId(339)
val mskillHellstorm_340 = MobSkillId(340)
val mskillSelfDestruct_341 = MobSkillId(341)
val mskillBerserk_342 = MobSkillId(342)
val mskillArcticImpact_343 = MobSkillId(343)
val mskillColdWave_344 = MobSkillId(344)
val mskillHiemalStorm_345 = MobSkillId(345)
val mskillHypothermalCombustion_346 = MobSkillId(346)
val mskillLateralSlash_347 = MobSkillId(347)
val mskillThroatStab_348 = MobSkillId(348)
val mskillAerialWheel_349 = MobSkillId(349)
val mskillShoulderAttack_350 = MobSkillId(350)
val mskillSlamDunk_351 = MobSkillId(351)
val mskillArmBlock_352 = MobSkillId(352)
val mskillBattleDance_353 = MobSkillId(353)
val mskillNetherBlast_354 = MobSkillId(354)
val mskillOreToss_355 = MobSkillId(355)
val mskillHeadButt_356 = MobSkillId(356)
val mskillShellBash_357 = MobSkillId(357)
val mskillShellGuard_358 = MobSkillId(358)
val mskillHellspin_359 = MobSkillId(359)
val mskillRuinousOmen_360 = MobSkillId(360)
val mskillFeatherStorm_361 = MobSkillId(361)
val mskillDoubleKick_362 = MobSkillId(362)
val mskillParry_363 = MobSkillId(363)
val mskillSweep_364 = MobSkillId(364)
val mskillSnowball_365 = MobSkillId(365)
val mskillHelldive_366 = MobSkillId(366)
val mskillWingCutter_367 = MobSkillId(367)
val mskillVulture1_368 = MobSkillId(368)
val mskillVulture2_369 = MobSkillId(369)
val mskillVulture3_370 = MobSkillId(370)
val mskillVulture4_371 = MobSkillId(371)
val mskillWildHorn_372 = MobSkillId(372)
val mskillThunderbolt_373 = MobSkillId(373)
val mskillKickOut_374 = MobSkillId(374)
val mskillShockWave_375 = MobSkillId(375)
val mskillFlameArmor_376 = MobSkillId(376)
val mskillHowl_377 = MobSkillId(377)
val mskillMeteor_378 = MobSkillId(378)
val mskillBurst_379 = MobSkillId(379)
val mskillFlameArrow_380 = MobSkillId(380)
val mskillFirebomb_381 = MobSkillId(381)
val mskillBlastbomb_382 = MobSkillId(382)
val mskillFountain_383 = MobSkillId(383)
val mskillTouchdown_384 = MobSkillId(384)
val mskillRecoilDive_385 = MobSkillId(385)
val mskillFlameBreath_386 = MobSkillId(386)
val mskillPoisonBreath_387 = MobSkillId(387)
val mskillWindBreath_388 = MobSkillId(388)
val mskillBodySlam_389 = MobSkillId(389)
val mskillHeavyStomp_390 = MobSkillId(390)
val mskillChaosBlade_391 = MobSkillId(391)
val mskillPetroEyes_392 = MobSkillId(392)
val mskillVoidsong_393 = MobSkillId(393)
val mskillThornsong_394 = MobSkillId(394)
val mskillLodesong_395 = MobSkillId(395)
val mskillBlaster_396 = MobSkillId(396)
val mskillChaoticEye_397 = MobSkillId(397)
val mskillDoubleWhammy_398 = MobSkillId(398)
val mskillScurvy_399 = MobSkillId(399)
val mskillGildedTorpor_400 = MobSkillId(400)
val mskillCalamitousCollapse_401 = MobSkillId(401)
val mskillCatapult_402 = MobSkillId(402)
val mskillCursedSphere_403 = MobSkillId(403)
val mskillVenom_404 = MobSkillId(404)
val mskillSnowCloud_405 = MobSkillId(405)
val mskillLightningRoar_406 = MobSkillId(406)
val mskillIceRoar_407 = MobSkillId(407)
val mskillImpactRoar_408 = MobSkillId(408)
val mskillGrandSlam_409 = MobSkillId(409)
val mskillPowerAttack_410 = MobSkillId(410)
val mskillPowerAttack_411 = MobSkillId(411)
val mskillKickBack_412 = MobSkillId(412)
val mskillImplosion_413 = MobSkillId(413)
val mskillImplosion_414 = MobSkillId(414)
val mskillUmbraSmash_415 = MobSkillId(415)
val mskillGigaSlash_416 = MobSkillId(416)
val mskillDarkNova_417 = MobSkillId(417)
val mskillCrystalShield_418 = MobSkillId(418)
val mskillHeavyStrike_419 = MobSkillId(419)
val mskillIceBreak_420 = MobSkillId(420)
val mskillThunderBreak_421 = MobSkillId(421)
val mskillCrystalRain_422 = MobSkillId(422)
val mskillCrystalWeapon_423 = MobSkillId(423)
val mskillCrystalWeapon_424 = MobSkillId(424)
val mskillCrystalWeapon_425 = MobSkillId(425)
val mskillCrystalWeapon_426 = MobSkillId(426)
val mskillBludgeon_427 = MobSkillId(427)
val mskillDealOut_428 = MobSkillId(428)
val mskillSproutSpin_429 = MobSkillId(429)
val mskillSlumberPowder_430 = MobSkillId(430)
val mskillSproutSmack_431 = MobSkillId(431)
val mskillMightyStrikes_432 = MobSkillId(432)
val mskillBenediction_433 = MobSkillId(433)
val mskillHundredFists_434 = MobSkillId(434)
val mskillManafont_435 = MobSkillId(435)
val mskillChainspell_436 = MobSkillId(436)
val mskillPerfectDodge_437 = MobSkillId(437)
val mskillInvincible_438 = MobSkillId(438)
val mskillBloodWeapon_439 = MobSkillId(439)
val mskillSoulVoice_440 = MobSkillId(440)
val mskillBerserk_441 = MobSkillId(441)
val mskillDefender_442 = MobSkillId(442)
val mskillAggressor_443 = MobSkillId(443)
val mskillBoost_444 = MobSkillId(444)
val mskillFocus_445 = MobSkillId(445)
val mskillDodge_446 = MobSkillId(446)
val mskillChakra_447 = MobSkillId(447)
val mskillCounterstance_448 = MobSkillId(448)
val mskillHide_449 = MobSkillId(449)
val mskillBash_450 = MobSkillId(450)
val mskillSentinel_451 = MobSkillId(451)
val mskillLastResort_452 = MobSkillId(452)
val mskillSouleater_453 = MobSkillId(453)
val mskillCharm_454 = MobSkillId(454)
val mskillEagleEyeShot_455 = MobSkillId(455)
val mskillEagleEyeShot_456 = MobSkillId(456)
val mskillSharpshot_457 = MobSkillId(457)
val mskillCamouflage_458 = MobSkillId(458)
val mskillBarrage_459 = MobSkillId(459)
val mskillShadowbind_460 = MobSkillId(460)
val mskillVenomBreath_461 = MobSkillId(461)
val mskillJump_462 = MobSkillId(462)
val mskillCriticalBite_463 = MobSkillId(463)
val mskillVenomSting_464 = MobSkillId(464)
val mskillStasis_465 = MobSkillId(465)
val mskillVenomStorm_466 = MobSkillId(466)
val mskillEarthbreaker_467 = MobSkillId(467)
val mskillEvasion_468 = MobSkillId(468)
val mskillImpale_469 = MobSkillId(469)
val mskillDrainWhip_470 = MobSkillId(470)
val mskillBadBreath_471 = MobSkillId(471)
val mskillSweetBreath_472 = MobSkillId(472)
val mskillDeathTrap_473 = MobSkillId(473)
val mskillMeikyoShisui_474 = MobSkillId(474)
val mskillMijinGakure_475 = MobSkillId(475)
val mskillCallWyvern_476 = MobSkillId(476)
val mskillJump_477 = MobSkillId(477)
val mskillAstralFlow_478 = MobSkillId(478)
val mskillEagleEyeShot_479 = MobSkillId(479)
val mskillEagleEyeShot_480 = MobSkillId(480)
val mskillEagleEyeShot_481 = MobSkillId(481)
val mskillEagleEyeShot_482 = MobSkillId(482)
val mskillEagleEyeShot_483 = MobSkillId(483)
val mskillFamiliar_484 = MobSkillId(484)
val mskillQuadraticContinuum_485 = MobSkillId(485)
val mskillQuadraticContinuum_486 = MobSkillId(486)
val mskillQuadraticContinuum_487 = MobSkillId(487)
val mskillSpiritAbsorption_488 = MobSkillId(488)
val mskillSpiritAbsorption_489 = MobSkillId(489)
val mskillSpiritAbsorption_490 = MobSkillId(490)
val mskillVanityDrive_491 = MobSkillId(491)
val mskillVanityDrive_492 = MobSkillId(492)
val mskillVanityDrive_493 = MobSkillId(493)
val mskillStygianFlatus_494 = MobSkillId(494)
val mskillStygianFlatus_495 = MobSkillId(495)
val mskillPromyvionBarrier_496 = MobSkillId(496)
val mskillPromyvionBarrier_497 = MobSkillId(497)
val mskillPromyvionBarrier_498 = MobSkillId(498)
val mskillFission_499 = MobSkillId(499)
val mskillLevel5Petrify_500 = MobSkillId(500)
val mskillHowl_501 = MobSkillId(501)
val mskillHowl_502 = MobSkillId(502)
val mskillHowl_503 = MobSkillId(503)
val mskillHowl_504 = MobSkillId(504)
val mskillHowl_505 = MobSkillId(505)
val mskillHowl_506 = MobSkillId(506)
val mskillHowl_507 = MobSkillId(507)
val mskillHowl_508 = MobSkillId(508)
val mskillHowl_509 = MobSkillId(509)
val mskillHowl_510 = MobSkillId(510)
val mskillBow_511 = MobSkillId(511)
val mskillJumpingStrike_512 = MobSkillId(512)
val mskillFlyingPunch_513 = MobSkillId(513)
val mskillJumpingThrust_514 = MobSkillId(514)
val mskillHydroball_515 = MobSkillId(515)
val mskillHydroball_516 = MobSkillId(516)
val mskillHydroball_517 = MobSkillId(517)
val mskillBubbleArmor_518 = MobSkillId(518)
val mskillBubbleArmor_519 = MobSkillId(519)
val mskillBubbleArmor_520 = MobSkillId(520)
val mskillHydroShot_521 = MobSkillId(521)
val mskillHydroShot_522 = MobSkillId(522)
val mskillHydroShot_523 = MobSkillId(523)
val mskillSpinningFin_524 = MobSkillId(524)
val mskillSpinningFin_525 = MobSkillId(525)
val mskillSpinningFin_526 = MobSkillId(526)
val mskillWordsofBane_527 = MobSkillId(527)
val mskillSigh_528 = MobSkillId(528)
val mskillLightofPenance_529 = MobSkillId(529)
val mskillLateralSlash_530 = MobSkillId(530)
val mskillVerticalSlash_531 = MobSkillId(531)
val mskillThroatStab_532 = MobSkillId(532)
val mskillSpikeball_533 = MobSkillId(533)
val mskillShoulderSlam_534 = MobSkillId(534)
val mskillMagnetiteCloud_535 = MobSkillId(535)
val mskillSandstorm_536 = MobSkillId(536)
val mskillSandVeil_537 = MobSkillId(537)
val mskillSandShield_538 = MobSkillId(538)
val mskillSandTrap_539 = MobSkillId(539)
val mskillJammingWave_540 = MobSkillId(540)
val mskillDeadlyHold_541 = MobSkillId(541)
val mskillTailSwing_542 = MobSkillId(542)
val mskillTailSmash_543 = MobSkillId(543)
val mskillHeatBreath_544 = MobSkillId(544)
val mskillRiddle_545 = MobSkillId(545)
val mskillGreatSandstorm_546 = MobSkillId(546)
val mskillGreatWhirlwind_547 = MobSkillId(547)
val mskillTortoiseSong_548 = MobSkillId(548)
val mskillHeadButt_549 = MobSkillId(549)
val mskillTortoiseStomp_550 = MobSkillId(550)
val mskillHardenShell_551 = MobSkillId(551)
val mskillEarthBreath_552 = MobSkillId(552)
val mskillAquaBreath_553 = MobSkillId(553)
val mskillSickleSlash_554 = MobSkillId(554)
val mskillAcidSpray_555 = MobSkillId(555)
val mskillSpiderWeb_556 = MobSkillId(556)
val mskillDispellingWind_557 = MobSkillId(557)
val mskillDeadlyDrive_558 = MobSkillId(558)
val mskillWindWall_559 = MobSkillId(559)
val mskillFangRush_560 = MobSkillId(560)
val mskillDreadShriek_561 = MobSkillId(561)
val mskillTailCrush_562 = MobSkillId(562)
val mskillBlizzardBreath_563 = MobSkillId(563)
val mskillThunderBreath_564 = MobSkillId(564)
val mskillRadiantBreath_565 = MobSkillId(565)
val mskillChaosBreath_566 = MobSkillId(566)
val mskillFireBlade_567 = MobSkillId(567)
val mskillFrostBlade_568 = MobSkillId(568)
val mskillWindBlade_569 = MobSkillId(569)
val mskillEarthBlade_570 = MobSkillId(570)
val mskillLightningBlade_571 = MobSkillId(571)
val mskillWaterBlade_572 = MobSkillId(572)
val mskillGreatWheel_573 = MobSkillId(573)
val mskillLightBlade_574 = MobSkillId(574)
val mskillMoonlitCharge_575 = MobSkillId(575)
val mskillCrescentFang_576 = MobSkillId(576)
val mskillLunarCry_577 = MobSkillId(577)
val mskillEclipticGrowl_578 = MobSkillId(578)
val mskillLunarRoar_579 = MobSkillId(579)
val mskillEclipseBite_580 = MobSkillId(580)
val mskillEclipticHowl_581 = MobSkillId(581)
val mskillHowlingMoon_582 = MobSkillId(582)
val mskillHowlingMoon_583 = MobSkillId(583)
val mskillPunch_584 = MobSkillId(584)
val mskillFireII_585 = MobSkillId(585)
val mskillBurningStrike_586 = MobSkillId(586)
val mskillDoublePunch_587 = MobSkillId(587)
val mskillCrimsonRoar_588 = MobSkillId(588)
val mskillFireIV_589 = MobSkillId(589)
val mskillFlamingCrush_590 = MobSkillId(590)
val mskillMeteorStrike_591 = MobSkillId(591)
val mskillInferno_592 = MobSkillId(592)
val mskillRockThrow_593 = MobSkillId(593)
val mskillStoneII_594 = MobSkillId(594)
val mskillRockBuster_595 = MobSkillId(595)
val mskillMegalithThrow_596 = MobSkillId(596)
val mskillEarthenWard_597 = MobSkillId(597)
val mskillStoneIV_598 = MobSkillId(598)
val mskillMountainBuster_599 = MobSkillId(599)
val mskillGeocrush_600 = MobSkillId(600)
val mskillEarthenFury_601 = MobSkillId(601)
val mskillBarracudaDive_602 = MobSkillId(602)
val mskillWaterII_603 = MobSkillId(603)
val mskillTailWhip_604 = MobSkillId(604)
val mskillSpringWater_605 = MobSkillId(605)
val mskillSlowga_606 = MobSkillId(606)
val mskillWaterIV_607 = MobSkillId(607)
val mskillSpinningDive_608 = MobSkillId(608)
val mskillGrandFall_609 = MobSkillId(609)
val mskillTidalWave_610 = MobSkillId(610)
val mskillClaw_611 = MobSkillId(611)
val mskillAeroII_612 = MobSkillId(612)
val mskillWhisperingWind_613 = MobSkillId(613)
val mskillHastega_614 = MobSkillId(614)
val mskillAerialArmor_615 = MobSkillId(615)
val mskillAeroIV_616 = MobSkillId(616)
val mskillPredatorClaws_617 = MobSkillId(617)
val mskillWindBlade_618 = MobSkillId(618)
val mskillAerialBlast_619 = MobSkillId(619)
val mskillAxeKick_620 = MobSkillId(620)
val mskillBlizzardII_621 = MobSkillId(621)
val mskillFrostArmor_622 = MobSkillId(622)
val mskillSleepga_623 = MobSkillId(623)
val mskillDoubleSlap_624 = MobSkillId(624)
val mskillBlizzardIV_625 = MobSkillId(625)
val mskillRush_626 = MobSkillId(626)
val mskillHeavenlyStrike_627 = MobSkillId(627)
val mskillDiamondDust_628 = MobSkillId(628)
val mskillShockStrike_629 = MobSkillId(629)
val mskillThunderII_630 = MobSkillId(630)
val mskillRollingThunder_631 = MobSkillId(631)
val mskillThunderspark_632 = MobSkillId(632)
val mskillLightningArmor_633 = MobSkillId(633)
val mskillThunderIV_634 = MobSkillId(634)
val mskillChaoticStrike_635 = MobSkillId(635)
val mskillThunderstorm_636 = MobSkillId(636)
val mskillJudgmentBolt_637 = MobSkillId(637)
val mskillHealingBreath_638 = MobSkillId(638)
val mskillHealingBreathII_639 = MobSkillId(639)
val mskillHealingBreathIII_640 = MobSkillId(640)
val mskillRemovePoison_641 = MobSkillId(641)
val mskillRemoveBlindness_642 = MobSkillId(642)
val mskillRemoveParalysis_643 = MobSkillId(643)
val mskillFlameBreath_644 = MobSkillId(644)
val mskillFrostBreath_645 = MobSkillId(645)
val mskillGustBreath_646 = MobSkillId(646)
val mskillSandBreath_647 = MobSkillId(647)
val mskillLightningBreath_648 = MobSkillId(648)
val mskillHydroBreath_649 = MobSkillId(649)
val mskillHealingRuby_650 = MobSkillId(650)
val mskillPoisonNails_651 = MobSkillId(651)
val mskillShiningRuby_652 = MobSkillId(652)
val mskillGlitteringRuby_653 = MobSkillId(653)
val mskillMeteorite_654 = MobSkillId(654)
val mskillHealingRubyII_655 = MobSkillId(655)
val mskillSearingLight_656 = MobSkillId(656)
val mskillInferno_657 = MobSkillId(657)
val mskillEarthenFury_658 = MobSkillId(658)
val mskillTidalWave_659 = MobSkillId(659)
val mskillAerialBlast_660 = MobSkillId(660)
val mskillDiamondDust_661 = MobSkillId(661)
val mskillJudgmentBolt_662 = MobSkillId(662)
val mskillSearingLight_663 = MobSkillId(663)
val mskillEveryonesGrudge_664 = MobSkillId(664)
val mskillEveryonesRancor_665 = MobSkillId(665)
val mskillBlindVortex_666 = MobSkillId(666)
val mskillGigaScream_667 = MobSkillId(667)
val mskillDreadDive_668 = MobSkillId(668)
val mskillFeatherBarrier_669 = MobSkillId(669)
val mskillStormwind_670 = MobSkillId(670)
val mskillDrillBranch_671 = MobSkillId(671)
val mskillPineconeBomb_672 = MobSkillId(672)
val mskillLeafstorm_673 = MobSkillId(673)
val mskillEntangle_674 = MobSkillId(674)
val mskillCrossReaver_675 = MobSkillId(675)
val mskillHavocSpiral_676 = MobSkillId(676)
val mskillDominionSlash_677 = MobSkillId(677)
val mskillShieldStrike_678 = MobSkillId(678)
val mskillAmonDrive_679 = MobSkillId(679)
val mskillArkGuardianTarutaru_680 = MobSkillId(680)
val mskillDragonfall_681 = MobSkillId(681)
val mskillCircleBlade_682 = MobSkillId(682)
val mskillSwiftBlade_683 = MobSkillId(683)
val mskillRampage_684 = MobSkillId(684)
val mskillCalamity_685 = MobSkillId(685)
val mskillSpiritsWithin_686 = MobSkillId(686)
val mskillVorpalBlade_687 = MobSkillId(687)
val mskillSpinningScythe_688 = MobSkillId(688)
val mskillGuillotine_689 = MobSkillId(689)
val mskillTachiYukikaze_690 = MobSkillId(690)
val mskillTachiGekko_691 = MobSkillId(691)
val mskillTachiKasha_692 = MobSkillId(692)
val mskillFlameBlast_693 = MobSkillId(693)
val mskillFlameBlast_694 = MobSkillId(694)
val mskillHurricaneWing_695 = MobSkillId(695)
val mskillSpikeFlail_696 = MobSkillId(696)
val mskillDragonBreath_697 = MobSkillId(697)
val mskillTouchdown_698 = MobSkillId(698)
val mskillFlameBlast_699 = MobSkillId(699)
val mskillHurricaneWing_700 = MobSkillId(700)
val mskillAbsoluteTerror_701 = MobSkillId(701)
val mskillHorridRoar_702 = MobSkillId(702)
val mskillSickleSlash_703 = MobSkillId(703)
val mskillAcidSpray_704 = MobSkillId(704)
val mskillSpiderWeb_705 = MobSkillId(705)
val mskillTarutaruWarpII_706 = MobSkillId(706)
val mskillEald1_707 = MobSkillId(707)
val mskillEald1_708 = MobSkillId(708)
val mskillEald1_709 = MobSkillId(709)
val mskillEald1_710 = MobSkillId(710)
val mskillEald1_711 = MobSkillId(711)
val mskillRedLotusBlade_712 = MobSkillId(712)
val mskillFlatBlade_713 = MobSkillId(713)
val mskillSavageBlade_714 = MobSkillId(714)
val mskillRoyalBash_715 = MobSkillId(715)
val mskillRoyalSavior_716 = MobSkillId(716)
val mskillRedLotusBlade_717 = MobSkillId(717)
val mskillSpiritsWithin_718 = MobSkillId(718)
val mskillVorpalBlade_719 = MobSkillId(719)
val mskillBerserkRuf_720 = MobSkillId(720)
val mskillWarp_721 = MobSkillId(721)
val mskillWarp_722 = MobSkillId(722)
val mskillPowerSlash_723 = MobSkillId(723)
val mskillFreezebite_724 = MobSkillId(724)
val mskillGroundStrike_725 = MobSkillId(725)
val mskillAbyssalDrain_726 = MobSkillId(726)
val mskillAbyssalStrike_727 = MobSkillId(727)
val mskillElectrocharge_728 = MobSkillId(728)
val mskillStellarBurst_729 = MobSkillId(729)
val mskillVortex_730 = MobSkillId(730)
val mskillShockwave_731 = MobSkillId(731)
val mskillEald2WarpIn_732 = MobSkillId(732)
val mskillEald2WarpOut_733 = MobSkillId(733)
val mskillGaeaStreamEta_734 = MobSkillId(734)
val mskillUranosCascadeEta_735 = MobSkillId(735)
val mskillCronosSlingEta_736 = MobSkillId(736)
val mskillPhaseShift_737 = MobSkillId(737)
val mskillGaeaStreamTheta_738 = MobSkillId(738)
val mskillUranosCascadeTheta_739 = MobSkillId(739)
val mskillCronosSlingTheta_740 = MobSkillId(740)
val mskillPhaseShift_741 = MobSkillId(741)
val mskillGaeaStreamLambda_742 = MobSkillId(742)
val mskillUranosCascadeLambda_743 = MobSkillId(743)
val mskillCronosSlingLambda_744 = MobSkillId(744)
val mskillPhaseShift_745 = MobSkillId(745)
val mskillOmegaJavelin_750 = MobSkillId(750)
val mskillMightyStrikes_752 = MobSkillId(752)
val mskillHundredFists_753 = MobSkillId(753)
val mskillBenediction_754 = MobSkillId(754)
val mskillManafont_755 = MobSkillId(755)
val mskillChainspell_756 = MobSkillId(756)
val mskillPerfectDodge_757 = MobSkillId(757)
val mskillInvincible_758 = MobSkillId(758)
val mskillBloodWeapon_759 = MobSkillId(759)
val mskillFamiliar_760 = MobSkillId(760)
val mskillCallBeast_761 = MobSkillId(761)
val mskillSoulVoice_762 = MobSkillId(762)
val mskillEagleEyeShot_763 = MobSkillId(763)
val mskillMeikyoShisui_764 = MobSkillId(764)
val mskillMijinGakure_765 = MobSkillId(765)
val mskillCallWyvern_766 = MobSkillId(766)
val mskillAstralFlow_767 = MobSkillId(767)
val mskillWarpOut_768 = MobSkillId(768)
val mskillWarpIn_769 = MobSkillId(769)
val mskillArborStorm_770 = MobSkillId(770)
val mskillCombo_771 = MobSkillId(771)
val mskillTackle_772 = MobSkillId(772)
val mskillOneIlmPunch_773 = MobSkillId(773)
val mskillBackhandBlow_774 = MobSkillId(774)
val mskillSpinningAttack_775 = MobSkillId(775)
val mskillHowlingFist_776 = MobSkillId(776)
val mskillDragonKick_777 = MobSkillId(777)
val mskillAsuranFists_778 = MobSkillId(778)
val mskillHeavyStrike_779 = MobSkillId(779)
val mskillMaatsBash_780 = MobSkillId(780)
val mskillFireball1_781 = MobSkillId(781)
val mskillFireball2_782 = MobSkillId(782)
val mskillHurricaneWing_783 = MobSkillId(783)
val mskillSpikeFlail_784 = MobSkillId(784)
val mskillDragonBreath_785 = MobSkillId(785)
val mskillLandingtothesurface_786 = MobSkillId(786)
val mskillGiantfireballFlying_787 = MobSkillId(787)
val mskillGreatwinggustFlying_788 = MobSkillId(788)
val mskillAbsoluteTerror_789 = MobSkillId(789)
val mskillHorridRoar_790 = MobSkillId(790)
val mskillTortoiseSong_791 = MobSkillId(791)
val mskillHeadButt_792 = MobSkillId(792)
val mskillTortoiseStomp_793 = MobSkillId(793)
val mskillHardenShell_794 = MobSkillId(794)
val mskillEarthBreath_795 = MobSkillId(795)
val mskillAquaBreath_796 = MobSkillId(796)
val mskillSabotenderDustdevil_798 = MobSkillId(798)
val mskillSabotenderDuststop_799 = MobSkillId(799)
val mskillFanaticDance_800 = MobSkillId(800)
val mskillAerialWheel_801 = MobSkillId(801)
val mskillShoulderAttack_802 = MobSkillId(802)
val mskillSlamDunk_803 = MobSkillId(803)
val mskillArmBlock_804 = MobSkillId(804)
val mskillBattleDance_805 = MobSkillId(805)
val mskillHowl_806 = MobSkillId(806)
val mskillBow_807 = MobSkillId(807)
val mskillJump_808 = MobSkillId(808)
val mskillEagleEyeShot_809 = MobSkillId(809)
val mskillFanaticDance_810 = MobSkillId(810)
val mskillDoom_811 = MobSkillId(811)
val mskillFeatherStorm_812 = MobSkillId(812)
val mskillDoubleKick_813 = MobSkillId(813)
val mskillParry_814 = MobSkillId(814)
val mskillSweep_815 = MobSkillId(815)
val mskillHowl_816 = MobSkillId(816)
val mskillDoom_817 = MobSkillId(817)
val mskillTheWrathofGuDha_818 = MobSkillId(818)
val mskillOreToss_819 = MobSkillId(819)
val mskillHeadButt_820 = MobSkillId(820)
val mskillShellBash_821 = MobSkillId(821)
val mskillShellGuard_822 = MobSkillId(822)
val mskillHowl_823 = MobSkillId(823)
val mskillTheWrathofGuDha_824 = MobSkillId(824)
val mskillFrypan_825 = MobSkillId(825)
val mskillSmokebomb_826 = MobSkillId(826)
val mskillSmokebomb_827 = MobSkillId(827)
val mskillCrispyCandle_828 = MobSkillId(828)
val mskillCrispyCandle_829 = MobSkillId(829)
val mskillParalysisShower_830 = MobSkillId(830)
val mskillParalysisShower_831 = MobSkillId(831)
val mskillGoblinRush_832 = MobSkillId(832)
val mskillBombToss_833 = MobSkillId(833)
val mskillBombToss_834 = MobSkillId(834)
val mskillEagleEyeShot_835 = MobSkillId(835)
val mskillFrypan_836 = MobSkillId(836)
val mskillSmokebomb_837 = MobSkillId(837)
val mskillSmokebomb_838 = MobSkillId(838)
val mskillCrispyCandle_839 = MobSkillId(839)
val mskillCrispyCandle_840 = MobSkillId(840)
val mskillParalysisShower_841 = MobSkillId(841)
val mskillParalysisShower_842 = MobSkillId(842)
val mskillGoblinDice_843 = MobSkillId(843)
val mskillGoblinDice_844 = MobSkillId(844)
val mskillGoblinDice_845 = MobSkillId(845)
val mskillGoblinDice_846 = MobSkillId(846)
val mskillGoblinDice_847 = MobSkillId(847)
val mskillGoblinDice_848 = MobSkillId(848)
val mskillGoblinDice_849 = MobSkillId(849)
val mskillGoblinDice_850 = MobSkillId(850)
val mskillGoblinDice_851 = MobSkillId(851)
val mskillGoblinDice_852 = MobSkillId(852)
val mskillGoblinDice_853 = MobSkillId(853)
val mskillSeismostomp_854 = MobSkillId(854)
val mskillNumbingGlare_855 = MobSkillId(855)
val mskillSeismostomp_856 = MobSkillId(856)
val mskillTormentfulGlare_857 = MobSkillId(857)
val mskillSeismostomp_858 = MobSkillId(858)
val mskillTorpidGlare_859 = MobSkillId(859)
val mskillSeismostomp_860 = MobSkillId(860)
val mskillLeadBreath_861 = MobSkillId(861)
val mskillLeadBreath_862 = MobSkillId(862)
val mskillFragBomb_863 = MobSkillId(863)
val mskill10000Needles_864 = MobSkillId(864)
val mskillEagleEyeShot_865 = MobSkillId(865)
val mskillEagleEyeShot_866 = MobSkillId(866)
val mskillOreToss_867 = MobSkillId(867)
val mskillDynamicImplosion_871 = MobSkillId(871)
val mskillTransfusion_872 = MobSkillId(872)
val mskillManastrom_873 = MobSkillId(873)
val mskillDynamicAssault_874 = MobSkillId(874)
val mskillViolentRupture_875 = MobSkillId(875)
val mskillOblivionSmash_876 = MobSkillId(876)
val mskillOblivionSmash_877 = MobSkillId(877)
val mskillTeraSlash_878 = MobSkillId(878)
val mskillTeraSlash_879 = MobSkillId(879)
val mskillBlindeye_880 = MobSkillId(880)
val mskillEyesOnMe_881 = MobSkillId(881)
val mskillHypnosis_882 = MobSkillId(882)
val mskillMindBreak_883 = MobSkillId(883)
val mskillBindingWave_884 = MobSkillId(884)
val mskillAiryShield_885 = MobSkillId(885)
val mskillPetCharm_886 = MobSkillId(886)
val mskillMagicBarrier_887 = MobSkillId(887)
val mskillLevel5Petrify_888 = MobSkillId(888)
val mskillSoulDrain_889 = MobSkillId(889)
val mskillHecatombWave_890 = MobSkillId(890)
val mskillDemonicHowl_891 = MobSkillId(891)
val mskillCondemnation_892 = MobSkillId(892)
val mskillQuadrastrike_893 = MobSkillId(893)
val mskillQuadrastrike_894 = MobSkillId(894)
val mskillEagleEyeShot_895 = MobSkillId(895)
val mskillHecatombWave_896 = MobSkillId(896)
val mskillEagleEyeShot_897 = MobSkillId(897)
val mskillRangedAttack_898 = MobSkillId(898)
val mskillSubsonics_899 = MobSkillId(899)
val mskillMarrowDrain_900 = MobSkillId(900)
val mskillSlipstream_901 = MobSkillId(901)
val mskillTurbulence_902 = MobSkillId(902)
val mskillBroadsideBarrage_903 = MobSkillId(903)
val mskillBlindSideBarrage_904 = MobSkillId(904)
val mskillDamnationDive_905 = MobSkillId(905)
val mskillInferno_906 = MobSkillId(906)
val mskillEarthenFury_907 = MobSkillId(907)
val mskillTidalWave_908 = MobSkillId(908)
val mskillAerialBlast_909 = MobSkillId(909)
val mskillDiamondDust_910 = MobSkillId(910)
val mskillJudgmentBolt_911 = MobSkillId(911)
val mskillFlameBreath_912 = MobSkillId(912)
val mskillPoisonBreath_913 = MobSkillId(913)
val mskillWindBreath_914 = MobSkillId(914)
val mskillBodySlam_915 = MobSkillId(915)
val mskillHeavyStomp_916 = MobSkillId(916)
val mskillChaosBlade_917 = MobSkillId(917)
val mskillPetroEyes_918 = MobSkillId(918)
val mskillVoidsong_919 = MobSkillId(919)
val mskillThornsong_920 = MobSkillId(920)
val mskillLodesong_921 = MobSkillId(921)
val mskillFlameBreath_922 = MobSkillId(922)
val mskillPoisonBreath_923 = MobSkillId(923)
val mskillWindBreath_924 = MobSkillId(924)
val mskillBodySlam_925 = MobSkillId(925)
val mskillHeavyStomp_926 = MobSkillId(926)
val mskillChaosBlade_927 = MobSkillId(927)
val mskillPetroEyes_928 = MobSkillId(928)
val mskillVoidsong_929 = MobSkillId(929)
val mskillThornsong_930 = MobSkillId(930)
val mskillLodesong_931 = MobSkillId(931)
val mskillFinalHeaven_932 = MobSkillId(932)
val mskillMercyStroke_933 = MobSkillId(933)
val mskillKnightsofRound_934 = MobSkillId(934)
val mskillScourge_935 = MobSkillId(935)
val mskillOnslaught_936 = MobSkillId(936)
val mskillMetatronTorment_937 = MobSkillId(937)
val mskillCatastrophe_938 = MobSkillId(938)
val mskillGeirskogul_939 = MobSkillId(939)
val mskillBladeMetsu_940 = MobSkillId(940)
val mskillTachiKaiten_941 = MobSkillId(941)
val mskillRandgrith_942 = MobSkillId(942)
val mskillGateofTartarus_943 = MobSkillId(943)
val mskillNamas_944 = MobSkillId(944)
val mskillCoronach_945 = MobSkillId(945)
val mskillRangedAttack_946 = MobSkillId(946)
val mskillRangedAttack_947 = MobSkillId(947)
val mskillRangedAttack_948 = MobSkillId(948)
val mskillRangedAttack_949 = MobSkillId(949)
val mskillRangedAttack_950 = MobSkillId(950)
val mskillArrowSquall_951 = MobSkillId(951)
val mskillArrowSquall_952 = MobSkillId(952)
val mskillRangedAttack_953 = MobSkillId(953)
val mskillRangedAttack_954 = MobSkillId(954)
val mskillRangedAttack_955 = MobSkillId(955)
val mskillRangedAttack_956 = MobSkillId(956)
val mskillRangedAttack_957 = MobSkillId(957)
val mskillRangedAttack_958 = MobSkillId(958)
val mskillInfernalRoulette_959 = MobSkillId(959)
val mskillInfernalRoulette_960 = MobSkillId(960)
val mskillEmptyCutter_961 = MobSkillId(961)
val mskillVacuousOsculation_962 = MobSkillId(962)
val mskillHexagonBelt_963 = MobSkillId(963)
val mskillAuroralDrape_964 = MobSkillId(964)
val mskillMemoryofFire_965 = MobSkillId(965)
val mskillMemoryofIce_966 = MobSkillId(966)
val mskillMemoryofWind_967 = MobSkillId(967)
val mskillMemoryofLight_968 = MobSkillId(968)
val mskillMemoryofEarth_969 = MobSkillId(969)
val mskillMemoryofLightning_970 = MobSkillId(970)
val mskillMemoryofWater_971 = MobSkillId(971)
val mskillMemoryofDark_972 = MobSkillId(972)
val mskillBrainSpike_973 = MobSkillId(973)
val mskillEmptyThrash_974 = MobSkillId(974)
val mskillPromyvionBrume_975 = MobSkillId(975)
val mskillMurk_976 = MobSkillId(976)
val mskillMaterialFend_977 = MobSkillId(977)
val mskillCarousel_978 = MobSkillId(978)
val mskillPilePitch_979 = MobSkillId(979)
val mskillGuidedMissile_980 = MobSkillId(980)
val mskillHyperPulse_981 = MobSkillId(981)
val mskillTargetAnalysis_982 = MobSkillId(982)
val mskillDischarger_983 = MobSkillId(983)
val mskillIonEfflux_984 = MobSkillId(984)
val mskillRearLasers_985 = MobSkillId(985)
val mskillEmptyCutter_986 = MobSkillId(986)
val mskillNegativeWhirl_987 = MobSkillId(987)
val mskillStygianVapor_988 = MobSkillId(988)
val mskillWindsofPromyvion_989 = MobSkillId(989)
val mskillSpiritAbsorption_990 = MobSkillId(990)
val mskillBinaryAbsorption_991 = MobSkillId(991)
val mskillTrinaryAbsorption_992 = MobSkillId(992)
val mskillSpiritTap_993 = MobSkillId(993)
val mskillBinaryTap_994 = MobSkillId(994)
val mskillTrinaryTap_995 = MobSkillId(995)
val mskillShadowSpread_996 = MobSkillId(996)
val mskillVanityStrike_997 = MobSkillId(997)
val mskillWanion_998 = MobSkillId(998)
val mskillOccultation_999 = MobSkillId(999)
val mskillEmptyCrush_1000 = MobSkillId(1000)
val mskillSpecialAttack_1001 = MobSkillId(1001)
val mskillLamentation_1002 = MobSkillId(1002)
val mskillWireCutter_1003 = MobSkillId(1003)
val mskillAntimatter_1004 = MobSkillId(1004)
val mskillEqualizer_1005 = MobSkillId(1005)
val mskillFlameThrower_1006 = MobSkillId(1006)
val mskillCryojet_1007 = MobSkillId(1007)
val mskillTurbofan_1008 = MobSkillId(1008)
val mskillSmokeDischarger_1009 = MobSkillId(1009)
val mskillHighTensionDischarger_1010 = MobSkillId(1010)
val mskillHydroCannon_1011 = MobSkillId(1011)
val mskillNuclearWaste_1012 = MobSkillId(1012)
val mskillChemicalBomb_1013 = MobSkillId(1013)
val mskillParticleShield_1014 = MobSkillId(1014)
val mskillEmptyCutter_1015 = MobSkillId(1015)
val mskillNegativeWhirl_1016 = MobSkillId(1016)
val mskillWindsofPromyvion_1017 = MobSkillId(1017)
val mskillImpalement_1018 = MobSkillId(1018)
val mskillEmptyThrash_1019 = MobSkillId(1019)
val mskillPromyvionBrume_1020 = MobSkillId(1020)
val mskillInfernoBlast_1021 = MobSkillId(1021)
val mskillInfernoBlast_1022 = MobSkillId(1022)
val mskillTebbadWing_1023 = MobSkillId(1023)
val mskillSpikeFlail_1024 = MobSkillId(1024)
val mskillFieryBreath_1025 = MobSkillId(1025)
val mskillTouchdown_1026 = MobSkillId(1026)
val mskillInfernoBlast_1027 = MobSkillId(1027)
val mskillTebbadWing_1028 = MobSkillId(1028)
val mskillAbsoluteTerror_1029 = MobSkillId(1029)
val mskillHorridRoar_1030 = MobSkillId(1030)
val mskillSleetBlast_1031 = MobSkillId(1031)
val mskillSleetBlast_1032 = MobSkillId(1032)
val mskillGregaleWing_1033 = MobSkillId(1033)
val mskillSpikeFlail_1034 = MobSkillId(1034)
val mskillGlacialBreath_1035 = MobSkillId(1035)
val mskillTouchdown_1036 = MobSkillId(1036)
val mskillSleetBlast_1037 = MobSkillId(1037)
val mskillGregaleWing_1038 = MobSkillId(1038)
val mskillAbsoluteTerror_1039 = MobSkillId(1039)
val mskillHorridRoar_1040 = MobSkillId(1040)
val mskillOcherBlast_1041 = MobSkillId(1041)
val mskillOcherBlast_1042 = MobSkillId(1042)
val mskillTyphoonWing_1043 = MobSkillId(1043)
val mskillSpikeFlail_1044 = MobSkillId(1044)
val mskillGeoticBreath_1045 = MobSkillId(1045)
val mskillTouchdown_1046 = MobSkillId(1046)
val mskillOcherBlast_1047 = MobSkillId(1047)
val mskillBaiWing_1048 = MobSkillId(1048)
val mskillAbsoluteTerror_1049 = MobSkillId(1049)
val mskillHorridRoar_1050 = MobSkillId(1050)
val mskillDarkMatterBlast_1051 = MobSkillId(1051)
val mskillDarkMatterBlast_1052 = MobSkillId(1052)
val mskillCycloneWing_1053 = MobSkillId(1053)
val mskillSpikeFlail_1054 = MobSkillId(1054)
val mskillSableBreath_1055 = MobSkillId(1055)
val mskillTouchdown_1056 = MobSkillId(1056)
val mskillDarkMatterBlast_1057 = MobSkillId(1057)
val mskillCycloneWing_1058 = MobSkillId(1058)
val mskillAbsoluteTerror_1059 = MobSkillId(1059)
val mskillHorridRoar_1060 = MobSkillId(1060)
val mskillMucusSpread_1061 = MobSkillId(1061)
val mskillWZ_SLIME_04_1062 = MobSkillId(1062)
val mskillEpoxySpread_1063 = MobSkillId(1063)
val mskillWZ_EYES_04_1064 = MobSkillId(1064)
val mskillWZ_CRAWL_03_1065 = MobSkillId(1065)
val mskillGerjisGrip_1066 = MobSkillId(1066)
val mskillWZ_BEES_04_1067 = MobSkillId(1067)
val mskillDebilitatingDrone_1068 = MobSkillId(1068)
val mskillWZ_TRSAP_03_1069 = MobSkillId(1069)
val mskillFinalRetribution_1070 = MobSkillId(1070)
val mskillEagleEyeShot_1071 = MobSkillId(1071)
val mskillInkJet_1072 = MobSkillId(1072)
val mskillGalaMacabre_1073 = MobSkillId(1073)
val mskillHoofVolley_1074 = MobSkillId(1074)
val mskillCounterstance_1075 = MobSkillId(1075)
val mskillExtremelyBadBreath_1076 = MobSkillId(1076)
val mskillContagionTransfer_1077 = MobSkillId(1077)
val mskillContamination_1078 = MobSkillId(1078)
val mskillToxicPick_1079 = MobSkillId(1079)
val mskillFrenziedRage_1080 = MobSkillId(1080)
val mskillCharm_1081 = MobSkillId(1081)
val mskillInfernalPestilence_1082 = MobSkillId(1082)
val mskillBane_1083 = MobSkillId(1083)
val mskillCrossthrash_1084 = MobSkillId(1084)
val mskillKnifeEdgeCircle_1085 = MobSkillId(1085)
val mskillTrainFall_1086 = MobSkillId(1086)
val mskill_1087 = MobSkillId(1087)
val mskill_1088 = MobSkillId(1088)
val mskill_1089 = MobSkillId(1089)
val mskill_1090 = MobSkillId(1090)
val mskillDualStrike_1091 = MobSkillId(1091)
val mskillSiphonDischarge_1092 = MobSkillId(1092)
val mskillMantlePierce_1093 = MobSkillId(1093)
val mskillInkCloud_1094 = MobSkillId(1094)
val mskillMolluscousMutation_1095 = MobSkillId(1095)
val mskillSalineCoat_1096 = MobSkillId(1096)
val mskillAerialCollision_1097 = MobSkillId(1097)
val mskillVaporSpray_1098 = MobSkillId(1098)
val mskillSpineLash_1099 = MobSkillId(1099)
val mskillVoicelessStorm_1100 = MobSkillId(1100)
val mskillTidalDive_1101 = MobSkillId(1101)
val mskillPlasmaCharge_1102 = MobSkillId(1102)
val mskillChthonianRay_1103 = MobSkillId(1103)
val mskillApocalypticRay_1104 = MobSkillId(1104)
val mskillViscidSecretion_1105 = MobSkillId(1105)
val mskillWildGinseng_1106 = MobSkillId(1106)
val mskillHungryCrunch_1107 = MobSkillId(1107)
val mskillMightySnort_1108 = MobSkillId(1108)
val mskillTailThrust_1109 = MobSkillId(1109)
val mskillTemporalShift_1110 = MobSkillId(1110)
val mskillSinuateRush_1111 = MobSkillId(1111)
val mskillRapidMolt_1112 = MobSkillId(1112)
val mskillIchorStream_1113 = MobSkillId(1113)
val mskillVitriolicBarrage_1114 = MobSkillId(1114)
val mskillPrimalDrill_1115 = MobSkillId(1115)
val mskillConcussiveOscillation_1116 = MobSkillId(1116)
val mskillIonShower_1117 = MobSkillId(1117)
val mskillTorrentialTorment_1118 = MobSkillId(1118)
val mskillAsthenicFog_1119 = MobSkillId(1119)
val mskillLuminousDrape_1120 = MobSkillId(1120)
val mskillFluorescence_1121 = MobSkillId(1121)
val mskillWingThrust_1122 = MobSkillId(1122)
val mskillAuroralWind_1123 = MobSkillId(1123)
val mskillImpactStream_1124 = MobSkillId(1124)
val mskillDepuration_1125 = MobSkillId(1125)
val mskillCrystallineCocoon_1126 = MobSkillId(1126)
val mskillGlacierSplitter_1127 = MobSkillId(1127)
val mskillDisseverment_1128 = MobSkillId(1128)
val mskillBioticBoomerang_1129 = MobSkillId(1129)
val mskillMedusaJavelin_1130 = MobSkillId(1130)
val mskillSideswipe_1131 = MobSkillId(1131)
val mskill_1132 = MobSkillId(1132)
val mskillEagleEyeShot_1133 = MobSkillId(1133)
val mskillAmatsuTorimai_1134 = MobSkillId(1134)
val mskillAmatsuKazakiri_1135 = MobSkillId(1135)
val mskillAmatsuYukiarashi_1136 = MobSkillId(1136)
val mskillAmatsuTsukioboro_1137 = MobSkillId(1137)
val mskillAmatsuHanaikusa_1138 = MobSkillId(1138)
val mskillAmatsuTsukikage_1139 = MobSkillId(1139)
val mskill_1140 = MobSkillId(1140)
val mskillOisoya_1141 = MobSkillId(1141)
val mskill_1142 = MobSkillId(1142)
val mskill_1143 = MobSkillId(1143)
val mskill_1144 = MobSkillId(1144)
val mskillSoulAccretion_1145 = MobSkillId(1145)
val mskill_1146 = MobSkillId(1146)
val mskillExplosiveImpulse_1147 = MobSkillId(1147)
val mskillOcherBlast_1148 = MobSkillId(1148)
val mskillOcherBlast_1149 = MobSkillId(1149)
val mskillTyphoonWing_1150 = MobSkillId(1150)
val mskillSpikeFlail_1151 = MobSkillId(1151)
val mskillGeoticBreath_1152 = MobSkillId(1152)
val mskillTouchdown_1153 = MobSkillId(1153)
val mskillOcherBlast_1154 = MobSkillId(1154)
val mskillBaiWing_1155 = MobSkillId(1155)
val mskillAbsoluteTerror_1156 = MobSkillId(1156)
val mskillHorridRoar_1157 = MobSkillId(1157)
val mskillMarionetteDice_1158 = MobSkillId(1158)
val mskillMarionetteDice_1159 = MobSkillId(1159)
val mskillMarionetteDice_1160 = MobSkillId(1160)
val mskillMarionetteDice_1161 = MobSkillId(1161)
val mskillMarionetteDice_1162 = MobSkillId(1162)
val mskillMarionetteDice_1163 = MobSkillId(1163)
val mskillMarionetteDice_1164 = MobSkillId(1164)
val mskillMarionetteDice_1165 = MobSkillId(1165)
val mskillMarionetteDice_1166 = MobSkillId(1166)
val mskillMarionetteDice_1167 = MobSkillId(1167)
val mskillMarionetteDice_1168 = MobSkillId(1168)
val mskillMarionetteDice_1169 = MobSkillId(1169)
val mskillMarionetteDice_1170 = MobSkillId(1170)
val mskillMarionetteDice_1171 = MobSkillId(1171)
val mskillWarcry_1172 = MobSkillId(1172)
val mskillCounterstance_1173 = MobSkillId(1173)
val mskillSteal_1174 = MobSkillId(1174)
val mskillShieldBash_1175 = MobSkillId(1175)
val mskillWeaponBash_1176 = MobSkillId(1176)
val mskillSic_1177 = MobSkillId(1177)
val mskillBarrage_1178 = MobSkillId(1178)
val mskill_1179 = MobSkillId(1179)
val mskillMeditate_1180 = MobSkillId(1180)
val mskillJump_1181 = MobSkillId(1181)
val mskillBloodPact_1182 = MobSkillId(1182)
val mskillAetheralToxin_1183 = MobSkillId(1183)
val mskillEdgeofDeath_1184 = MobSkillId(1184)
val mskillActinicBurst_1185 = MobSkillId(1185)
val mskillCoreMeltdown_1186 = MobSkillId(1186)
val mskillHexidiscs_1187 = MobSkillId(1187)
val mskillVorpalBlade_1188 = MobSkillId(1188)
val mskillDamnationDive_1189 = MobSkillId(1189)
val mskillSickleSlash_1190 = MobSkillId(1190)
val mskillVerticalCleave_1191 = MobSkillId(1191)
val mskillEfflorescentFoetor_1192 = MobSkillId(1192)
val mskillStuporSpores_1193 = MobSkillId(1193)
val mskillViscidNectar_1194 = MobSkillId(1194)
val mskillMorningGlory_1195 = MobSkillId(1195)
val mskillAxialBloom_1196 = MobSkillId(1196)
val mskillNutrientAbsorption_1197 = MobSkillId(1197)
val mskillPalsyPollen_1198 = MobSkillId(1198)
val mskillToxicSpit_1199 = MobSkillId(1199)
val mskillFilamentedHold_1200 = MobSkillId(1200)
val mskillMarionetteDice_1201 = MobSkillId(1201)
val mskillSelfDestruct_1202 = MobSkillId(1202)
val mskillSelfDestruct_1203 = MobSkillId(1203)
val mskill_1204 = MobSkillId(1204)
val mskillShieldBash_1205 = MobSkillId(1205)
val mskillShieldBash_1206 = MobSkillId(1206)
val mskillReactorCool_1207 = MobSkillId(1207)
val mskill_1208 = MobSkillId(1208)
val mskillOpticInduration_1209 = MobSkillId(1209)
val mskillStaticFilament_1210 = MobSkillId(1210)
val mskillDecayedFilament_1211 = MobSkillId(1211)
val mskillReactorOverheat_1212 = MobSkillId(1212)
val mskillReactorOverload_1213 = MobSkillId(1213)
val mskillSelfDestruct_1214 = MobSkillId(1214)
val mskillCattlepult_1215 = MobSkillId(1215)
val mskillCattlepult_1216 = MobSkillId(1216)
val mskillCattlepult_1217 = MobSkillId(1217)
val mskillBullRush_1219 = MobSkillId(1219)
val mskillRedLotusBlade_1220 = MobSkillId(1220)
val mskillFlatBlade_1221 = MobSkillId(1221)
val mskillSavageBlade_1222 = MobSkillId(1222)
val mskillRoyalBash_1223 = MobSkillId(1223)
val mskillRoyalSavior_1224 = MobSkillId(1224)
val mskillRedLotusBlade_1225 = MobSkillId(1225)
val mskillSpiritsWithin_1226 = MobSkillId(1226)
val mskillVorpalBlade_1227 = MobSkillId(1227)
val mskillBerserkRuf_1228 = MobSkillId(1228)
val mskillHundredFists_1229 = MobSkillId(1229)
val mskillBenediction_1230 = MobSkillId(1230)
val mskillPrisheItem1_1231 = MobSkillId(1231)
val mskillPrisheItem2_1232 = MobSkillId(1232)
val mskillNullifyingDropkick_1233 = MobSkillId(1233)
val mskillAuroralUppercut_1234 = MobSkillId(1234)
val mskillChainsofApathy_1235 = MobSkillId(1235)
val mskillChainsofArrogance_1236 = MobSkillId(1236)
val mskillChainsofCowardice_1237 = MobSkillId(1237)
val mskillChainsofRage_1238 = MobSkillId(1238)
val mskillChainsofEnvy_1239 = MobSkillId(1239)
val mskillMalevolentBlessing_1240 = MobSkillId(1240)
val mskillPestilentPenance_1241 = MobSkillId(1241)
val mskillEmptySalvation_1242 = MobSkillId(1242)
val mskillInfernalDeliverance_1243 = MobSkillId(1243)
val mskillMalevolentBlessing_1244 = MobSkillId(1244)
val mskillPestilentPenance_1245 = MobSkillId(1245)
val mskillEmptySalvation_1246 = MobSkillId(1246)
val mskillInfernalDeliverance_1247 = MobSkillId(1247)
val mskillWheelofImpregnability_1248 = MobSkillId(1248)
val mskillBastionofTwilight_1249 = MobSkillId(1249)
val mskillWindsofOblivion_1250 = MobSkillId(1250)
val mskillSealofQuiescence_1251 = MobSkillId(1251)
val mskillLuminousLance_1252 = MobSkillId(1252)
val mskillRejuvenation_1253 = MobSkillId(1253)
val mskillRevelation_1254 = MobSkillId(1254)
val mskillSlamDunk_1255 = MobSkillId(1255)
val mskillHowl_1256 = MobSkillId(1256)
val mskillOreToss_1257 = MobSkillId(1257)
val mskillHowl_1258 = MobSkillId(1258)
val mskillDoubleKick_1259 = MobSkillId(1259)
val mskillHowl_1260 = MobSkillId(1260)
val mskillGoblinRush_1261 = MobSkillId(1261)
val mskillGoblinDice_1262 = MobSkillId(1262)
val mskillProvoke_1263 = MobSkillId(1263)
val mskillHowlingMoon_1264 = MobSkillId(1264)
val mskillArmorBuster_1265 = MobSkillId(1265)
val mskillEnergyScreen_1266 = MobSkillId(1266)
val mskillManaScreen_1267 = MobSkillId(1267)
val mskillDissipation_1268 = MobSkillId(1268)
val mskillGuidedMissileII_1269 = MobSkillId(1269)
val mskillColossalBlow_1270 = MobSkillId(1270)
val mskillLaserShower_1271 = MobSkillId(1271)
val mskillFloodlight_1272 = MobSkillId(1272)
val mskillHyperPulse_1273 = MobSkillId(1273)
val mskillStunCannon_1274 = MobSkillId(1274)
val mskillWZ_RECOVER_ALL_1275 = MobSkillId(1275)
val mskillPodEjection_1276 = MobSkillId(1276)
val mskillPilePitch_1277 = MobSkillId(1277)
val mskillGuidedMissile_1278 = MobSkillId(1278)
val mskillHyperPulse_1279 = MobSkillId(1279)
val mskillTargetAnalysis_1280 = MobSkillId(1280)
val mskillDischarger_1281 = MobSkillId(1281)
val mskillIonEfflux_1282 = MobSkillId(1282)
val mskillRearLasers_1283 = MobSkillId(1283)
val mskillCitadelBuster_1284 = MobSkillId(1284)
val mskillBlightedGloom_1285 = MobSkillId(1285)
val mskillTrample_1286 = MobSkillId(1286)
val mskillTempestWing_1287 = MobSkillId(1287)
val mskillTouchdown_1288 = MobSkillId(1288)
val mskillSweepingFlail_1289 = MobSkillId(1289)
val mskillProdigiousSpike_1290 = MobSkillId(1290)
val mskillImpulsion_1291 = MobSkillId(1291)
val mskillAbsoluteTerror_1292 = MobSkillId(1292)
val mskillHorribleRoar_1293 = MobSkillId(1293)
val mskill_1294 = MobSkillId(1294)
val mskillMegaflare_1295 = MobSkillId(1295)
val mskillGigaflare_1296 = MobSkillId(1296)
val mskillTeraflare_1297 = MobSkillId(1297)
val mskillCamisado_1298 = MobSkillId(1298)
val mskillBlessedRadiance_1299 = MobSkillId(1299)
val mskillRegeneration_1300 = MobSkillId(1300)
val mskillEagleEyeShot_1301 = MobSkillId(1301)
val mskillSmiteofFury_1302 = MobSkillId(1302)
val mskillFlurryofRage_1303 = MobSkillId(1303)
val mskillWhispersofIre_1304 = MobSkillId(1304)
val mskillSonicWave_1305 = MobSkillId(1305)
val mskillStomping_1306 = MobSkillId(1306)
val mskillColdStare_1307 = MobSkillId(1307)
val mskillWhistle_1308 = MobSkillId(1308)
val mskillBerserk_1309 = MobSkillId(1309)
val mskillHealingBreeze_1310 = MobSkillId(1310)
val mskillFootKick_1311 = MobSkillId(1311)
val mskillDustCloud_1312 = MobSkillId(1312)
val mskillWhirlClaws_1313 = MobSkillId(1313)
val mskillWildCarrot_1314 = MobSkillId(1314)
val mskillGasShell_1315 = MobSkillId(1315)
val mskillVenomShell_1316 = MobSkillId(1316)
val mskillPalsynyxis_1317 = MobSkillId(1317)
val mskillPainfulWhip_1318 = MobSkillId(1318)
val mskillSuctorialTentacle_1319 = MobSkillId(1319)
val mskillHelldive_1320 = MobSkillId(1320)
val mskillWingCutter_1321 = MobSkillId(1321)
val mskillBroadsideBarrage_1322 = MobSkillId(1322)
val mskillBlindSideBarrage_1323 = MobSkillId(1323)
val mskillDamnationDive_1324 = MobSkillId(1324)
val mskillStickyThread_1325 = MobSkillId(1325)
val mskillPoisonBreath_1326 = MobSkillId(1326)
val mskillCocoon_1327 = MobSkillId(1327)
val mskillHeadButt_1328 = MobSkillId(1328)
val mskillDreamFlower_1329 = MobSkillId(1329)
val mskillWildOats_1330 = MobSkillId(1330)
val mskillLeafDagger_1331 = MobSkillId(1331)
val mskillScream_1332 = MobSkillId(1332)
val mskillBubbleShower_1333 = MobSkillId(1333)
val mskillBubbleCurtain_1334 = MobSkillId(1334)
val mskillBigScissors_1335 = MobSkillId(1335)
val mskillScissorGuard_1336 = MobSkillId(1336)
val mskillMetallicBody_1337 = MobSkillId(1337)
val mskillToxicSpit_1338 = MobSkillId(1338)
val mskillGeistWall_1339 = MobSkillId(1339)
val mskillNumbingNoise_1340 = MobSkillId(1340)
val mskillNimbleSnap_1341 = MobSkillId(1341)
val mskillCyclotail_1342 = MobSkillId(1342)
val mskillHammerBeak_1343 = MobSkillId(1343)
val mskillPoisonPick_1344 = MobSkillId(1344)
val mskillSoundVacuum_1345 = MobSkillId(1345)
val mskillSoundBlast_1346 = MobSkillId(1346)
val mskillBalefulGaze_1347 = MobSkillId(1347)
val mskillMiasmicBreath_1348 = MobSkillId(1348)
val mskillMiasmicBreath_1349 = MobSkillId(1349)
val mskillFragrantBreath_1350 = MobSkillId(1350)
val mskillFragrantBreath_1351 = MobSkillId(1351)
val mskillPutridBreath_1352 = MobSkillId(1352)
val mskillPutridBreath_1353 = MobSkillId(1353)
val mskillExtremelyBadBreath_1354 = MobSkillId(1354)
val mskillVampiricLash_1355 = MobSkillId(1355)
val mskillGougingBranch_1356 = MobSkillId(1356)
val mskillGloeosuccus_1357 = MobSkillId(1357)
val mskillGloeosuccus_1358 = MobSkillId(1358)
val mskillSoporific_1359 = MobSkillId(1359)
val mskillPalsyPollen_1360 = MobSkillId(1360)
val mskillBlow_1361 = MobSkillId(1361)
val mskillUppercut_1362 = MobSkillId(1362)
val mskillAttractant_1363 = MobSkillId(1363)
val mskillMephiticSpore_1364 = MobSkillId(1364)
val mskillFrogkick_1365 = MobSkillId(1365)
val mskillCursedSphere_1366 = MobSkillId(1366)
val mskillVenom_1367 = MobSkillId(1367)
val mskillDebilitatingDrone_1368 = MobSkillId(1368)
val mskill2000Needles_1369 = MobSkillId(1369)
val mskill4000Needles_1370 = MobSkillId(1370)
val mskillNeedleshot_1371 = MobSkillId(1371)
val mskillHeatBreath_1372 = MobSkillId(1372)
val mskillRiddle_1373 = MobSkillId(1373)
val mskillGreatSandstorm_1374 = MobSkillId(1374)
val mskillGreatWhirlwind_1375 = MobSkillId(1375)
val mskillChokeBreath_1376 = MobSkillId(1376)
val mskillSheepBleat_1377 = MobSkillId(1377)
val mskillSheepSong_1378 = MobSkillId(1378)
val mskillSheepCharge_1379 = MobSkillId(1379)
val mskillTrebuchet_1380 = MobSkillId(1380)
val mskillPowerAttack_1381 = MobSkillId(1381)
val mskillLightningRoar_1382 = MobSkillId(1382)
val mskillImpactRoar_1383 = MobSkillId(1383)
val mskillGrandSlam_1384 = MobSkillId(1384)
val mskillEagleEyeShot_1385 = MobSkillId(1385)
val mskillWhirlofRage_1386 = MobSkillId(1386)
val mskillSmiteofRage_1387 = MobSkillId(1387)
val mskillHypothermalCombustion_1388 = MobSkillId(1388)
val mskillFreezeRush_1389 = MobSkillId(1389)
val mskillColdWave_1390 = MobSkillId(1390)
val mskillBerserk_1391 = MobSkillId(1391)
val mskillCrystalShield_1392 = MobSkillId(1392)
val mskillHeavyStrike_1393 = MobSkillId(1393)
val mskillIceBreak_1394 = MobSkillId(1394)
val mskillThunderBreak_1395 = MobSkillId(1395)
val mskillCrystalRain_1396 = MobSkillId(1396)
val mskillCrystalWeapon_1397 = MobSkillId(1397)
val mskillCrystalWeapon_1398 = MobSkillId(1398)
val mskillCrystalWeapon_1399 = MobSkillId(1399)
val mskillCrystalWeapon_1400 = MobSkillId(1400)
val mskillBlindVortex_1401 = MobSkillId(1401)
val mskillGigaScream_1402 = MobSkillId(1402)
val mskillDreadDive_1403 = MobSkillId(1403)
val mskillFeatherBarrier_1404 = MobSkillId(1404)
val mskillStormwind_1405 = MobSkillId(1405)
val mskillUltrasonics_1406 = MobSkillId(1406)
val mskillBloodDrain_1407 = MobSkillId(1407)
val mskillSubsonics_1408 = MobSkillId(1408)
val mskillMarrowDrain_1409 = MobSkillId(1409)
val mskillSonicBoom_1410 = MobSkillId(1410)
val mskillJetStream_1411 = MobSkillId(1411)
val mskillSlipstream_1412 = MobSkillId(1412)
val mskillTurbulence_1413 = MobSkillId(1413)
val mskillTentacle_1414 = MobSkillId(1414)
val mskillInkJet_1415 = MobSkillId(1415)
val mskillHardMembrane_1416 = MobSkillId(1416)
val mskillCrossAttack_1417 = MobSkillId(1417)
val mskillRegeneration_1418 = MobSkillId(1418)
val mskillMaelstrom_1419 = MobSkillId(1419)
val mskillWhirlwind_1420 = MobSkillId(1420)
val mskillRoar_1421 = MobSkillId(1421)
val mskillRazorFang_1422 = MobSkillId(1422)
val mskillClawCyclone_1423 = MobSkillId(1423)
val mskillPredatoryGlare_1424 = MobSkillId(1424)
val mskillCrossthrash_1425 = MobSkillId(1425)
val mskillRipperFang_1426 = MobSkillId(1426)
val mskillFoulBreath_1428 = MobSkillId(1428)
val mskillFrostBreath_1429 = MobSkillId(1429)
val mskillThunderbolt_1430 = MobSkillId(1430)
val mskillChompRush_1431 = MobSkillId(1431)
val mskillScytheTail_1432 = MobSkillId(1432)
val mskillDoubleClaw_1433 = MobSkillId(1433)
val mskillGrapple_1434 = MobSkillId(1434)
val mskillFilamentedHold_1435 = MobSkillId(1435)
val mskillSpinningTop_1436 = MobSkillId(1436)
val mskillGnash_1437 = MobSkillId(1437)
val mskillVileBelch_1438 = MobSkillId(1438)
val mskillHypnicLamp_1439 = MobSkillId(1439)
val mskillSeismicTail_1440 = MobSkillId(1440)
val mskillSeaspray_1441 = MobSkillId(1441)
val mskillLeechingCurrent_1442 = MobSkillId(1442)
val mskillPeckingFlurry_1443 = MobSkillId(1443)
val mskillSnatchMorsel_1444 = MobSkillId(1444)
val mskillFeatherTickle_1445 = MobSkillId(1445)
val mskillWisecrack_1446 = MobSkillId(1446)
val mskillBarrierTusk_1447 = MobSkillId(1447)
val mskillOnrush_1448 = MobSkillId(1448)
val mskillStampede_1449 = MobSkillId(1449)
val mskillFlailingTrunk_1450 = MobSkillId(1450)
val mskillVoraciousTrunk_1451 = MobSkillId(1451)
val mskillProboscisShower_1452 = MobSkillId(1452)
val mskillAbrasiveTantara_1453 = MobSkillId(1453)
val mskillDeafeningTantara_1454 = MobSkillId(1454)
val mskillFreneticRip_1455 = MobSkillId(1455)
val mskillBugleCall_1456 = MobSkillId(1456)
val mskillYawn_1457 = MobSkillId(1457)
val mskillWingSlap_1458 = MobSkillId(1458)
val mskillBeakLunge_1459 = MobSkillId(1459)
val mskillFrigidShuffle_1460 = MobSkillId(1460)
val mskillWingWhirl_1461 = MobSkillId(1461)
val mskillCrosswind_1462 = MobSkillId(1462)
val mskillWindShear_1464 = MobSkillId(1464)
val mskillObfuscate_1465 = MobSkillId(1465)
val mskillZephyrMantle_1466 = MobSkillId(1466)
val mskillIllWind_1467 = MobSkillId(1467)
val mskillWhiteWind_1468 = MobSkillId(1468)
val mskillKibosh_1469 = MobSkillId(1469)
val mskillCutpurse_1470 = MobSkillId(1470)
val mskillSandspray_1471 = MobSkillId(1471)
val mskillFaze_1472 = MobSkillId(1472)
val mskillBowshot_1473 = MobSkillId(1473)
val mskillDeadeye_1474 = MobSkillId(1474)
val mskillForcefulBlow_1475 = MobSkillId(1475)
val mskillSomersaultKick_1476 = MobSkillId(1476)
val mskillFirespit_1477 = MobSkillId(1477)
val mskillWarmUp_1478 = MobSkillId(1478)
val mskillJavelinThrow_1479 = MobSkillId(1479)
val mskillAxeThrow_1480 = MobSkillId(1480)
val mskillVorpalBlade_1481 = MobSkillId(1481)
val mskillGroundburst_1482 = MobSkillId(1482)
val mskill_1483 = MobSkillId(1483)
val mskill_1484 = MobSkillId(1484)
val mskillPotentLunge_1485 = MobSkillId(1485)
val mskillOverthrow_1486 = MobSkillId(1486)
val mskillRockSmash_1487 = MobSkillId(1487)
val mskillDiamondhide_1488 = MobSkillId(1488)
val mskillEnervation_1489 = MobSkillId(1489)
val mskillQuakeStomp_1490 = MobSkillId(1490)
val mskillZarraqa_1491 = MobSkillId(1491)
val mskillZarbzan_1492 = MobSkillId(1492)
val mskillHealingStomp_1493 = MobSkillId(1493)
val mskill_1494 = MobSkillId(1494)
val mskill_1495 = MobSkillId(1495)
val mskillGustingGouge_1496 = MobSkillId(1496)
val mskillHystericBarrage_1497 = MobSkillId(1497)
val mskillDukkeripen_1498 = MobSkillId(1498)
val mskillDukkeripen_1499 = MobSkillId(1499)
val mskillDukkeripen_1500 = MobSkillId(1500)
val mskillDukkeripen_1501 = MobSkillId(1501)
val mskillTailSlap_1502 = MobSkillId(1502)
val mskillHypnoticSway_1503 = MobSkillId(1503)
val mskillSwiftShot_1504 = MobSkillId(1504)
val mskillArrowDeluge_1505 = MobSkillId(1505)
val mskillBellyDance_1506 = MobSkillId(1506)
val mskill_1507 = MobSkillId(1507)
val mskill_1508 = MobSkillId(1508)
val mskillGustingGouge_1509 = MobSkillId(1509)
val mskillHystericBarrage_1510 = MobSkillId(1510)
val mskillDukkeripen_1511 = MobSkillId(1511)
val mskillDukkeripen_1512 = MobSkillId(1512)
val mskillDukkeripen_1513 = MobSkillId(1513)
val mskillDukkeripen_1514 = MobSkillId(1514)
val mskillTailSlap_1515 = MobSkillId(1515)
val mskillTorrent_1516 = MobSkillId(1516)
val mskillSwiftShot_1517 = MobSkillId(1517)
val mskillArrowDeluge_1518 = MobSkillId(1518)
val mskillRisingSwell_1519 = MobSkillId(1519)
val mskill_1520 = MobSkillId(1520)
val mskill_1521 = MobSkillId(1521)
val mskillSpinalCleave_1522 = MobSkillId(1522)
val mskillMangle_1523 = MobSkillId(1523)
val mskillLeapingCleave_1524 = MobSkillId(1524)
val mskillHexPalm_1525 = MobSkillId(1525)
val mskillAnimatingWail_1526 = MobSkillId(1526)
val mskillFortifyingWail_1527 = MobSkillId(1527)
val mskillUnblestJambiya_1528 = MobSkillId(1528)
val mskillLavaSpit_1529 = MobSkillId(1529)
val mskillSulfurousBreath_1530 = MobSkillId(1530)
val mskillScorchingLash_1531 = MobSkillId(1531)
val mskillUlulation_1532 = MobSkillId(1532)
val mskillMagmaHoplon_1533 = MobSkillId(1533)
val mskillGatesofHades_1534 = MobSkillId(1534)
val mskillIncinerate_1535 = MobSkillId(1535)
val mskillNullsong_1536 = MobSkillId(1536)
val mskillVampiricRoot_1537 = MobSkillId(1537)
val mskillPerdition_1538 = MobSkillId(1538)
val mskillMalediction_1539 = MobSkillId(1539)
val mskillPiercingShriek_1540 = MobSkillId(1540)
val mskillRushingSlash_1541 = MobSkillId(1541)
val mskillDecussate_1542 = MobSkillId(1542)
val mskillTyrannicBlare_1543 = MobSkillId(1543)
val mskillMiasma_1544 = MobSkillId(1544)
val mskillVorpalWheel_1545 = MobSkillId(1545)
val mskillSledgehammer_1546 = MobSkillId(1546)
val mskillHeadSnatch_1547 = MobSkillId(1547)
val mskillHaymaker_1548 = MobSkillId(1548)
val mskillIncessantFists_1549 = MobSkillId(1549)
val mskillArcaneStomp_1550 = MobSkillId(1550)
val mskillPleiadesRay_1551 = MobSkillId(1551)
val mskillPetrifaction_1552 = MobSkillId(1552)
val mskillShadowThrust_1553 = MobSkillId(1553)
val mskillTailSlap_1554 = MobSkillId(1554)
val mskill_1555 = MobSkillId(1555)
val mskillPinningShot_1556 = MobSkillId(1556)
val mskillCalcifyingDeluge_1557 = MobSkillId(1557)
val mskillGorgonDance_1558 = MobSkillId(1558)
val mskillAmberScutum_1559 = MobSkillId(1559)
val mskillVitriolicSpray_1560 = MobSkillId(1560)
val mskillThermalPulse_1561 = MobSkillId(1561)
val mskillCannonball_1562 = MobSkillId(1562)
val mskillHeatBarrier_1563 = MobSkillId(1563)
val mskillVitriolicShower_1564 = MobSkillId(1564)
val mskillAmplification_1565 = MobSkillId(1565)
val mskillBoilingPoint_1566 = MobSkillId(1566)
val mskillXenoglossia_1567 = MobSkillId(1567)
val mskillAmorphicSpikes_1568 = MobSkillId(1568)
val mskillAmorphicScythe_1569 = MobSkillId(1569)
val mskillSynergism_1570 = MobSkillId(1570)
val mskillMetastasis_1571 = MobSkillId(1571)
val mskillPyricBlast_1572 = MobSkillId(1572)
val mskillPyricBulwark_1573 = MobSkillId(1573)
val mskillPolarBlast_1574 = MobSkillId(1574)
val mskillPolarBulwark_1575 = MobSkillId(1575)
val mskillBarofield_1576 = MobSkillId(1576)
val mskill_1577 = MobSkillId(1577)
val mskillTrembling_1578 = MobSkillId(1578)
val mskillSerpentineTail_1579 = MobSkillId(1579)
val mskillNerveGas_1580 = MobSkillId(1580)
val mskillFeebleBleat_1581 = MobSkillId(1581)
val mskillMineBlast_1582 = MobSkillId(1582)
val mskillRushingSlash_1583 = MobSkillId(1583)
val mskillRushingStab_1584 = MobSkillId(1584)
val mskillSandblast_1585 = MobSkillId(1585)
val mskillSandpit_1586 = MobSkillId(1586)
val mskillVenomSpray_1587 = MobSkillId(1587)
val mskillPitAmbush_1588 = MobSkillId(1588)
val mskillMandibularBite_1589 = MobSkillId(1589)
val mskillSharpSting_1590 = MobSkillId(1590)
val mskillFrenzyPollen_1591 = MobSkillId(1591)
val mskillFinalSting_1592 = MobSkillId(1592)
val mskillSlingBomb_1593 = MobSkillId(1593)
val mskillFormationAttack_1594 = MobSkillId(1594)
val mskillRefueling_1595 = MobSkillId(1595)
val mskillCircleofFlames_1596 = MobSkillId(1596)
val mskillSelfDestruct_1597 = MobSkillId(1597)
val mskillStellarBurst_1598 = MobSkillId(1598)
val mskillSelfDestruct_1599 = MobSkillId(1599)
val mskillOmegaJavelin_1600 = MobSkillId(1600)
val mskillSelfDestruct_1601 = MobSkillId(1601)
val mskillTailRoll_1602 = MobSkillId(1602)
val mskillTusk_1603 = MobSkillId(1603)
val mskillScutum_1604 = MobSkillId(1604)
val mskillBoneCrunch_1605 = MobSkillId(1605)
val mskillAwfulEye_1606 = MobSkillId(1606)
val mskillHeavyBellow_1607 = MobSkillId(1607)
val mskillIntimidate_1608 = MobSkillId(1608)
val mskillAquaBall_1609 = MobSkillId(1609)
val mskillSplashBreath_1610 = MobSkillId(1610)
val mskillScrewdriver_1611 = MobSkillId(1611)
val mskillWaterWall_1612 = MobSkillId(1612)
val mskillWaterShield_1613 = MobSkillId(1613)
val mskillRecoilDive_1614 = MobSkillId(1614)
val mskillSuction_1615 = MobSkillId(1615)
val mskillAcidMist_1616 = MobSkillId(1616)
val mskillSandBreath_1617 = MobSkillId(1617)
val mskillDrainkiss_1618 = MobSkillId(1618)
val mskillRegeneration_1619 = MobSkillId(1619)
val mskillTPDrainkiss_1620 = MobSkillId(1620)
val mskillMPDrainkiss_1621 = MobSkillId(1621)
val mskillBrainDrain_1622 = MobSkillId(1622)
val mskillTriclip_1623 = MobSkillId(1623)
val mskillBackSwish_1624 = MobSkillId(1624)
val mskillMow_1625 = MobSkillId(1625)
val mskillFrightfulRoar_1626 = MobSkillId(1626)
val mskillMortalRay_1627 = MobSkillId(1627)
val mskillUnblestArmor_1628 = MobSkillId(1628)
val mskillFullforceBlow_1629 = MobSkillId(1629)
val mskillGastricBomb_1630 = MobSkillId(1630)
val mskillSandspin_1631 = MobSkillId(1631)
val mskillTremors_1632 = MobSkillId(1632)
val mskillSpiritVacuum_1633 = MobSkillId(1633)
val mskillSoundVacuum_1634 = MobSkillId(1634)
val mskillProvoke_1635 = MobSkillId(1635)
val mskill_1636 = MobSkillId(1636)
val mskillSpiritSurge_1637 = MobSkillId(1637)
val mskillPotentLunge_1638 = MobSkillId(1638)
val mskillOverthrow_1639 = MobSkillId(1639)
val mskillRockSmash_1640 = MobSkillId(1640)
val mskillDiamondhide_1641 = MobSkillId(1641)
val mskillEnervation_1642 = MobSkillId(1642)
val mskillQuakeStomp_1643 = MobSkillId(1643)
val mskillHealingStomp_1644 = MobSkillId(1644)
val mskill_1645 = MobSkillId(1645)
val mskill_1646 = MobSkillId(1646)
val mskillCamisado_1647 = MobSkillId(1647)
val mskillSomnolence_1648 = MobSkillId(1648)
val mskillNoctoshield_1649 = MobSkillId(1649)
val mskillUltimateTerror_1650 = MobSkillId(1650)
val mskillDreamShroud_1651 = MobSkillId(1651)
val mskillNightmare_1652 = MobSkillId(1652)
val mskillCacodemonia_1653 = MobSkillId(1653)
val mskillNetherBlast_1654 = MobSkillId(1654)
val mskillRuinousOmen_1655 = MobSkillId(1655)
val mskillHypnogenesis_1656 = MobSkillId(1656)
val mskillStunbolt_1657 = MobSkillId(1657)
val mskillGreatWheel_1658 = MobSkillId(1658)
val mskill_1659 = MobSkillId(1659)
val mskillBlessedRadiance_1660 = MobSkillId(1660)
val mskillSweepingSomnolence_1661 = MobSkillId(1661)
val mskillNetherTempest_1662 = MobSkillId(1662)
val mskillDaydream_1663 = MobSkillId(1663)
val mskillRushingDrub_1664 = MobSkillId(1664)
val mskillForcefulBlow_1665 = MobSkillId(1665)
val mskillSomersaultKick_1666 = MobSkillId(1666)
val mskillFirespit_1667 = MobSkillId(1667)
val mskillWarmUp_1668 = MobSkillId(1668)
val mskillStaveToss_1669 = MobSkillId(1669)
val mskillGroundburst_1670 = MobSkillId(1670)
val mskill_1671 = MobSkillId(1671)
val mskill_1672 = MobSkillId(1672)
val mskillPoleSwing_1673 = MobSkillId(1673)
val mskillTidalSlash_1674 = MobSkillId(1674)
val mskillEagleEyeShot_1675 = MobSkillId(1675)
val mskillEagleEyeShot_1676 = MobSkillId(1676)
val mskillAzureLore_1677 = MobSkillId(1677)
val mskillWildCard_1678 = MobSkillId(1678)
val mskillOverdrive_1679 = MobSkillId(1679)
val mskillShibaraku_1680 = MobSkillId(1680)
val mskill_1681 = MobSkillId(1681)
val mskill_1682 = MobSkillId(1682)
val mskill_1683 = MobSkillId(1683)
val mskillChimeraRipper_1684 = MobSkillId(1684)
val mskillStringClipper_1685 = MobSkillId(1685)
val mskillArcuballista_1686 = MobSkillId(1686)
val mskillSlapstick_1687 = MobSkillId(1687)
val mskillShieldBash_1688 = MobSkillId(1688)
val mskillProvoke_1689 = MobSkillId(1689)
val mskillShockAbsorber_1690 = MobSkillId(1690)
val mskillFlashbulb_1691 = MobSkillId(1691)
val mskillManaConverter_1692 = MobSkillId(1692)
val mskillRangedAttack_1693 = MobSkillId(1693)
val mskillBellyDance_1694 = MobSkillId(1694)
val mskillMagmaFan_1695 = MobSkillId(1695)
val mskillErraticFlutter_1696 = MobSkillId(1696)
val mskillProboscis_1697 = MobSkillId(1697)
val mskillErosionDust_1698 = MobSkillId(1698)
val mskillExuviation_1699 = MobSkillId(1699)
val mskillFireBreak_1700 = MobSkillId(1700)
val mskillFrogSong_1701 = MobSkillId(1701)
val mskillMagicHammer_1702 = MobSkillId(1702)
val mskillWaterBomb_1703 = MobSkillId(1703)
val mskillFrogCheer_1704 = MobSkillId(1704)
val mskillProvidence_1705 = MobSkillId(1705)
val mskillFrogChorus_1706 = MobSkillId(1706)
val mskillMindBlast_1707 = MobSkillId(1707)
val mskillImmortalMind_1708 = MobSkillId(1708)
val mskillImmortalShield_1709 = MobSkillId(1709)
val mskillMindPurge_1710 = MobSkillId(1710)
val mskillTribulation_1711 = MobSkillId(1711)
val mskillImmortalAnathema_1712 = MobSkillId(1712)
val mskillReprobation_1713 = MobSkillId(1713)
val mskillEclosion_1714 = MobSkillId(1714)
val mskill_1715 = MobSkillId(1715)
val mskill_1716 = MobSkillId(1716)
val mskill_1717 = MobSkillId(1717)
val mskill_1718 = MobSkillId(1718)
val mskill_1719 = MobSkillId(1719)
val mskill_1720 = MobSkillId(1720)
val mskillDeathgnash_1721 = MobSkillId(1721)
val mskillAbominableBelch_1722 = MobSkillId(1722)
val mskill_1723 = MobSkillId(1723)
val mskillBoreasMantle_1724 = MobSkillId(1724)
val mskill_1725 = MobSkillId(1725)
val mskillNullifyingDropkick_1726 = MobSkillId(1726)
val mskillAuroralUppercut_1727 = MobSkillId(1727)
val mskillWisecrack_1728 = MobSkillId(1728)
val mskillFightersRoll_1729 = MobSkillId(1729)
val mskillRoguesRoll_1730 = MobSkillId(1730)
val mskillGallantsRoll_1731 = MobSkillId(1731)
val mskillChaosRoll_1732 = MobSkillId(1732)
val mskillHuntersRoll_1733 = MobSkillId(1733)
val mskillNinjaRoll_1734 = MobSkillId(1734)
val mskillDoubleUp_1735 = MobSkillId(1735)
val mskillFireManeuver_1736 = MobSkillId(1736)
val mskillIceManeuver_1737 = MobSkillId(1737)
val mskillWindManeuver_1738 = MobSkillId(1738)
val mskillEarthManeuver_1739 = MobSkillId(1739)
val mskillThunderManeuver_1740 = MobSkillId(1740)
val mskillWaterManeuver_1741 = MobSkillId(1741)
val mskillHaneFubuki_1742 = MobSkillId(1742)
val mskillHidenSokyaku_1743 = MobSkillId(1743)
val mskillShikonoMitate_1744 = MobSkillId(1744)
val mskillHappobarai_1745 = MobSkillId(1745)
val mskillRinpyotosha_1746 = MobSkillId(1746)
val mskillGratingTantara_1747 = MobSkillId(1747)
val mskillStiflingTantara_1748 = MobSkillId(1748)
val mskillReward_1749 = MobSkillId(1749)
val mskillAzureLore_1750 = MobSkillId(1750)
val mskillWildCard_1751 = MobSkillId(1751)
val mskillOverdrive_1752 = MobSkillId(1752)
val mskillFireShot_1753 = MobSkillId(1753)
val mskillIceShot_1754 = MobSkillId(1754)
val mskillWindShot_1755 = MobSkillId(1755)
val mskillEarthShot_1756 = MobSkillId(1756)
val mskillThunderShot_1757 = MobSkillId(1757)
val mskillWaterShot_1758 = MobSkillId(1758)
val mskillLightShot_1759 = MobSkillId(1759)
val mskillDarkShot_1760 = MobSkillId(1760)
val mskill_1761 = MobSkillId(1761)
val mskill_1762 = MobSkillId(1762)
val mskill_1763 = MobSkillId(1763)
val mskillHundredFists_1764 = MobSkillId(1764)
val mskillEraser_1765 = MobSkillId(1765)
val mskillTenebrousMist_1766 = MobSkillId(1766)
val mskillThunderstrike_1767 = MobSkillId(1767)
val mskillTourbillion_1768 = MobSkillId(1768)
val mskillDreadstorm_1769 = MobSkillId(1769)
val mskillFossilizingBreath_1770 = MobSkillId(1770)
val mskillPlagueSwipe_1771 = MobSkillId(1771)
val mskillFulmination_1772 = MobSkillId(1772)
val mskill_1773 = MobSkillId(1773)
val mskill_1774 = MobSkillId(1774)
val mskillReactiveShield_1775 = MobSkillId(1775)
val mskillRollerChain_1776 = MobSkillId(1776)
val mskillChokeChain_1777 = MobSkillId(1777)
val mskillReinforcements_1778 = MobSkillId(1778)
val mskillBiomagnet_1779 = MobSkillId(1779)
val mskillAstralGate_1780 = MobSkillId(1780)
val mskillWarp_1781 = MobSkillId(1781)
val mskillArtificialGravity_1782 = MobSkillId(1782)
val mskillAntigravity_1783 = MobSkillId(1783)
val mskillRailCannon_1784 = MobSkillId(1784)
val mskillRestoral_1785 = MobSkillId(1785)
val mskillArmature_1786 = MobSkillId(1786)
val mskillArtificialGravity_1787 = MobSkillId(1787)
val mskillAntigravity_1788 = MobSkillId(1788)
val mskillRailCannon_1789 = MobSkillId(1789)
val mskillArtificialGravity_1790 = MobSkillId(1790)
val mskillAntigravity_1791 = MobSkillId(1791)
val mskillRailCannon_1792 = MobSkillId(1792)
val mskillArtificialGravity_1793 = MobSkillId(1793)
val mskillAntigravity_1794 = MobSkillId(1794)
val mskillRailCannon_1795 = MobSkillId(1795)
val mskillRestoral_1796 = MobSkillId(1796)
val mskillHeavyArmature_1797 = MobSkillId(1797)
val mskillDiffusionRay_1798 = MobSkillId(1798)
val mskillInertiaStream_1799 = MobSkillId(1799)
val mskillDischarge_1800 = MobSkillId(1800)
val mskillMortalRevolution_1801 = MobSkillId(1801)
val mskillHomingMissile_1802 = MobSkillId(1802)
val mskillDiscoid_1803 = MobSkillId(1803)
val mskillBrainjack_1804 = MobSkillId(1804)
val mskillRestoral_1805 = MobSkillId(1805)
val mskillRestoral_1806 = MobSkillId(1806)
val mskillHeavyArmature_1807 = MobSkillId(1807)
val mskillHeavyArmature_1808 = MobSkillId(1808)
val mskillCannibalBlade_1809 = MobSkillId(1809)
val mskillDaze_1810 = MobSkillId(1810)
val mskillKnockout_1811 = MobSkillId(1811)
val mskillEconomizer_1812 = MobSkillId(1812)
val mskillTribulation_1813 = MobSkillId(1813)
val mskillDismemberment_1814 = MobSkillId(1814)
val mskillDireStraight_1815 = MobSkillId(1815)
val mskillEarthshatter_1816 = MobSkillId(1816)
val mskillSinkerDrill_1817 = MobSkillId(1817)
val mskillDetonatingGrip_1818 = MobSkillId(1818)
val mskillOverthrow_1819 = MobSkillId(1819)
val mskillRockSmash_1820 = MobSkillId(1820)
val mskillDiamondhide_1821 = MobSkillId(1821)
val mskillEnervation_1822 = MobSkillId(1822)
val mskillQuakeStomp_1823 = MobSkillId(1823)
val mskillPotentLunge_1824 = MobSkillId(1824)
val mskillHammerGoRound_1825 = MobSkillId(1825)
val mskillHammerblow_1826 = MobSkillId(1826)
val mskillDropHammer_1827 = MobSkillId(1827)
val mskillSeismohammer_1828 = MobSkillId(1828)
val mskillVenomousTail_1829 = MobSkillId(1829)
val mskillGrimReaper_1830 = MobSkillId(1830)
val mskill_1831 = MobSkillId(1831)
val mskillVictoryBeacon_1832 = MobSkillId(1832)
val mskillSalamanderFlame_1833 = MobSkillId(1833)
val mskillTyphonicArrow_1834 = MobSkillId(1834)
val mskillMeteoricImpact_1835 = MobSkillId(1835)
val mskillScouringBubbles_1836 = MobSkillId(1836)
val mskill_1837 = MobSkillId(1837)
val mskillFireAngon_1838 = MobSkillId(1838)
val mskillBatterhorn_1839 = MobSkillId(1839)
val mskillClobber_1840 = MobSkillId(1840)
val mskillGraniteSkin_1841 = MobSkillId(1841)
val mskillBlazingAngon_1842 = MobSkillId(1842)
val mskillBatterhorn_1843 = MobSkillId(1843)
val mskillClobber_1844 = MobSkillId(1844)
val mskillDemoralizingRoar_1845 = MobSkillId(1845)
val mskillBoilingBlood_1846 = MobSkillId(1846)
val mskillGraniteSkin_1847 = MobSkillId(1847)
val mskillCripplingSlam_1848 = MobSkillId(1848)
val mskillMijinGakure_1849 = MobSkillId(1849)
val mskillBloodrake_1850 = MobSkillId(1850)
val mskillDecollation_1851 = MobSkillId(1851)
val mskillNosferatusKiss_1852 = MobSkillId(1852)
val mskillHeliovoid_1853 = MobSkillId(1853)
val mskillWingsofGehenna_1854 = MobSkillId(1854)
val mskillEternalDamnation_1855 = MobSkillId(1855)
val mskillNocturnalServitude_1856 = MobSkillId(1856)
val mskillHellsnap_1857 = MobSkillId(1857)
val mskillHellclap_1858 = MobSkillId(1858)
val mskillCackle_1859 = MobSkillId(1859)
val mskillNecrobane_1860 = MobSkillId(1860)
val mskillNecropurge_1861 = MobSkillId(1861)
val mskillBilgestorm_1862 = MobSkillId(1862)
val mskillThundrisShriek_1863 = MobSkillId(1863)
val mskillOfnir_1864 = MobSkillId(1864)
val mskillValfodr_1865 = MobSkillId(1865)
val mskillYggr_1866 = MobSkillId(1866)
val mskillGagnrath_1867 = MobSkillId(1867)
val mskillSanngetall_1868 = MobSkillId(1868)
val mskillGeirrothr_1869 = MobSkillId(1869)
val mskillZantetsuken_1870 = MobSkillId(1870)
val mskill_1871 = MobSkillId(1871)
val mskill_1872 = MobSkillId(1872)
val mskill_1873 = MobSkillId(1873)
val mskillProboscisShower_1874 = MobSkillId(1874)
val mskill_1875 = MobSkillId(1875)
val mskillReplicator_1876 = MobSkillId(1876)
val mskillLiarsDice_1877 = MobSkillId(1877)
val mskillVictoryBeacon_1878 = MobSkillId(1878)
val mskillSalamanderFlame_1879 = MobSkillId(1879)
val mskillTyphonicArrow_1880 = MobSkillId(1880)
val mskillMeteoricImpact_1881 = MobSkillId(1881)
val mskillScouringBubbles_1882 = MobSkillId(1882)
val mskillDoom_1883 = MobSkillId(1883)
val mskillPeacebreaker_1884 = MobSkillId(1884)
val mskillRadiantSacrament_1885 = MobSkillId(1885)
val mskillMegaHoly_1886 = MobSkillId(1886)
val mskillPerfectDefense_1887 = MobSkillId(1887)
val mskillDivineSpear_1888 = MobSkillId(1888)
val mskillGospeloftheLost_1889 = MobSkillId(1889)
val mskillVoidofRepentance_1890 = MobSkillId(1890)
val mskillDivineJudgment_1891 = MobSkillId(1891)
val mskillEagleEyeShot_1892 = MobSkillId(1892)
val mskillChiBlast_1893 = MobSkillId(1893)
val mskillSnatchMorsel_1894 = MobSkillId(1894)
val mskill1000Needles_1895 = MobSkillId(1895)
val mskillAquaFortis_1896 = MobSkillId(1896)
val mskillRegurgitation_1897 = MobSkillId(1897)
val mskillDeltaThrust_1898 = MobSkillId(1898)
val mskillTorpefyingCharge_1899 = MobSkillId(1899)
val mskillGrimGlower_1900 = MobSkillId(1900)
val mskillCalcifyingMist_1901 = MobSkillId(1901)
val mskillInsipidNip_1902 = MobSkillId(1902)
val mskillPandemicNip_1903 = MobSkillId(1903)
val mskillBombilation_1904 = MobSkillId(1904)
val mskillCimicineDischarge_1905 = MobSkillId(1905)
val mskillEmeticDischarge_1906 = MobSkillId(1906)
val mskillSeedspray_1907 = MobSkillId(1907)
val mskillViscidEmission_1908 = MobSkillId(1908)
val mskillRottenStench_1909 = MobSkillId(1909)
val mskillFloralBouquet_1910 = MobSkillId(1910)
val mskillBloodyCaress_1911 = MobSkillId(1911)
val mskillBloodyCaress_1912 = MobSkillId(1912)
val mskillSoothingAroma_1913 = MobSkillId(1913)
val mskillFeveredPitch_1914 = MobSkillId(1914)
val mskillCalloftheMoon_1915 = MobSkillId(1915)
val mskillCalloftheMoon_1916 = MobSkillId(1916)
val mskillPleniluneEmbrace_1917 = MobSkillId(1917)
val mskillPleniluneEmbrace_1918 = MobSkillId(1918)
val mskillNoxBlast_1919 = MobSkillId(1919)
val mskillAsuranClaws_1920 = MobSkillId(1920)
val mskillCacophony_1921 = MobSkillId(1921)
val mskillSuddenLunge_1922 = MobSkillId(1922)
val mskillNoisomePowder_1923 = MobSkillId(1923)
val mskillNepentheanHum_1924 = MobSkillId(1924)
val mskillSpiralSpin_1925 = MobSkillId(1925)
val mskillSpiralBurst_1926 = MobSkillId(1926)
val mskillFuscousOoze_1927 = MobSkillId(1927)
val mskillPurulentOoze_1928 = MobSkillId(1928)
val mskillCorrosiveOoze_1929 = MobSkillId(1929)
val mskillMucilaginousOoze_1930 = MobSkillId(1930)
val mskillDustvoid_1931 = MobSkillId(1931)
val mskillSlaverousGale_1932 = MobSkillId(1932)
val mskillAeolianVoid_1933 = MobSkillId(1933)
val mskillExtremePurgation_1934 = MobSkillId(1934)
val mskillDesiccation_1935 = MobSkillId(1935)
val mskillDoomvoid_1936 = MobSkillId(1936)
val mskillZephyrArrow_1937 = MobSkillId(1937)
val mskillLetheArrows_1938 = MobSkillId(1938)
val mskillSpringBreeze_1939 = MobSkillId(1939)
val mskillSummerBreeze_1940 = MobSkillId(1940)
val mskillAutumnBreeze_1941 = MobSkillId(1941)
val mskillWinterBreeze_1942 = MobSkillId(1942)
val mskillCyclonicTurmoil_1943 = MobSkillId(1943)
val mskillCyclonicTorrent_1944 = MobSkillId(1944)
val mskillOrcishCounterstance_1945 = MobSkillId(1945)
val mskillBerserkerDance_1946 = MobSkillId(1946)
val mskillDiamondShell_1947 = MobSkillId(1947)
val mskillOreLob_1948 = MobSkillId(1948)
val mskillFeatheredFurore_1949 = MobSkillId(1949)
val mskillDarkInvocation_1950 = MobSkillId(1950)
val mskillDisorientingWaul_1951 = MobSkillId(1951)
val mskillMicrospores_1952 = MobSkillId(1952)
val mskillBlinkofPeril_1953 = MobSkillId(1953)
val mskillPetalPirouette_1954 = MobSkillId(1954)
val mskill_1955 = MobSkillId(1955)
val mskill_1956 = MobSkillId(1956)
val mskillDarkMist_1957 = MobSkillId(1957)
val mskill_1958 = MobSkillId(1958)
val mskill_1959 = MobSkillId(1959)
val mskillNocturnalCombustion_1960 = MobSkillId(1960)
val mskillBerserk_1961 = MobSkillId(1961)
val mskillPenumbralImpact_1962 = MobSkillId(1962)
val mskillDarkWave_1963 = MobSkillId(1963)
val mskillTartareanStorm_1964 = MobSkillId(1964)
val mskillHellScissors_1965 = MobSkillId(1965)
val mskillHurricaneBreath_1966 = MobSkillId(1966)
val mskillOreToss_1967 = MobSkillId(1967)
val mskillHeadButt_1968 = MobSkillId(1968)
val mskillShellBash_1969 = MobSkillId(1969)
val mskillShellGuard_1970 = MobSkillId(1970)
val mskillHowl_1971 = MobSkillId(1971)
val mskillTheWrathofGuDha_1972 = MobSkillId(1972)
val mskillPoisonBreath_1973 = MobSkillId(1973)
val mskillPoisonSting_1974 = MobSkillId(1974)
val mskillVenom_1975 = MobSkillId(1975)
val mskillQueasyshroom_1976 = MobSkillId(1976)
val mskillDiamondShell_1977 = MobSkillId(1977)
val mskillOreLob_1978 = MobSkillId(1978)
val mskillParalyzingBlast_1979 = MobSkillId(1979)
val mskillSilencingBlast_1980 = MobSkillId(1980)
val mskillBindingBlast_1981 = MobSkillId(1981)
val mskillBloodyTomahawk_1982 = MobSkillId(1982)
val mskillVolantAngon_1983 = MobSkillId(1983)
val mskillWardenofTerror_1984 = MobSkillId(1984)
val mskillCalltoArms_1985 = MobSkillId(1985)
val mskillMightyStrikes_1986 = MobSkillId(1986)
val mskillHundredFists_1987 = MobSkillId(1987)
val mskillBenediction_1988 = MobSkillId(1988)
val mskillManafont_1989 = MobSkillId(1989)
val mskillChainspell_1990 = MobSkillId(1990)
val mskillPerfectDodge_1991 = MobSkillId(1991)
val mskillInvincible_1992 = MobSkillId(1992)
val mskillBloodWeapon_1993 = MobSkillId(1993)
val mskillFamiliar_1994 = MobSkillId(1994)
val mskillSoulVoice_1995 = MobSkillId(1995)
val mskillEagleEyeShot_1996 = MobSkillId(1996)
val mskillMeikyoShisui_1997 = MobSkillId(1997)
val mskillMijinGakure_1998 = MobSkillId(1998)
val mskillSpiritSurge_1999 = MobSkillId(1999)
val mskillAstralFlow_2000 = MobSkillId(2000)
val mskillAzureLore_2001 = MobSkillId(2001)
val mskillWildCard_2002 = MobSkillId(2002)
val mskillOverdrive_2003 = MobSkillId(2003)
val mskillTrance_2004 = MobSkillId(2004)
val mskillTabulaRasa_2005 = MobSkillId(2005)
val mskill_2006 = MobSkillId(2006)
val mskillTornadoEdge_2007 = MobSkillId(2007)
val mskillShoulderCharge_2008 = MobSkillId(2008)
val mskillSkullSmash_2009 = MobSkillId(2009)
val mskillShellCharge_2010 = MobSkillId(2010)
val mskillSkullSmash_2011 = MobSkillId(2011)
val mskillShellCharge_2012 = MobSkillId(2012)
val mskillKamaitachi_2013 = MobSkillId(2013)
val mskillShirahadori_2014 = MobSkillId(2014)
val mskillRisingDragon_2015 = MobSkillId(2015)
val mskillBearKiller_2016 = MobSkillId(2016)
val mskillUrielBlade_2017 = MobSkillId(2017)
val mskillSpineChiller_2018 = MobSkillId(2018)
val mskillProminence_2019 = MobSkillId(2019)
val mskillArrowofApathy_2020 = MobSkillId(2020)
val mskillCruelRiposte_2021 = MobSkillId(2021)
val mskillGlorySlash_2022 = MobSkillId(2022)
val mskillNapalmTomahawk_2023 = MobSkillId(2023)
val mskillIainuki_2024 = MobSkillId(2024)
val mskillOppressiveEmbrace_2025 = MobSkillId(2025)
val mskillReverieFrolic_2026 = MobSkillId(2026)
val mskillTartarusTorpor_2027 = MobSkillId(2027)
val mskillDeathKnell_2028 = MobSkillId(2028)
val mskillBloodyQuarrel_2029 = MobSkillId(2029)
val mskillLeonineLegflail_2030 = MobSkillId(2030)
val mskillSoulfetterArrow_2031 = MobSkillId(2031)
val mskillHeavyArtillery_2032 = MobSkillId(2032)
val mskillImmortalShield_2033 = MobSkillId(2033)
val mskillRestoral_2034 = MobSkillId(2034)
val mskillRestoral_2035 = MobSkillId(2035)
val mskillRestoral_2036 = MobSkillId(2036)
val mskillRestoral_2037 = MobSkillId(2037)
val mskillBasiliskCannon_2038 = MobSkillId(2038)
val mskillBeakedBomber_2039 = MobSkillId(2039)
val mskill_2040 = MobSkillId(2040)
val mskill_2041 = MobSkillId(2041)
val mskill_2042 = MobSkillId(2042)
val mskillBoneCrusher_2043 = MobSkillId(2043)
val mskillArmorPiercer_2044 = MobSkillId(2044)
val mskillMagicMortar_2045 = MobSkillId(2045)
val mskillLightArts_2046 = MobSkillId(2046)
val mskillDarkArts_2047 = MobSkillId(2047)
val mskillCuringWaltz_2048 = MobSkillId(2048)
val mskillHealingWaltz_2049 = MobSkillId(2049)
val mskillDrainSamba_2050 = MobSkillId(2050)
val mskillHasteSamba_2051 = MobSkillId(2051)
val mskillQuickstep_2052 = MobSkillId(2052)
val mskillBoxStep_2053 = MobSkillId(2053)
val mskillStutterStep_2054 = MobSkillId(2054)
val mskillBuildingFlourish_2055 = MobSkillId(2055)
val mskillDesperateFlourish_2056 = MobSkillId(2056)
val mskillReverseFlourish_2057 = MobSkillId(2057)
val mskillParsimony_2058 = MobSkillId(2058)
val mskillAlacrity_2059 = MobSkillId(2059)
val mskillManifestation_2060 = MobSkillId(2060)
val mskillEbullience_2061 = MobSkillId(2061)
val mskillCuringWaltzII_2062 = MobSkillId(2062)
val mskillCuringWaltzIII_2063 = MobSkillId(2063)
val mskillCuringWaltzIV_2064 = MobSkillId(2064)
val mskillDrainSambaII_2065 = MobSkillId(2065)
val mskillDrainSambaIII_2066 = MobSkillId(2066)
val mskillAnimatedFlourish_2067 = MobSkillId(2067)
val mskillViolentFlourish_2068 = MobSkillId(2068)
val mskillWildFlourish_2069 = MobSkillId(2069)
val mskill_2070 = MobSkillId(2070)
val mskillMineBlast_2071 = MobSkillId(2071)
val mskill_2072 = MobSkillId(2072)
val mskill_2073 = MobSkillId(2073)
val mskill_2074 = MobSkillId(2074)
val mskill_2075 = MobSkillId(2075)
val mskill_2076 = MobSkillId(2076)
val mskill_2077 = MobSkillId(2077)
val mskillWrathofZeus_2078 = MobSkillId(2078)
val mskillLightningSpear_2079 = MobSkillId(2079)
val mskillAcheronKick_2080 = MobSkillId(2080)
val mskillDamselMemento_2081 = MobSkillId(2081)
val mskillRampantStance_2082 = MobSkillId(2082)
val mskill_2083 = MobSkillId(2083)
val mskillExtremePurgation_2084 = MobSkillId(2084)
val mskill_2085 = MobSkillId(2085)
val mskill_2086 = MobSkillId(2086)
val mskill_2087 = MobSkillId(2087)
val mskill_2088 = MobSkillId(2088)
val mskill_2089 = MobSkillId(2089)
val mskill_2090 = MobSkillId(2090)
val mskill_2091 = MobSkillId(2091)
val mskillGlacialBellow_2092 = MobSkillId(2092)
val mskillDauntingHurl_2093 = MobSkillId(2093)
val mskillScatterShell_2094 = MobSkillId(2094)
val mskillTearGrenade_2095 = MobSkillId(2095)
val mskillStickyGrenade_2096 = MobSkillId(2096)
val mskill_2097 = MobSkillId(2097)
val mskill_2098 = MobSkillId(2098)
val mskill_2099 = MobSkillId(2099)
val mskill_2100 = MobSkillId(2100)
val mskill_2101 = MobSkillId(2101)
val mskillTabulaRasa_2102 = MobSkillId(2102)
val mskillStrapCutter_2103 = MobSkillId(2103)
val mskillWindShear_2104 = MobSkillId(2104)
val mskillStaveToss_2105 = MobSkillId(2105)
val mskill_2106 = MobSkillId(2106)
val mskill_2107 = MobSkillId(2107)
val mskillUnblestJambiya_2108 = MobSkillId(2108)
val mskillGoddesssShield_2109 = MobSkillId(2109)
val mskillMineBlast_2110 = MobSkillId(2110)
val mskillMoribundHack_2111 = MobSkillId(2111)
val mskillDamselMemento_2112 = MobSkillId(2112)
val mskillScintillantLance_2113 = MobSkillId(2113)
val mskillGraceofHera_2114 = MobSkillId(2114)
val mskillNoxiousSpray_2115 = MobSkillId(2115)
val mskillHellbornYawp_2116 = MobSkillId(2116)
val mskillVeilofChaos_2117 = MobSkillId(2117)
val mskillTormentofGuDha_2118 = MobSkillId(2118)
val mskillVorticoseSands_2119 = MobSkillId(2119)
val mskillParoxysm_2120 = MobSkillId(2120)
val mskillReviviscence_2121 = MobSkillId(2121)
val mskillDiamondShell_2122 = MobSkillId(2122)
val mskillInvincible_2123 = MobSkillId(2123)
val mskillMonocularScowl_2124 = MobSkillId(2124)
val mskillDoubleKick_2125 = MobSkillId(2125)
val mskillMijinGakure_2126 = MobSkillId(2126)
val mskillCharm_2127 = MobSkillId(2127)
val mskillOrbitalEarthrend_2128 = MobSkillId(2128)
val mskillTongueLash_2129 = MobSkillId(2129)
val mskillCobraClamp_2130 = MobSkillId(2130)
val mskillFatalScream_2131 = MobSkillId(2131)
val mskillDirtyBreath_2132 = MobSkillId(2132)
val mskillLethalTriclip_2133 = MobSkillId(2133)
val mskillAccursedArmor_2134 = MobSkillId(2134)
val mskillAmnesicBlast_2135 = MobSkillId(2135)
val mskillOppressiveGlare_2136 = MobSkillId(2136)
val mskillRitualBind_2137 = MobSkillId(2137)
val mskillMoribundHack_2138 = MobSkillId(2138)
val mskillMineBlast_2139 = MobSkillId(2139)
val mskill_2140 = MobSkillId(2140)
val mskill_2141 = MobSkillId(2141)
val mskill_2142 = MobSkillId(2142)
val mskill_2143 = MobSkillId(2143)
val mskill_2144 = MobSkillId(2144)
val mskill_2145 = MobSkillId(2145)
val mskill_2146 = MobSkillId(2146)
val mskill_2147 = MobSkillId(2147)
val mskill_2148 = MobSkillId(2148)
val mskill_2149 = MobSkillId(2149)
val mskillRoar_2150 = MobSkillId(2150)
val mskillChargedWhisker_2151 = MobSkillId(2151)
val mskill_2152 = MobSkillId(2152)
val mskill_2153 = MobSkillId(2153)
val mskillDemonicFlower_2154 = MobSkillId(2154)
val mskillPhantasmalDance_2155 = MobSkillId(2155)
val mskillThunderousYowl_2156 = MobSkillId(2156)
val mskillFeatherMaelstrom_2157 = MobSkillId(2157)
val mskillSaucepan_2158 = MobSkillId(2158)
val mskillSeedAutoAttack_2159 = MobSkillId(2159)
val mskillSeedofDeception_2160 = MobSkillId(2160)
val mskillSeedofDeference_2161 = MobSkillId(2161)
val mskillSeedofNihility_2162 = MobSkillId(2162)
val mskillSeedofJudgment_2163 = MobSkillId(2163)
val mskillShacklingClout_2164 = MobSkillId(2164)
val mskillDarkOrb_2165 = MobSkillId(2165)
val mskillDarkMist_2166 = MobSkillId(2166)
val mskillTriumphantRoar_2167 = MobSkillId(2167)
val mskillTerrorEye_2168 = MobSkillId(2168)
val mskillBloodyClaw_2169 = MobSkillId(2169)
val mskillShadowBurst_2170 = MobSkillId(2170)
val mskillTailLash_2171 = MobSkillId(2171)
val mskillBloodyBeak_2172 = MobSkillId(2172)
val mskillFeralPeck_2173 = MobSkillId(2173)
val mskillWarpedWail_2174 = MobSkillId(2174)
val mskillReavingWind_2175 = MobSkillId(2175)
val mskillStormWing_2176 = MobSkillId(2176)
val mskillCalamitousWind_2177 = MobSkillId(2177)
val mskill_2178 = MobSkillId(2178)
val mskillSeveringFang_2179 = MobSkillId(2179)
val mskillSubzeroSmash_2180 = MobSkillId(2180)
val mskillAquaBlast_2181 = MobSkillId(2181)
val mskillFrozenMist_2182 = MobSkillId(2182)
val mskillHydroWave_2183 = MobSkillId(2183)
val mskillIceGuillotine_2184 = MobSkillId(2184)
val mskillAquaCannon_2185 = MobSkillId(2185)
val mskillThornedStance_2186 = MobSkillId(2186)
val mskillSensualDance_2187 = MobSkillId(2187)
val mskillDancersFury_2188 = MobSkillId(2188)
val mskillWhirlingEdge_2189 = MobSkillId(2189)
val mskillRousingSamba_2190 = MobSkillId(2190)
val mskillVivifyingWaltz_2191 = MobSkillId(2191)
val mskillRegalScratch_2192 = MobSkillId(2192)
val mskillMewingLullaby_2193 = MobSkillId(2193)
val mskillEerieEye_2194 = MobSkillId(2194)
val mskillDivineFavor_2195 = MobSkillId(2195)
val mskillLevelHoly_2196 = MobSkillId(2196)
val mskillLevelHoly_2197 = MobSkillId(2197)
val mskillLevelHoly_2198 = MobSkillId(2198)
val mskillLevelHoly_2199 = MobSkillId(2199)
val mskillLevelHoly_2200 = MobSkillId(2200)
val mskillLevelHoly_2201 = MobSkillId(2201)
val mskillSoulVacuum_2202 = MobSkillId(2202)
val mskillSoulInfusion_2203 = MobSkillId(2203)
val mskill_2204 = MobSkillId(2204)
val mskillMogBomb_2205 = MobSkillId(2205)
val mskillMogShrapnel_2206 = MobSkillId(2206)
val mskillFlowerpot_2207 = MobSkillId(2207)
val mskill_2208 = MobSkillId(2208)
val mskillBillToss_2209 = MobSkillId(2209)
val mskillWashtub_2210 = MobSkillId(2210)
val mskillCrystallineFlare_2211 = MobSkillId(2211)
val mskillKingCobraClamp_2212 = MobSkillId(2212)
val mskillWaspSting_2213 = MobSkillId(2213)
val mskillDancingEdge_2214 = MobSkillId(2214)
val mskillBistillotBlast_2215 = MobSkillId(2215)
val mskillSongbirdSwoop_2216 = MobSkillId(2216)
val mskillVunkerlHerbTonic_2217 = MobSkillId(2217)
val mskillStagsCry_2218 = MobSkillId(2218)
val mskillStagsCall_2219 = MobSkillId(2219)
val mskillGyreStrike_2220 = MobSkillId(2220)
val mskillStagsCharge_2221 = MobSkillId(2221)
val mskillOrcsbane_2222 = MobSkillId(2222)
val mskillTemblorBlade_2223 = MobSkillId(2223)
val mskillInferno_2224 = MobSkillId(2224)
val mskillTidalWave_2225 = MobSkillId(2225)
val mskillEarthenFury_2226 = MobSkillId(2226)
val mskillDiamondDust_2227 = MobSkillId(2227)
val mskillJudgmentBolt_2228 = MobSkillId(2228)
val mskillAerialBlast_2229 = MobSkillId(2229)
val mskillSalvationScythe_2230 = MobSkillId(2230)
val mskillSalvationScythe_2231 = MobSkillId(2231)
val mskillDivineMalison_2232 = MobSkillId(2232)
val mskillDivineMalison_2233 = MobSkillId(2233)
val mskillFireOverload_2234 = MobSkillId(2234)
val mskillIceOverload_2235 = MobSkillId(2235)
val mskillWindOverload_2236 = MobSkillId(2236)
val mskillEarthOverload_2237 = MobSkillId(2237)
val mskillLightningOverload_2238 = MobSkillId(2238)
val mskillWaterOverload_2239 = MobSkillId(2239)
val mskillLightOverload_2240 = MobSkillId(2240)
val mskillDarkOverload_2241 = MobSkillId(2241)
val mskill_2242 = MobSkillId(2242)
val mskill_2243 = MobSkillId(2243)
val mskill_2244 = MobSkillId(2244)
val mskill_2245 = MobSkillId(2245)
val mskill_2246 = MobSkillId(2246)
val mskill_2247 = MobSkillId(2247)
val mskill_2248 = MobSkillId(2248)
val mskill_2249 = MobSkillId(2249)
val mskill_2250 = MobSkillId(2250)
val mskill_2251 = MobSkillId(2251)
val mskill_2252 = MobSkillId(2252)
val mskillHypothermalCombustion_2253 = MobSkillId(2253)
val mskill_2254 = MobSkillId(2254)
val mskillCorpseBreath_2255 = MobSkillId(2255)
val mskillVenomShower_2256 = MobSkillId(2256)
val mskillMegaScissors_2257 = MobSkillId(2257)
val mskillCytokinesis_2258 = MobSkillId(2258)
val mskill_2259 = MobSkillId(2259)
val mskillGraviticHorn_2260 = MobSkillId(2260)
val mskillQuakeBlast_2261 = MobSkillId(2261)
val mskillNornArrows_2262 = MobSkillId(2262)
val mskillDexterWing_2263 = MobSkillId(2263)
val mskillSinisterWing_2264 = MobSkillId(2264)
val mskillChaosBlast_2265 = MobSkillId(2265)
val mskillAbyssicBuster_2266 = MobSkillId(2266)
val mskillDancingTail_2267 = MobSkillId(2267)
val mskillDancingTail_2268 = MobSkillId(2268)
val mskillChillingRoar_2269 = MobSkillId(2269)
val mskillChillingRoar_2270 = MobSkillId(2270)
val mskillSoulDouse_2271 = MobSkillId(2271)
val mskillSoulDouse_2272 = MobSkillId(2272)
val mskillDarkStar_2273 = MobSkillId(2273)
val mskillDarkStar_2274 = MobSkillId(2274)
val mskillAltairBullet_2275 = MobSkillId(2275)
val mskillSavageSwordhand_2276 = MobSkillId(2276)
val mskillLithicRay_2277 = MobSkillId(2277)
val mskillMinaxGlare_2278 = MobSkillId(2278)
val mskillViciousKick_2279 = MobSkillId(2279)
val mskillBoonVoid_2280 = MobSkillId(2280)
val mskillCruelSlash_2281 = MobSkillId(2281)
val mskillSpellWall_2282 = MobSkillId(2282)
val mskillImplosion_2283 = MobSkillId(2283)
val mskillUmbralOrb_2284 = MobSkillId(2284)
val mskillCrossSmash_2285 = MobSkillId(2285)
val mskillBlightingBlitz_2286 = MobSkillId(2286)
val mskillSpawnShadow_2287 = MobSkillId(2287)
val mskillSomaWall_2288 = MobSkillId(2288)
val mskillDoomArc_2289 = MobSkillId(2289)
val mskill_2290 = MobSkillId(2290)
val mskill_2291 = MobSkillId(2291)
val mskillFluidSpread_2292 = MobSkillId(2292)
val mskillFluidToss_2293 = MobSkillId(2293)
val mskillDissolve_2294 = MobSkillId(2294)
val mskillMucusSpread_2295 = MobSkillId(2295)
val mskillEpoxySpread_2296 = MobSkillId(2296)
val mskillRiceBall_2297 = MobSkillId(2297)
val mskill_2298 = MobSkillId(2298)
val mskill_2299 = MobSkillId(2299)
val mskillOfnir_2300 = MobSkillId(2300)
val mskillValfodr_2301 = MobSkillId(2301)
val mskillYggr_2302 = MobSkillId(2302)
val mskillGagnrath_2303 = MobSkillId(2303)
val mskillSanngetall_2304 = MobSkillId(2304)
val mskillGeirrothr_2305 = MobSkillId(2305)
val mskillAcridStream_2306 = MobSkillId(2306)
val mskillRimeSpray_2307 = MobSkillId(2307)
val mskillBlazingBound_2308 = MobSkillId(2308)
val mskillMoltingBurst_2309 = MobSkillId(2309)
val mskillDiabolicClaw_2310 = MobSkillId(2310)
val mskillStygianCyclone_2311 = MobSkillId(2311)
val mskillDeathlyDiminuendo_2312 = MobSkillId(2312)
val mskillHellishCrescendo_2313 = MobSkillId(2313)
val mskillAfflictingGaze_2314 = MobSkillId(2314)
val mskillStygianSphere_2315 = MobSkillId(2315)
val mskillMalignInvocation_2316 = MobSkillId(2316)
val mskillShadowWreck_2317 = MobSkillId(2317)
val mskillThousandSpears_2318 = MobSkillId(2318)
val mskillTaintingBreath_2319 = MobSkillId(2319)
val mskillMercurialStrike_2320 = MobSkillId(2320)
val mskillMercurialStrike_2321 = MobSkillId(2321)
val mskillColossalSlam_2322 = MobSkillId(2322)
val mskillPhaeosynthesis_2323 = MobSkillId(2323)
val mskillPandorasCurse_2324 = MobSkillId(2324)
val mskillPandorasGift_2325 = MobSkillId(2325)
val mskill_2326 = MobSkillId(2326)
val mskill_2327 = MobSkillId(2327)
val mskill_2328 = MobSkillId(2328)
val mskillTestudoTremor_2329 = MobSkillId(2329)
val mskillEclipticMeteor_2330 = MobSkillId(2330)
val mskillInspirit_2331 = MobSkillId(2331)
val mskillDebonairRush_2332 = MobSkillId(2332)
val mskillIridalPierce_2333 = MobSkillId(2333)
val mskillLunarRevolution_2334 = MobSkillId(2334)
val mskillGreatDivide_2335 = MobSkillId(2335)
val mskillDarklingBlade_2336 = MobSkillId(2336)
val mskillDemonicShear_2337 = MobSkillId(2337)
val mskillQuietusSphere_2338 = MobSkillId(2338)
val mskill_2339 = MobSkillId(2339)
val mskill_2340 = MobSkillId(2340)
val mskill_2341 = MobSkillId(2341)
val mskill_2342 = MobSkillId(2342)
val mskillTepalTwist_2343 = MobSkillId(2343)
val mskillBloomFouette_2344 = MobSkillId(2344)
val mskillPetalbackSpin_2345 = MobSkillId(2345)
val mskillMortalBlast_2346 = MobSkillId(2346)
val mskillHeatBreath_2347 = MobSkillId(2347)
val mskillGorge_2348 = MobSkillId(2348)
val mskillDisgorge_2349 = MobSkillId(2349)
val mskillCarousel_2350 = MobSkillId(2350)
val mskillAgaricus_2351 = MobSkillId(2351)
val mskillTerminalSting_2352 = MobSkillId(2352)
val mskillBoomingBleat_2353 = MobSkillId(2353)
val mskillVacantGaze_2354 = MobSkillId(2354)
val mskillBlaster_2355 = MobSkillId(2355)
val mskillWildCarrot_2356 = MobSkillId(2356)
val mskillSpiralSpin_2357 = MobSkillId(2357)
val mskillNoisomePowder_2358 = MobSkillId(2358)
val mskillStagsCry_2359 = MobSkillId(2359)
val mskill_2360 = MobSkillId(2360)
val mskill_2361 = MobSkillId(2361)
val mskill_2362 = MobSkillId(2362)
val mskillTurbineCyclone_2363 = MobSkillId(2363)
val mskillSeismicImpact_2364 = MobSkillId(2364)
val mskillIncinerator_2365 = MobSkillId(2365)
val mskillArmCannon_2366 = MobSkillId(2366)
val mskillBallisticKick_2367 = MobSkillId(2367)
val mskillScapulaBeam_2368 = MobSkillId(2368)
val mskillEradicator_2369 = MobSkillId(2369)
val mskillAugerSmash_2370 = MobSkillId(2370)
val mskillAreaBombardment_2371 = MobSkillId(2371)
val mskillCauterizingField_2372 = MobSkillId(2372)
val mskillBenthicTyphoon_2373 = MobSkillId(2373)
val mskillPelagicTempest_2374 = MobSkillId(2374)
val mskillOsmosis_2375 = MobSkillId(2375)
val mskillVacuoleDischarge_2376 = MobSkillId(2376)
val mskillNucleicImplosion_2377 = MobSkillId(2377)
val mskillInterference_2378 = MobSkillId(2378)
val mskillDarkArrivisme_2379 = MobSkillId(2379)
val mskillBanneretCharge_2380 = MobSkillId(2380)
val mskillBesiegersBane_2381 = MobSkillId(2381)
val mskillHadalSummons_2382 = MobSkillId(2382)
val mskillMayhemLantern_2383 = MobSkillId(2383)
val mskillRuinousScythe_2384 = MobSkillId(2384)
val mskillPsycheSuction_2385 = MobSkillId(2385)
val mskillVermilionWind_2386 = MobSkillId(2386)
val mskillTyrantTusk_2387 = MobSkillId(2387)
val mskillSomnialDurance_2388 = MobSkillId(2388)
val mskillMudStream_2389 = MobSkillId(2389)
val mskillRancorSmash_2390 = MobSkillId(2390)
val mskillMelancholyJig_2391 = MobSkillId(2391)
val mskillForlornImpact_2392 = MobSkillId(2392)
val mskillEssenceJack_2393 = MobSkillId(2393)
val mskill_2394 = MobSkillId(2394)
val mskill_2395 = MobSkillId(2395)
val mskill_2396 = MobSkillId(2396)
val mskill_2397 = MobSkillId(2397)
val mskill_2398 = MobSkillId(2398)
val mskill_2399 = MobSkillId(2399)
val mskill_2400 = MobSkillId(2400)
val mskill_2401 = MobSkillId(2401)
val mskill_2402 = MobSkillId(2402)
val mskill_2403 = MobSkillId(2403)
val mskill_2404 = MobSkillId(2404)
val mskill_2405 = MobSkillId(2405)
val mskill_2406 = MobSkillId(2406)
val mskill_2407 = MobSkillId(2407)
val mskillCosmicBreath_2408 = MobSkillId(2408)
val mskillCataclysmicVortex_2409 = MobSkillId(2409)
val mskillGyreCharge_2410 = MobSkillId(2410)
val mskillMightyGuard_2411 = MobSkillId(2411)
val mskillAtomicRay_2412 = MobSkillId(2412)
val mskillDarkMatter_2413 = MobSkillId(2413)
val mskillProtostar_2414 = MobSkillId(2414)
val mskillSupernova_2415 = MobSkillId(2415)
val mskill_2416 = MobSkillId(2416)
val mskill_2417 = MobSkillId(2417)
val mskill_2418 = MobSkillId(2418)
val mskillDarkThorn_2419 = MobSkillId(2419)
val mskillPetalineTempest_2420 = MobSkillId(2420)
val mskillDuranceWhip_2421 = MobSkillId(2421)
val mskillSubjugatingSlash_2422 = MobSkillId(2422)
val mskillFatalAllure_2423 = MobSkillId(2423)
val mskillMoonlightVeil_2424 = MobSkillId(2424)
val mskill_2425 = MobSkillId(2425)
val mskill_2426 = MobSkillId(2426)
val mskill_2427 = MobSkillId(2427)
val mskillDarkFlare_2428 = MobSkillId(2428)
val mskillDarkFreeze_2429 = MobSkillId(2429)
val mskillDarkTornado_2430 = MobSkillId(2430)
val mskillDarkQuake_2431 = MobSkillId(2431)
val mskillDarkBurst_2432 = MobSkillId(2432)
val mskillDarkFlood_2433 = MobSkillId(2433)
val mskillDarkMoon_2434 = MobSkillId(2434)
val mskillDarkSun_2435 = MobSkillId(2435)
val mskillRoyalDecree_2436 = MobSkillId(2436)
val mskillVirulentHaze_2437 = MobSkillId(2437)
val mskillCyclonicBlight_2438 = MobSkillId(2438)
val mskillTormentTusk_2439 = MobSkillId(2439)
val mskillBalefulRoar_2440 = MobSkillId(2440)
val mskillInfiniteTerror_2441 = MobSkillId(2441)
val mskillLithicBreath_2442 = MobSkillId(2442)
val mskillTarsalSlam_2443 = MobSkillId(2443)
val mskillEnthrall_2444 = MobSkillId(2444)
val mskillAcheronFlame_2445 = MobSkillId(2445)
val mskillTerraWing_2446 = MobSkillId(2446)
val mskillDreadWind_2447 = MobSkillId(2447)
val mskillNeedles_2448 = MobSkillId(2448)
val mskillWhiteWind_2449 = MobSkillId(2449)
val mskillSmokebomb_2450 = MobSkillId(2450)
val mskillParalysisShower_2451 = MobSkillId(2451)
val mskillCosmicBreath_2452 = MobSkillId(2452)
val mskillCataclysmicVortex_2453 = MobSkillId(2453)
val mskillTrance_2454 = MobSkillId(2454)
val mskill_2455 = MobSkillId(2455)
val mskill_2456 = MobSkillId(2456)
val mskill_2457 = MobSkillId(2457)
val mskillYakshaStance_2458 = MobSkillId(2458)
val mskillYakshaDamnation_2459 = MobSkillId(2459)
val mskillYakshaBliss_2460 = MobSkillId(2460)
val mskillYakshaOblivion_2461 = MobSkillId(2461)
val mskillRakshaStance_2462 = MobSkillId(2462)
val mskillRakshaJudgment_2463 = MobSkillId(2463)
val mskillRakshaIllusion_2464 = MobSkillId(2464)
val mskillRakshaVengeance_2465 = MobSkillId(2465)
val mskillHarpeiaAutoAttack_2466 = MobSkillId(2466)
val mskillHarpeiaAutoAttack_2467 = MobSkillId(2467)
val mskillHarpeiaAutoAttack_2468 = MobSkillId(2468)
val mskillRendingTalons_2469 = MobSkillId(2469)
val mskillShriekingGale_2470 = MobSkillId(2470)
val mskillWingsofWoe_2471 = MobSkillId(2471)
val mskillWingsofAgony_2472 = MobSkillId(2472)
val mskillTyphoeanRage_2473 = MobSkillId(2473)
val mskillRavenousWail_2474 = MobSkillId(2474)
val mskillIncinerator_2475 = MobSkillId(2475)
val mskillArmCannon_2476 = MobSkillId(2476)
val mskillBallisticKick_2477 = MobSkillId(2477)
val mskillCauterizingField_2478 = MobSkillId(2478)
val mskillSearingTempest_2479 = MobSkillId(2479)
val mskillBlindingFulgor_2480 = MobSkillId(2480)
val mskillSpectralFloe_2481 = MobSkillId(2481)
val mskillScouringSpate_2482 = MobSkillId(2482)
val mskillAnvilLightning_2483 = MobSkillId(2483)
val mskillSilentStorm_2484 = MobSkillId(2484)
val mskillEntomb_2485 = MobSkillId(2485)
val mskillTenebralCrush_2486 = MobSkillId(2486)
val mskillStringShredder_2487 = MobSkillId(2487)
val mskillArmorShatterer_2488 = MobSkillId(2488)
val mskillHeatCapacitor_2489 = MobSkillId(2489)
val mskillBarrageTurbine_2490 = MobSkillId(2490)
val mskillDisruptor_2491 = MobSkillId(2491)
val mskillMantidAutoAttack_2492 = MobSkillId(2492)
val mskillMantidAutoAttack_2493 = MobSkillId(2493)
val mskillMantidAutoAttack_2494 = MobSkillId(2494)
val mskillSlicingSickle_2495 = MobSkillId(2495)
val mskillRaptorialClaw_2496 = MobSkillId(2496)
val mskillPhlegmExpulsion_2497 = MobSkillId(2497)
val mskillMaceratingBile_2498 = MobSkillId(2498)
val mskillPreyingPosture_2499 = MobSkillId(2499)
val mskillDeathProphet_2500 = MobSkillId(2500)
val mskillSakraStorm_2501 = MobSkillId(2501)
val mskillKaleidoscopicFury_2502 = MobSkillId(2502)
val mskillTelsonicTempest_2503 = MobSkillId(2503)
val mskillPreternaturalGleam_2504 = MobSkillId(2504)
val mskillChupaBlossom_2505 = MobSkillId(2505)
val mskillHellSlash_2506 = MobSkillId(2506)
val mskillHorrorCloud_2507 = MobSkillId(2507)
val mskillBlackCloud_2508 = MobSkillId(2508)
val mskillBloodSaber_2509 = MobSkillId(2509)
val mskillMalediction_2510 = MobSkillId(2510)
val mskillCrepusculeBlade_2511 = MobSkillId(2511)
val mskillDeathlyGlare_2512 = MobSkillId(2512)
val mskillBlightedBouquet_2513 = MobSkillId(2513)
val mskillBoomingBombination_2514 = MobSkillId(2514)
val mskillGushoGoo_2515 = MobSkillId(2515)
val mskill_2516 = MobSkillId(2516)
val mskill_2517 = MobSkillId(2517)
val mskillFlankOpening_2518 = MobSkillId(2518)
val mskillTabbiyaaGambit_2519 = MobSkillId(2519)
val mskillShahMat_2520 = MobSkillId(2520)
val mskillBenediction_2521 = MobSkillId(2521)
val mskillReactiveShield_2522 = MobSkillId(2522)
val mskillShockAbsorber_2523 = MobSkillId(2523)
val mskillReplicator_2524 = MobSkillId(2524)
val mskillGalluAutoAttack_2525 = MobSkillId(2525)
val mskillGalluAutoAttack_2526 = MobSkillId(2526)
val mskillGalluAutoAttack_2527 = MobSkillId(2527)
val mskillDiluvialWake_2528 = MobSkillId(2528)
val mskillKurnugiCollapse_2529 = MobSkillId(2529)
val mskillSearingHalitus_2530 = MobSkillId(2530)
val mskillDivestingGale_2531 = MobSkillId(2531)
val mskillBoltofPerdition_2532 = MobSkillId(2532)
val mskillCripplingRime_2533 = MobSkillId(2533)
val mskillOblivionsMantle_2534 = MobSkillId(2534)
val mskill_2535 = MobSkillId(2535)
val mskill_2536 = MobSkillId(2536)
val mskill_2537 = MobSkillId(2537)
val mskill_2538 = MobSkillId(2538)
val mskill_2539 = MobSkillId(2539)
val mskill_2540 = MobSkillId(2540)
val mskill_2541 = MobSkillId(2541)
val mskillGnashnGuttle_2542 = MobSkillId(2542)
val mskillSloughySputum_2543 = MobSkillId(2543)
val mskillChymousReek_2544 = MobSkillId(2544)
val mskillRancidReflux_2545 = MobSkillId(2545)
val mskillCrowningFlatus_2546 = MobSkillId(2546)
val mskillSlimyProposal_2547 = MobSkillId(2547)
val mskillJustDesserts_2548 = MobSkillId(2548)
val mskillPawnsPenumbra_2549 = MobSkillId(2549)
val mskillBeleaguerment_2550 = MobSkillId(2550)
val mskillUnchivalrousStab_2551 = MobSkillId(2551)
val mskillDiscordantGambit_2552 = MobSkillId(2552)
val mskillImmolatingClaw_2553 = MobSkillId(2553)
val mskillYamasJudgment_2554 = MobSkillId(2554)
val mskillKeraunosQuill_2555 = MobSkillId(2555)
val mskillBilrostSquall_2556 = MobSkillId(2556)
val mskillDunurStrike_2557 = MobSkillId(2557)
val mskillYawn_2558 = MobSkillId(2558)
val mskillWingSlap_2559 = MobSkillId(2559)
val mskillBeakLunge_2560 = MobSkillId(2560)
val mskillFrigidShuffle_2561 = MobSkillId(2561)
val mskillWingWhirl_2562 = MobSkillId(2562)
val mskillWhiteout_2563 = MobSkillId(2563)
val mskillKeratinousCrush_2564 = MobSkillId(2564)
val mskillAccurstSpear_2565 = MobSkillId(2565)
val mskillEldritchWind_2566 = MobSkillId(2566)
val mskillRhinowrecker_2567 = MobSkillId(2567)
val mskillCloudscourge_2568 = MobSkillId(2568)
val mskillLouringSkies_2569 = MobSkillId(2569)
val mskillExponentialBurst_2570 = MobSkillId(2570)
val mskillSuddenLunge_2571 = MobSkillId(2571)
val mskillJettatura_2572 = MobSkillId(2572)
val mskillAquaBreath_2573 = MobSkillId(2573)
val mskillRoyalDecree_2574 = MobSkillId(2574)
val mskillGraceofHera_2575 = MobSkillId(2575)
val mskill_2576 = MobSkillId(2576)
val mskill_2577 = MobSkillId(2577)
val mskill_2578 = MobSkillId(2578)
val mskill_2579 = MobSkillId(2579)
val mskill_2580 = MobSkillId(2580)
val mskill_2581 = MobSkillId(2581)
val mskill_2582 = MobSkillId(2582)
val mskillPrismaticBreath_2583 = MobSkillId(2583)
val mskillAcicularBrand_2584 = MobSkillId(2584)
val mskillOrogenesis_2585 = MobSkillId(2585)
val mskillPhasonBeam_2586 = MobSkillId(2586)
val mskillDiffractiveBreak_2587 = MobSkillId(2587)
val mskillEuhedralSwat_2588 = MobSkillId(2588)
val mskill_2589 = MobSkillId(2589)
val mskill_2590 = MobSkillId(2590)
val mskill_2591 = MobSkillId(2591)
val mskill_2592 = MobSkillId(2592)
val mskill_2593 = MobSkillId(2593)
val mskill_2594 = MobSkillId(2594)
val mskill_2595 = MobSkillId(2595)
val mskillPrismaticBreath_2596 = MobSkillId(2596)
val mskillAcicularBrand_2597 = MobSkillId(2597)
val mskillOrogenesis_2598 = MobSkillId(2598)
val mskillPhasonBeam_2599 = MobSkillId(2599)
val mskillDiffractiveBreak_2600 = MobSkillId(2600)
val mskillEuhedralSwat_2601 = MobSkillId(2601)
val mskillCrystalliteShower_2602 = MobSkillId(2602)
val mskillGravitonCrux_2603 = MobSkillId(2603)
val mskillCrystalBolide_2604 = MobSkillId(2604)
val mskillFragorMaximus_2605 = MobSkillId(2605)
val mskillPteraketosAutoAttack_2606 = MobSkillId(2606)
val mskillPteraketosAutoAttack_2607 = MobSkillId(2607)
val mskillPteraketosAutoAttack_2608 = MobSkillId(2608)
val mskillPteraketosAutoAttack_2609 = MobSkillId(2609)
val mskillPteraketosAutoAttack_2610 = MobSkillId(2610)
val mskillPteraketosAutoAttack_2611 = MobSkillId(2611)
val mskillEcholocation_2612 = MobSkillId(2612)
val mskillDeepSeaDirge_2613 = MobSkillId(2613)
val mskillCaudalCapacitor_2614 = MobSkillId(2614)
val mskillBaleenGurge_2615 = MobSkillId(2615)
val mskillDepthCharge_2616 = MobSkillId(2616)
val mskillBlowholeBlast_2617 = MobSkillId(2617)
val mskillWaterspout_2618 = MobSkillId(2618)
val mskillAngrySeas_2619 = MobSkillId(2619)
val mskillTharSheBlows_2620 = MobSkillId(2620)
val mskillBelladonnaAutoAttack_2621 = MobSkillId(2621)
val mskillBelladonnaAutoAttack_2622 = MobSkillId(2622)
val mskillBelladonnaAutoAttack_2623 = MobSkillId(2623)
val mskillNightStalker_2624 = MobSkillId(2624)
val mskillAtropineSpore_2625 = MobSkillId(2625)
val mskillFrondFatale_2626 = MobSkillId(2626)
val mskillFullBloom_2627 = MobSkillId(2627)
val mskillDeracinator_2628 = MobSkillId(2628)
val mskillBeautifulDeath_2629 = MobSkillId(2629)
val mskillExorender_2630 = MobSkillId(2630)
val mskillTropicTenor_2631 = MobSkillId(2631)
val mskillDarkRecital_2632 = MobSkillId(2632)
val mskillUsurpingScepter_2633 = MobSkillId(2633)
val mskillGeneiRyodan_2634 = MobSkillId(2634)
val mskillGrapeshot_2635 = MobSkillId(2635)
val mskillPiratePummel_2636 = MobSkillId(2636)
val mskillPowderKeg_2637 = MobSkillId(2637)
val mskillWalkthePlank_2638 = MobSkillId(2638)
val mskillKnuckleSandwich_2639 = MobSkillId(2639)
val mskillImperialAuthority_2640 = MobSkillId(2640)
val mskillSixthElement_2641 = MobSkillId(2641)
val mskillShieldSubverter_2642 = MobSkillId(2642)
val mskillShiningSummerSamba_2643 = MobSkillId(2643)
val mskillLovelyMiracleWaltz_2644 = MobSkillId(2644)
val mskillNeoCrystalJig_2645 = MobSkillId(2645)
val mskillSuperCrusherJig_2646 = MobSkillId(2646)
val mskillEternalVanaIllusion_2647 = MobSkillId(2647)
val mskillFinalEternalHeart_2648 = MobSkillId(2648)
val mskillShahsDecree_2649 = MobSkillId(2649)
val mskillFalsePromises_2650 = MobSkillId(2650)
val mskillFrogSong_2651 = MobSkillId(2651)
val mskillFrogChorus_2652 = MobSkillId(2652)
val mskillLevel3Petrify_2653 = MobSkillId(2653)
val mskillCitadelSiege_2654 = MobSkillId(2654)
val mskillCatastrophicMalfunction_2655 = MobSkillId(2655)
val mskillZantetsukenKai_2656 = MobSkillId(2656)
val mskillElectrocharge_2657 = MobSkillId(2657)
val mskillRearLasers_2658 = MobSkillId(2658)
val mskillMeebleWarble_2659 = MobSkillId(2659)
val mskillThrashingAssault_2660 = MobSkillId(2660)
val mskillDrillClaw_2661 = MobSkillId(2661)
val mskillPuncturingFrenzy_2662 = MobSkillId(2662)
val mskillYztargAutoAttack_2663 = MobSkillId(2663)
val mskillYztargAutoAttack_2664 = MobSkillId(2664)
val mskillYztargAutoAttack_2665 = MobSkillId(2665)
val mskillSoulshatteringRoar_2666 = MobSkillId(2666)
val mskillCalcifyingClaw_2667 = MobSkillId(2667)
val mskillDivestingStampede_2668 = MobSkillId(2668)
val mskillBonebreakingBarrage_2669 = MobSkillId(2669)
val mskillBeastruction_2670 = MobSkillId(2670)
val mskillMetamorphicBlast_2671 = MobSkillId(2671)
val mskillEnervatingGrasp_2672 = MobSkillId(2672)
val mskillOrogenicStorm_2673 = MobSkillId(2673)
val mskillSubduction_2674 = MobSkillId(2674)
val mskillTectonicShift_2675 = MobSkillId(2675)
val mskillUnrelentingBrand_2676 = MobSkillId(2676)
val mskillSearingEffulgence_2677 = MobSkillId(2677)
val mskillBlazingShriek_2678 = MobSkillId(2678)
val mskillVolcanicWrath_2679 = MobSkillId(2679)
val mskillTarichutoxin_2680 = MobSkillId(2680)
val mskillCaliginosity_2681 = MobSkillId(2681)
val mskill_2682 = MobSkillId(2682)
val mskillMightyStrikes_2683 = MobSkillId(2683)
val mskillInvincible_2684 = MobSkillId(2684)
val mskillEagleEyeShot_2685 = MobSkillId(2685)
val mskillChainspell_2686 = MobSkillId(2686)
val mskillBenediction_2687 = MobSkillId(2687)
val mskillManafont_2688 = MobSkillId(2688)
val mskillNaturesMeditation_2689 = MobSkillId(2689)
val mskillSensillaBlades_2690 = MobSkillId(2690)
val mskillTegminaBuffet_2691 = MobSkillId(2691)
val mskillSanguinarySlash_2692 = MobSkillId(2692)
val mskillOrthopterror_2693 = MobSkillId(2693)
val mskillTempestuousUpheaval_2694 = MobSkillId(2694)
val mskillSlicenDice_2695 = MobSkillId(2695)
val mskillBlackout_2696 = MobSkillId(2696)
val mskillSmoulderingSwarm_2697 = MobSkillId(2697)
val mskill_2698 = MobSkillId(2698)
val mskill_2699 = MobSkillId(2699)
val mskill_2700 = MobSkillId(2700)
val mskillImpenetrableCarapace_2701 = MobSkillId(2701)
val mskillRendingDeluge_2702 = MobSkillId(2702)
val mskillSunderingSnip_2703 = MobSkillId(2703)
val mskillViscidSpindrift_2704 = MobSkillId(2704)
val mskillRiptideEupnea_2705 = MobSkillId(2705)
val mskill_2706 = MobSkillId(2706)
val mskill_2707 = MobSkillId(2707)
val mskill_2708 = MobSkillId(2708)
val mskillCranialThrust_2709 = MobSkillId(2709)
val mskillTailThwack_2710 = MobSkillId(2710)
val mskillEmbalmingEarth_2711 = MobSkillId(2711)
val mskillScaldingBreath_2712 = MobSkillId(2712)
val mskillDebilitatingSpout_2713 = MobSkillId(2713)
val mskillParalyzingTriad_2714 = MobSkillId(2714)
val mskillCrepuscularGrasp_2715 = MobSkillId(2715)
val mskillNecroticBrume_2716 = MobSkillId(2716)
val mskillTerminalBloom_2717 = MobSkillId(2717)
val mskillFoulWaters_2718 = MobSkillId(2718)
val mskillPestilentPlume_2719 = MobSkillId(2719)
val mskillDeadeningHaze_2720 = MobSkillId(2720)
val mskillVenomousVapor_2721 = MobSkillId(2721)
val mskillConsecration_2722 = MobSkillId(2722)
val mskillSacredCaper_2723 = MobSkillId(2723)
val mskillPhototrophicBlessing_2724 = MobSkillId(2724)
val mskillPhototrophicWrath_2725 = MobSkillId(2725)
val mskillDeificGambol_2726 = MobSkillId(2726)
val mskillAncestralBanishment_2727 = MobSkillId(2727)
val mskillHeartfeltAura_2728 = MobSkillId(2728)
val mskillImpairingGlister_2729 = MobSkillId(2729)
val mskillCripplingGleam_2730 = MobSkillId(2730)
val mskill_2731 = MobSkillId(2731)
val mskillGlutinousDart_2732 = MobSkillId(2732)
val mskillDeathSpin_2733 = MobSkillId(2733)
val mskillVelkkanPygmachia_2734 = MobSkillId(2734)
val mskillSaurianSlide_2735 = MobSkillId(2735)
val mskillJungleWallop_2736 = MobSkillId(2736)
val mskill_2737 = MobSkillId(2737)
val mskillGlutinousDart_2738 = MobSkillId(2738)
val mskillDeathSpin_2739 = MobSkillId(2739)
val mskillVelkkanPygmachia_2740 = MobSkillId(2740)
val mskillSaurianSwamp_2741 = MobSkillId(2741)
val mskillJungleHoodoo_2742 = MobSkillId(2742)
val mskill_2743 = MobSkillId(2743)
val mskill_2744 = MobSkillId(2744)
val mskill_2745 = MobSkillId(2745)
val mskillMandibularLashing_2746 = MobSkillId(2746)
val mskillVespineHurricane_2747 = MobSkillId(2747)
val mskillStingerVolley_2748 = MobSkillId(2748)
val mskillDroningWhirlwind_2749 = MobSkillId(2749)
val mskillIncisiveDenouement_2750 = MobSkillId(2750)
val mskillIncisiveApotheosis_2751 = MobSkillId(2751)
val mskill_2752 = MobSkillId(2752)
val mskill_2753 = MobSkillId(2753)
val mskill_2754 = MobSkillId(2754)
val mskillProtolithicPuncture_2755 = MobSkillId(2755)
val mskillAquaticLance_2756 = MobSkillId(2756)
val mskillPelagicCleaver_2757 = MobSkillId(2757)
val mskillCarcharianVerve_2758 = MobSkillId(2758)
val mskillTidalGuillotine_2759 = MobSkillId(2759)
val mskillMarineMayhem_2760 = MobSkillId(2760)
val mskill_2761 = MobSkillId(2761)
val mskill_2762 = MobSkillId(2762)
val mskill_2763 = MobSkillId(2763)
val mskillBlisteringRoar_2764 = MobSkillId(2764)
val mskillSearingSerration_2765 = MobSkillId(2765)
val mskillVolcanicStasis_2766 = MobSkillId(2766)
val mskillTyrannicalBlow_2767 = MobSkillId(2767)
val mskillBatholithicShell_2768 = MobSkillId(2768)
val mskillPyroclasticSurge_2769 = MobSkillId(2769)
val mskillIncineratingLahar_2770 = MobSkillId(2770)
val mskillBlossomSpore_2771 = MobSkillId(2771)
val mskillFungusSpore_2772 = MobSkillId(2772)
val mskill_2773 = MobSkillId(2773)
val mskillRetinalGlare_2774 = MobSkillId(2774)
val mskillSylvanSlumber_2775 = MobSkillId(2775)
val mskillCrushingGaze_2776 = MobSkillId(2776)
val mskillVaskania_2777 = MobSkillId(2777)
val mskillGiantGnatAutoAttack_2778 = MobSkillId(2778)
val mskillGiantGnatAutoAttack_2779 = MobSkillId(2779)
val mskillGiantGnatAutoAttack_2780 = MobSkillId(2780)
val mskillFleshSyphon_2781 = MobSkillId(2781)
val mskillUmbralExpunction_2782 = MobSkillId(2782)
val mskillStickySituation_2783 = MobSkillId(2783)
val mskillAbdominalAssault_2784 = MobSkillId(2784)
val mskillMandibularMassacre_2785 = MobSkillId(2785)
val mskill_2786 = MobSkillId(2786)
val mskillWhirlingInferno_2787 = MobSkillId(2787)
val mskillBenumbingBlaze_2788 = MobSkillId(2788)
val mskillConcentricPulse_2789 = MobSkillId(2789)
val mskillFoulWaters_2790 = MobSkillId(2790)
val mskillPestilentPlume_2791 = MobSkillId(2791)
val mskillDeadeningHaze_2792 = MobSkillId(2792)
val mskillSensillaBlades_2793 = MobSkillId(2793)
val mskillTegminaBuffet_2794 = MobSkillId(2794)
val mskillMendingHalation_2795 = MobSkillId(2795)
val mskillRadialArcana_2796 = MobSkillId(2796)
val mskillDynasticGravitas_2797 = MobSkillId(2797)
val mskillYggdreantAutoAttack_2798 = MobSkillId(2798)
val mskillYggdreantAutoAttack_2799 = MobSkillId(2799)
val mskillYggdreantAutoAttack_2800 = MobSkillId(2800)
val mskillRootoftheProblem_2801 = MobSkillId(2801)
val mskillPottedPlant_2802 = MobSkillId(2802)
val mskillUproot_2803 = MobSkillId(2803)
val mskillCanopierce_2804 = MobSkillId(2804)
val mskillFireflyFandango_2805 = MobSkillId(2805)
val mskillTiiimbeeer_2806 = MobSkillId(2806)
val mskillMoltingPlumage_2807 = MobSkillId(2807)
val mskillPentapeck_2808 = MobSkillId(2808)
val mskillSwoopingFrenzy_2809 = MobSkillId(2809)
val mskillFromtheSkies_2810 = MobSkillId(2810)
val mskill_2811 = MobSkillId(2811)
val mskill_2812 = MobSkillId(2812)
val mskill_2813 = MobSkillId(2813)
val mskill_2814 = MobSkillId(2814)
val mskill_2815 = MobSkillId(2815)
val mskillCrashingThunder_2816 = MobSkillId(2816)
val mskillReverberatingCry_2817 = MobSkillId(2817)
val mskillBrownout_2818 = MobSkillId(2818)
val mskillReverseCurrent_2819 = MobSkillId(2819)
val mskillSparkstorm_2820 = MobSkillId(2820)
val mskillStaticPrison_2821 = MobSkillId(2821)
val mskill_2822 = MobSkillId(2822)
val mskill_2823 = MobSkillId(2823)
val mskill_2824 = MobSkillId(2824)
val mskillVelkkanAmbush_2825 = MobSkillId(2825)
val mskillGalumph_2826 = MobSkillId(2826)
val mskillComingThrough_2827 = MobSkillId(2827)
val mskillMercilessMauling_2828 = MobSkillId(2828)
val mskillCroctastrophe_2829 = MobSkillId(2829)
val mskill_2830 = MobSkillId(2830)
val mskillBattleTrance_2831 = MobSkillId(2831)
val mskill_2832 = MobSkillId(2832)
val mskill_2833 = MobSkillId(2833)
val mskill_2834 = MobSkillId(2834)
val mskillBanefulBlades_2835 = MobSkillId(2835)
val mskillWildwoodIndignation_2836 = MobSkillId(2836)
val mskillDryadsKiss_2837 = MobSkillId(2837)
val mskillInfectedIllusion_2838 = MobSkillId(2838)
val mskillDepravedDandia_2839 = MobSkillId(2839)
val mskillMatriarchalFiat_2840 = MobSkillId(2840)
val mskillTicklingTendrils_2841 = MobSkillId(2841)
val mskillStinkBomb_2842 = MobSkillId(2842)
val mskillNectarousDeluge_2843 = MobSkillId(2843)
val mskillNepenthicPlunge_2844 = MobSkillId(2844)
val mskillInfaunalFlop_2845 = MobSkillId(2845)
val mskill_2846 = MobSkillId(2846)
val mskillIgnis_2847 = MobSkillId(2847)
val mskillGelus_2848 = MobSkillId(2848)
val mskillFlabra_2849 = MobSkillId(2849)
val mskillTellus_2850 = MobSkillId(2850)
val mskillSulpor_2851 = MobSkillId(2851)
val mskillUnda_2852 = MobSkillId(2852)
val mskillLux_2853 = MobSkillId(2853)
val mskillTenebrae_2854 = MobSkillId(2854)
val mskillVallation_2855 = MobSkillId(2855)
val mskillPflug_2856 = MobSkillId(2856)
val mskillLunge_2857 = MobSkillId(2857)
val mskillGambit_2858 = MobSkillId(2858)
val mskillBellatrixofLight_2859 = MobSkillId(2859)
val mskillBellatrixofShadows_2860 = MobSkillId(2860)
val mskill_2861 = MobSkillId(2861)
val mskill_2862 = MobSkillId(2862)
val mskill_2863 = MobSkillId(2863)
val mskill_2864 = MobSkillId(2864)
val mskill_2865 = MobSkillId(2865)
val mskill_2866 = MobSkillId(2866)
val mskillFightingStance_2867 = MobSkillId(2867)
val mskillFightingStance_2868 = MobSkillId(2868)
val mskillFightingStance_2869 = MobSkillId(2869)
val mskillFightingStance_2870 = MobSkillId(2870)
val mskillFrizz_2871 = MobSkillId(2871)
val mskillBarrelingSmash_2874 = MobSkillId(2874)
val mskillSweepingGouge_2875 = MobSkillId(2875)
val mskillZealousSnort_2876 = MobSkillId(2876)
val mskillTerrifyingSnap_2877 = MobSkillId(2877)
val mskillPolarRoar_2881 = MobSkillId(2881)
val mskillBrainFreeze_2882 = MobSkillId(2882)
val mskillBitingAbrogation_2883 = MobSkillId(2883)
val mskillPermafrostRequiem_2884 = MobSkillId(2884)
val mskillGlacialTomb_2885 = MobSkillId(2885)
val mskillGlassyNova_2886 = MobSkillId(2886)
val mskillJitteringJig_2888 = MobSkillId(2888)
val mskillRomp_2889 = MobSkillId(2889)
val mskillFreneticFlurry_2890 = MobSkillId(2890)
val mskillDazingDiscord_2893 = MobSkillId(2893)
val mskillSteamingRage_2894 = MobSkillId(2894)
val mskillShiningSalvo_2896 = MobSkillId(2896)
val mskillPallingSalvo_2897 = MobSkillId(2897)
val mskillCatharticCaper_2898 = MobSkillId(2898)
val mskillBewailingWake_2899 = MobSkillId(2899)
val mskillFlightoftheFluttyries_2900 = MobSkillId(2900)
val mskill_2901 = MobSkillId(2901)
val mskill_2902 = MobSkillId(2902)
val mskill_2903 = MobSkillId(2903)
val mskillVehementResolution_2904 = MobSkillId(2904)
val mskillCamaraderieoftheCrevasse_2905 = MobSkillId(2905)
val mskillIntotheLight_2906 = MobSkillId(2906)
val mskillArduousDecision_2907 = MobSkillId(2907)
val mskill12BladesofRemorse_2908 = MobSkillId(2908)
val mskill_2909 = MobSkillId(2909)
val mskill_2910 = MobSkillId(2910)
val mskill_2911 = MobSkillId(2911)
val mskillAurousCharge_2912 = MobSkillId(2912)
val mskillHowlingGust_2913 = MobSkillId(2913)
val mskillRighteousRasp_2914 = MobSkillId(2914)
val mskillStarwardYowl_2915 = MobSkillId(2915)
val mskillStalkingPrey_2916 = MobSkillId(2916)
val mskillBrazenRush_2917 = MobSkillId(2917)
val mskillCrossReaver_2918 = MobSkillId(2918)
val mskillMeikyoShisui_2919 = MobSkillId(2919)
val mskillChantduCygne_2920 = MobSkillId(2920)
val mskillIntervene_2921 = MobSkillId(2921)
val mskillArroganceIncarnate_2922 = MobSkillId(2922)
val mskillChantduCygne_2923 = MobSkillId(2923)
val mskillSoulEnslavement_2924 = MobSkillId(2924)
val mskillAmonDrive_2925 = MobSkillId(2925)
val mskillLarceny_2926 = MobSkillId(2926)
val mskillCharm_2927 = MobSkillId(2927)
val mskillHavocSpiral_2928 = MobSkillId(2928)
val mskillCloudsplitter_2929 = MobSkillId(2929)
val mskillYaegasumi_2930 = MobSkillId(2930)
val mskillDragonfall_2931 = MobSkillId(2931)
val mskillTachiFudo_2932 = MobSkillId(2932)
val mskillKingCobraClamp_2933 = MobSkillId(2933)
val mskillRedLotusBlade_2934 = MobSkillId(2934)
val mskillSpiritsWithin_2935 = MobSkillId(2935)
val mskillVorpalBlade_2936 = MobSkillId(2936)
val mskillRoyalBash_2937 = MobSkillId(2937)
val mskillRoyalSavior_2938 = MobSkillId(2938)
val mskillAbyssalDrain_2939 = MobSkillId(2939)
val mskillAbyssalStrike_2940 = MobSkillId(2940)
val mskillGroundStrike_2941 = MobSkillId(2941)
val mskillGrapeshot_2942 = MobSkillId(2942)
val mskillPiratePummel_2943 = MobSkillId(2943)
val mskillPowderKeg_2944 = MobSkillId(2944)
val mskillWalkthePlank_2945 = MobSkillId(2945)
val mskillUrielBlade_2946 = MobSkillId(2946)
val mskillScouringBubbles_2947 = MobSkillId(2947)
val mskillAmatsuTsukikage_2948 = MobSkillId(2948)
val mskillBerserkRuf_2949 = MobSkillId(2949)
val mskillAstralDistortion_2950 = MobSkillId(2950)
val mskillIgnition_2951 = MobSkillId(2951)
val mskillGlacification_2952 = MobSkillId(2952)
val mskillVaporization_2953 = MobSkillId(2953)
val mskillTerrafication_2954 = MobSkillId(2954)
val mskillElectrification_2955 = MobSkillId(2955)
val mskillLiquification_2956 = MobSkillId(2956)
val mskillVortex_2957 = MobSkillId(2957)
val mskillLightBlade_2958 = MobSkillId(2958)
val mskillPeacebreaker_2959 = MobSkillId(2959)
val mskillRedLotusBlade_2960 = MobSkillId(2960)
val mskillSavageBlade_2961 = MobSkillId(2961)
val mskillVillainousRebuke_2962 = MobSkillId(2962)
val mskillStygianRelease_2963 = MobSkillId(2963)
val mskillInfernalBulwark_2964 = MobSkillId(2964)
val mskillAtramentousLibations_2965 = MobSkillId(2965)
val mskillNoahionto_2966 = MobSkillId(2966)
val mskillShockiavona_2967 = MobSkillId(2967)
val mskillHemorrhaze_2968 = MobSkillId(2968)
val mskill_2969 = MobSkillId(2969)
val mskill_2970 = MobSkillId(2970)
val mskill_2971 = MobSkillId(2971)
val mskill_2972 = MobSkillId(2972)
val mskill_2973 = MobSkillId(2973)
val mskillInspirit_2974 = MobSkillId(2974)
val mskillDebonairRush_2975 = MobSkillId(2975)
val mskillIridalPierce_2976 = MobSkillId(2976)
val mskillLunarRevolution_2977 = MobSkillId(2977)
val mskillNullifyingDropkick_2978 = MobSkillId(2978)
val mskillAuroralUppercut_2979 = MobSkillId(2979)
val mskillKnuckleSandwich_2980 = MobSkillId(2980)
val mskillVictoryBeacon_2981 = MobSkillId(2981)
val mskillSalamanderFlame_2982 = MobSkillId(2982)
val mskillTyphonicArrow_2983 = MobSkillId(2983)
val mskillMeteoricImpact_2984 = MobSkillId(2984)
val mskillShiningSalvo_2985 = MobSkillId(2985)
val mskillPallingSalvo_2986 = MobSkillId(2986)
val mskillImperialAuthority_2987 = MobSkillId(2987)
val mskillSixthElement_2988 = MobSkillId(2988)
val mskillShieldSubverter_2989 = MobSkillId(2989)
val mskillAbsoluteTerror_2990 = MobSkillId(2990)
val mskillTerricBreath_2991 = MobSkillId(2991)
val mskillAmatsuKagamikaeshi_2992 = MobSkillId(2992)
val mskillAmatsuMizumari_2993 = MobSkillId(2993)
val mskill_2994 = MobSkillId(2994)
val mskillAmatsuShirahadori_2995 = MobSkillId(2995)
val mskillBisection_2996 = MobSkillId(2996)
val mskillLeadenSalute_2997 = MobSkillId(2997)
val mskillAkimboShot_2998 = MobSkillId(2998)
val mskillGrislyHorizon_2999 = MobSkillId(2999)
val mskillHaneFubuki_3000 = MobSkillId(3000)
val mskillShibaraku_3001 = MobSkillId(3001)
val mskillShikonoMitate_3002 = MobSkillId(3002)
val mskillHappobarai_3003 = MobSkillId(3003)
val mskillRinpyotosha_3004 = MobSkillId(3004)
val mskillBombToss_3005 = MobSkillId(3005)
val mskillGoblinRush_3006 = MobSkillId(3006)
val mskillBearKiller_3007 = MobSkillId(3007)
val mskillSalvationScythe_3008 = MobSkillId(3008)
val mskillElementalSforzo_3009 = MobSkillId(3009)
val mskillLiement_3010 = MobSkillId(3010)
val mskill_3011 = MobSkillId(3011)
val mskill_3012 = MobSkillId(3012)
val mskill_3013 = MobSkillId(3013)
val mskill_3014 = MobSkillId(3014)
val mskill_3015 = MobSkillId(3015)
val mskill_3016 = MobSkillId(3016)
val mskill_3017 = MobSkillId(3017)
val mskill_3018 = MobSkillId(3018)
val mskillBurningMemories_3019 = MobSkillId(3019)
val mskillKagedourou_3020 = MobSkillId(3020)
val mskillKarakuridourou_3021 = MobSkillId(3021)
val mskillTsujikaze_3022 = MobSkillId(3022)
val mskillSleepytimeBoomboom_3023 = MobSkillId(3023)
val mskillSmelledItandDealtIt_3024 = MobSkillId(3024)
val mskillSomnicShell_3025 = MobSkillId(3025)
val mskillContaminatingConcoction_3026 = MobSkillId(3026)
val mskillIniquitousStab_3027 = MobSkillId(3027)
val mskillShockstormEdge_3028 = MobSkillId(3028)
val mskillChoreographedCarnage_3029 = MobSkillId(3029)
val mskillLockandLoad_3030 = MobSkillId(3030)
val mskillLunge_3031 = MobSkillId(3031)
val mskillSwathofSilence_3032 = MobSkillId(3032)
val mskillDamningEdict_3033 = MobSkillId(3033)
val mskillBowelsofAgony_3034 = MobSkillId(3034)
val mskillStagsCall_3035 = MobSkillId(3035)
val mskillGyreStrike_3036 = MobSkillId(3036)
val mskillStagsCharge_3037 = MobSkillId(3037)
val mskillOrcsbane_3038 = MobSkillId(3038)
val mskillSongbirdSwoop_3039 = MobSkillId(3039)
val mskillTemblorBlade_3040 = MobSkillId(3040)
val mskillCobraClamp_3041 = MobSkillId(3041)
val mskillIllustriousAid_3042 = MobSkillId(3042)
val mskill_3043 = MobSkillId(3043)
val mskill_3044 = MobSkillId(3044)
val mskill_3045 = MobSkillId(3045)
val mskill_3046 = MobSkillId(3046)
val mskillFeastofArrows_3047 = MobSkillId(3047)
val mskillCruelJoke_3048 = MobSkillId(3048)
val mskillRegurgitatedSwarm_3049 = MobSkillId(3049)
val mskillSettingtheStage_3050 = MobSkillId(3050)
val mskillLastLaugh_3051 = MobSkillId(3051)
val mskillThornedStance_3052 = MobSkillId(3052)
val mskillSensualDance_3053 = MobSkillId(3053)
val mskillDancersFury_3054 = MobSkillId(3054)
val mskillWhirlingEdge_3055 = MobSkillId(3055)
val mskillRousingSamba_3056 = MobSkillId(3056)
val mskillVivifyingWaltz_3057 = MobSkillId(3057)
val mskillTrueStrike_3058 = MobSkillId(3058)
val mskillHexaStrike_3059 = MobSkillId(3059)
val mskillGlutinousDart_3060 = MobSkillId(3060)
val mskillDeathSpin_3061 = MobSkillId(3061)
val mskillVelkkanPygmachia_3062 = MobSkillId(3062)
val mskillSaurianSlide_3063 = MobSkillId(3063)
val mskillJungleWallop_3064 = MobSkillId(3064)
val mskill_3065 = MobSkillId(3065)
val mskillCriticalMass_3066 = MobSkillId(3066)
val mskillFieryTailings_3067 = MobSkillId(3067)
val mskillMeteorStrike_3068 = MobSkillId(3068)
val mskillInferno_3069 = MobSkillId(3069)
val mskillWindBlade_3070 = MobSkillId(3070)
val mskillAerialBlast_3071 = MobSkillId(3071)
val mskillHeavenlyStrike_3072 = MobSkillId(3072)
val mskillDiamondDust_3073 = MobSkillId(3073)
val mskillThunderstorm_3074 = MobSkillId(3074)
val mskillJudgmentBolt_3075 = MobSkillId(3075)
val mskillGeocrush_3076 = MobSkillId(3076)
val mskillEarthenFury_3077 = MobSkillId(3077)
val mskillGrandFall_3078 = MobSkillId(3078)
val mskillTidalWave_3079 = MobSkillId(3079)
val mskillHowlingMoon_3080 = MobSkillId(3080)
val mskillLunarBay_3081 = MobSkillId(3081)
val mskillChaosBlast_3082 = MobSkillId(3082)
val mskillOblivionsMantle_3083 = MobSkillId(3083)
val mskillDarkMoon_3084 = MobSkillId(3084)
val mskillDarkSun_3085 = MobSkillId(3085)
val mskillDarkThorn_3086 = MobSkillId(3086)
val mskillDuranceWhip_3087 = MobSkillId(3087)
val mskill_3088 = MobSkillId(3088)
val mskillDarkFlare_3089 = MobSkillId(3089)
val mskillDarkFreeze_3090 = MobSkillId(3090)
val mskillDarkTornado_3091 = MobSkillId(3091)
val mskillDarkQuake_3092 = MobSkillId(3092)
val mskillDarkBurst_3093 = MobSkillId(3093)
val mskillDarkFlood_3094 = MobSkillId(3094)
val mskillWildOats_3095 = MobSkillId(3095)
val mskillPhotosynthesis_3096 = MobSkillId(3096)
val mskillPetalPirouette_3097 = MobSkillId(3097)
val mskillHeadButt_3098 = MobSkillId(3098)
val mskillBlow_3099 = MobSkillId(3099)
val mskillUppercut_3100 = MobSkillId(3100)
val mskillAntiphase_3101 = MobSkillId(3101)
val mskillBlankGaze_3102 = MobSkillId(3102)
val mskill_3103 = MobSkillId(3103)
val mskill_3104 = MobSkillId(3104)
val mskill_3105 = MobSkillId(3105)
val mskill_3106 = MobSkillId(3106)
val mskillTearingGust_3107 = MobSkillId(3107)
val mskillConcussiveShock_3108 = MobSkillId(3108)
val mskillChokehold_3109 = MobSkillId(3109)
val mskillZap_3110 = MobSkillId(3110)
val mskillShriekingGale_3111 = MobSkillId(3111)
val mskillUndulatingShockwave_3112 = MobSkillId(3112)
val mskill_3113 = MobSkillId(3113)
val mskill_3114 = MobSkillId(3114)
val mskill_3115 = MobSkillId(3115)
val mskillCesspool_3116 = MobSkillId(3116)
val mskillFetidEddies_3117 = MobSkillId(3117)
val mskillNullifyingRain_3118 = MobSkillId(3118)
val mskillNoyade_3119 = MobSkillId(3119)
val mskillClobberingWave_3120 = MobSkillId(3120)
val mskill_3121 = MobSkillId(3121)
val mskill_3122 = MobSkillId(3122)
val mskill_3123 = MobSkillId(3123)
val mskillStartfromScratch_3124 = MobSkillId(3124)
val mskillFrenziedThrust_3125 = MobSkillId(3125)
val mskillSinnersCross_3126 = MobSkillId(3126)
val mskillOpenCoffin_3127 = MobSkillId(3127)
val mskillRavenousAssault_3128 = MobSkillId(3128)
val mskillHemocladis_3129 = MobSkillId(3129)
val mskill_3130 = MobSkillId(3130)
val mskill_3131 = MobSkillId(3131)
val mskill_3132 = MobSkillId(3132)
val mskillFulminousSmash_3133 = MobSkillId(3133)
val mskillFlamingKick_3134 = MobSkillId(3134)
val mskillIcyGrasp_3135 = MobSkillId(3135)
val mskillFlashflood_3136 = MobSkillId(3136)
val mskillErodingFlesh_3137 = MobSkillId(3137)
val mskillVivisection_3138 = MobSkillId(3138)
val mskill_3139 = MobSkillId(3139)
val mskill_3140 = MobSkillId(3140)
val mskill_3141 = MobSkillId(3141)
val mskill_3142 = MobSkillId(3142)
val mskillImpudence_3143 = MobSkillId(3143)
val mskillIncessantVoid_3144 = MobSkillId(3144)
val mskillTenebrousGrip_3145 = MobSkillId(3145)
val mskillDemonfire_3146 = MobSkillId(3146)
val mskillFrozenBlood_3147 = MobSkillId(3147)
val mskillBlastofReticence_3148 = MobSkillId(3148)
val mskillEnsepulcher_3149 = MobSkillId(3149)
val mskillCeaselessSurge_3150 = MobSkillId(3150)
val mskillTorrentialPain_3151 = MobSkillId(3151)
val mskillEternalMisery_3152 = MobSkillId(3152)
val mskillCripplingAgony_3153 = MobSkillId(3153)
val mskillBaneofTartarus_3154 = MobSkillId(3154)
val mskillPowerSlash_3155 = MobSkillId(3155)
val mskillFreezebite_3156 = MobSkillId(3156)
val mskillCombo_3157 = MobSkillId(3157)
val mskillOneIlmPunch_3158 = MobSkillId(3158)
val mskillHowlingFist_3159 = MobSkillId(3159)
val mskillDragonKick_3160 = MobSkillId(3160)
val mskillAsuranFists_3161 = MobSkillId(3161)
val mskillAmatsuTorimai_3162 = MobSkillId(3162)
val mskillAmatsuKazakiri_3163 = MobSkillId(3163)
val mskillAmatsuYukiarashi_3164 = MobSkillId(3164)
val mskillAmatsuTsukioboro_3165 = MobSkillId(3165)
val mskillAmatsuHanaikusa_3166 = MobSkillId(3166)
val mskillWaspSting_3167 = MobSkillId(3167)
val mskillDancingEdge_3168 = MobSkillId(3168)
val mskillFlatBlade_3169 = MobSkillId(3169)
val mskillStinkBomb_3170 = MobSkillId(3170)
val mskillNectarousDeluge_3171 = MobSkillId(3171)
val mskillNepenthicPlunge_3172 = MobSkillId(3172)
val mskillGuidingLight_3173 = MobSkillId(3173)
val mskillUpgrowth_3174 = MobSkillId(3174)
val mskillFastBlade_3175 = MobSkillId(3175)
val mskillSavageBlade_3176 = MobSkillId(3176)
val mskillSheepSong_3177 = MobSkillId(3177)
val mskillTachiKamai_3178 = MobSkillId(3178)
val mskillIainuki_3179 = MobSkillId(3179)
val mskillTachiGoten_3180 = MobSkillId(3180)
val mskillTachiKasha_3181 = MobSkillId(3181)
val mskillDragonBreath_3182 = MobSkillId(3182)
val mskillHurricaneWing_3183 = MobSkillId(3183)
val mskillPocketSand_3184 = MobSkillId(3184)
val mskillTripeGripe_3185 = MobSkillId(3185)
val mskillSharpEye_3186 = MobSkillId(3186)
val mskillGloeosuccus_3187 = MobSkillId(3187)
val mskillAfflatusMisery_3188 = MobSkillId(3188)
val mskillMercilessStrike_3189 = MobSkillId(3189)
val mskillVillainousRebuke_3190 = MobSkillId(3190)
val mskillStygianRelease_3191 = MobSkillId(3191)
val mskillUppercut_3192 = MobSkillId(3192)
val mskillInfernalBulwark_3193 = MobSkillId(3193)
val mskillEarthbreaker_3194 = MobSkillId(3194)
val mskillDynasticGravitas_3195 = MobSkillId(3195)
val mskillIllustriousAid_3196 = MobSkillId(3196)
val mskillGuidingLight_3197 = MobSkillId(3197)
val mskillComingUpRoses_3198 = MobSkillId(3198)
val mskillBloodyBreath_3205 = MobSkillId(3205)
val mskillExcessivelyBadBreath_3206 = MobSkillId(3206)
val mskillParalyzingMicrotube_3210 = MobSkillId(3210)
val mskillSilencingMicrotube_3211 = MobSkillId(3211)
val mskillBindingMicrotube_3212 = MobSkillId(3212)
val mskillTwirlingDervish_3213 = MobSkillId(3213)
val mskillGreatWheel_3214 = MobSkillId(3214)
val mskillLightBlade_3215 = MobSkillId(3215)
val mskillVortex_3216 = MobSkillId(3216)
val mskillStellarBurst_3217 = MobSkillId(3217)
val mskillBubbleCurtain_3218 = MobSkillId(3218)
val mskillMetallicBody_3219 = MobSkillId(3219)
val mskillVenomStorm_3220 = MobSkillId(3220)
val mskillVenomSting_3221 = MobSkillId(3221)
val mskillVenomBreath_3222 = MobSkillId(3222)
val mskillElementalSforzo_3223 = MobSkillId(3223)
val mskillMikage_3224 = MobSkillId(3224)
val mskillAzureLore_3225 = MobSkillId(3225)
val mskillBolster_3226 = MobSkillId(3226)
val mskillScissorGuard_3227 = MobSkillId(3227)
val mskillHemorrhaze_3228 = MobSkillId(3228)
val mskillRegulator_3229 = MobSkillId(3229)
val mskillTongueLash_3230 = MobSkillId(3230)
val mskillSidewinder_3231 = MobSkillId(3231)
val mskillArchingArrow_3232 = MobSkillId(3232)
val mskillStellarArrow_3233 = MobSkillId(3233)
val mskillLuxArrow_3234 = MobSkillId(3234)
val mskillGrapeshot_3235 = MobSkillId(3235)
val mskillPiratePummel_3236 = MobSkillId(3236)
val mskillPowderKeg_3237 = MobSkillId(3237)
val mskillWalkthePlank_3238 = MobSkillId(3238)
val mskillGroundStrike_3239 = MobSkillId(3239)
val mskillHollowSmite_3240 = MobSkillId(3240)
val mskillSarvasStorm_3241 = MobSkillId(3241)
val mskillSarvasStorm_3242 = MobSkillId(3242)
val mskillSoturisFury_3243 = MobSkillId(3243)
val mskillCelidonsTorment_3244 = MobSkillId(3244)
val mskillTachiMudo_3245 = MobSkillId(3245)
val mskillNott_3246 = MobSkillId(3246)
val mskillJusticebreaker_3247 = MobSkillId(3247)
val mskillRancidBreath_3248 = MobSkillId(3248)
val mskillGeoticSpin_3249 = MobSkillId(3249)
val mskillHellfireArrow_3250 = MobSkillId(3250)
val mskillIncensedPummel_3251 = MobSkillId(3251)
val mskill_3252 = MobSkillId(3252)
val mskill_3253 = MobSkillId(3253)
val mskill_3254 = MobSkillId(3254)
val mskillLunaticVoice_3255 = MobSkillId(3255)
val mskillSonicBuffet_3256 = MobSkillId(3256)
val mskillEntice_3257 = MobSkillId(3257)
val mskillHystericAssault_3258 = MobSkillId(3258)
val mskillClarsachCall_3259 = MobSkillId(3259)
val mskillInfectedLeech_3260 = MobSkillId(3260)
val mskillGloomSpray_3261 = MobSkillId(3261)
val mskillBloodyMist_3262 = MobSkillId(3262)
val mskillTendrilCurse_3263 = MobSkillId(3263)
val mskillFrigidPulse_3264 = MobSkillId(3264)
val mskillGatesofHades_3265 = MobSkillId(3265)
val mskillMagmaHoplon_3266 = MobSkillId(3266)
val mskillBadBreath_3267 = MobSkillId(3267)
val mskillMeteor_3268 = MobSkillId(3268)
val mskillMeteor_3269 = MobSkillId(3269)
val mskillThunderbolt_3270 = MobSkillId(3270)
val mskillBeastruction_3274 = MobSkillId(3274)
val mskillBadBreath_3275 = MobSkillId(3275)
val mskillWingsofAgony_3276 = MobSkillId(3276)
val mskillWingsofWoe_3277 = MobSkillId(3277)
val mskill_3278 = MobSkillId(3278)
val mskill_3279 = MobSkillId(3279)
val mskillSpineChiller_3280 = MobSkillId(3280)
val mskillQuietusSphere_3281 = MobSkillId(3281)
val mskillNullBlast_3282 = MobSkillId(3282)
val mskillPsychoanima_3283 = MobSkillId(3283)
val mskillHysteroanima_3284 = MobSkillId(3284)
val mskillSalaheemSpirit_3285 = MobSkillId(3285)
val mskillOisoya_3286 = MobSkillId(3286)
val mskillKnuckleSandwich_3287 = MobSkillId(3287)
val mskillWhirlingEdge_3288 = MobSkillId(3288)
val mskillTartarusTorpor_3289 = MobSkillId(3289)
val mskillUnbridledWisdom_3290 = MobSkillId(3290)
val mskillHardMembrane_3291 = MobSkillId(3291)
val mskillRegeneration_3292 = MobSkillId(3292)
val mskillSandstorm_3293 = MobSkillId(3293)
val mskillSandVeil_3294 = MobSkillId(3294)
val mskillLunarBay_3295 = MobSkillId(3295)
val mskillImpact_3296 = MobSkillId(3296)
val mskillHolyMist_3297 = MobSkillId(3297)
val mskillNightTerror_3298 = MobSkillId(3298)
val mskillRuinousOmen_3299 = MobSkillId(3299)
val mskillAmatsuFuga_3300 = MobSkillId(3300)
val mskillAmatsuKyori_3301 = MobSkillId(3301)
val mskillAmatsuHanadoki_3302 = MobSkillId(3302)
val mskillAmatsuChoun_3303 = MobSkillId(3303)
val mskillAmatsuGachirin_3304 = MobSkillId(3304)
val mskillAmatsuSuien_3305 = MobSkillId(3305)
val mskillCurtainCall_3306 = MobSkillId(3306)
val mskillDeniedProwess_3307 = MobSkillId(3307)
val mskillAethericPull_3308 = MobSkillId(3308)
val mskillNecroticWave_3309 = MobSkillId(3309)
val mskillShearingGale_3310 = MobSkillId(3310)
val mskillBecloudingDust_3311 = MobSkillId(3311)
val mskillBrewingStorm_3312 = MobSkillId(3312)
val mskillDebilitatingSurge_3313 = MobSkillId(3313)
val mskillWeightedFlux_3314 = MobSkillId(3314)
val mskillViscousDeluge_3315 = MobSkillId(3315)
val mskillLeechingVines_3316 = MobSkillId(3316)
val mskillAscension_3321 = MobSkillId(3321)
val mskillDescension_3322 = MobSkillId(3322)
val mskillExpungeMagic_3323 = MobSkillId(3323)
val mskillHarmonicDisplacement_3324 = MobSkillId(3324)
val mskillSightUnseen_3325 = MobSkillId(3325)
val mskillDarkestHour_3326 = MobSkillId(3326)
val mskillUnceasingDread_3327 = MobSkillId(3327)
val mskillDignifiedAwe_3328 = MobSkillId(3328)
val mskillNaakualsVengeance_3329 = MobSkillId(3329)
val mskillDaybreak_3334 = MobSkillId(3334)
val mskillTartaricSigil_3335 = MobSkillId(3335)
val mskillNullField_3336 = MobSkillId(3336)
val mskillAlabasterBurst_3337 = MobSkillId(3337)
val mskillNobleFrenzy_3338 = MobSkillId(3338)
val mskillFulminousFury_3339 = MobSkillId(3339)
val mskillNoQuarter_3340 = MobSkillId(3340)
val mskillRepellingShout_3346 = MobSkillId(3346)
val mskillChastise_3347 = MobSkillId(3347)
val mskillScorchingLuminescense_3348 = MobSkillId(3348)
val mskillRendingBlow_3349 = MobSkillId(3349)
val mskillViciousRake_3350 = MobSkillId(3350)
val mskillHeavensGrace_3351 = MobSkillId(3351)
val mskillDenounce_3352 = MobSkillId(3352)
val mskillRelentlessDiscord_3353 = MobSkillId(3353)
val mskillRuthlessness_3354 = MobSkillId(3354)
val mskillInexorableStrike_3355 = MobSkillId(3355)
val mskillSelfAggrandizement_3356 = MobSkillId(3356)
val mskillFeastofArrows_3361 = MobSkillId(3361)
val mskillRegurgitatedSwarm_3362 = MobSkillId(3362)
val mskillSettingtheStage_3363 = MobSkillId(3363)
val mskillLastLaugh_3364 = MobSkillId(3364)
val mskillLuminousLance_3365 = MobSkillId(3365)
val mskillRejuvenation_3366 = MobSkillId(3366)
val mskillRevelation_3367 = MobSkillId(3367)
val mskillMementoMori_3368 = MobSkillId(3368)
val mskillSilenceSeal_3369 = MobSkillId(3369)
val mskillEnvoutement_3370 = MobSkillId(3370)
val mskillBoredtoTears_3371 = MobSkillId(3371)
val mskillStartfromScratch_3375 = MobSkillId(3375)
val mskillFrenziedThrust_3376 = MobSkillId(3376)
val mskillSinnersCross_3377 = MobSkillId(3377)
val mskillOpenCoffin_3378 = MobSkillId(3378)
val mskillRavenousAssault_3379 = MobSkillId(3379)
val mskillHemocladis_3380 = MobSkillId(3380)
val mskillShiningSummerSamba_3381 = MobSkillId(3381)
val mskillLovelyMiracleWaltz_3382 = MobSkillId(3382)
val mskillNeoCrystalJig_3383 = MobSkillId(3383)
val mskillSuperCrusherJig_3384 = MobSkillId(3384)
val mskillEternalVanaIllusion_3385 = MobSkillId(3385)
val mskillFinalEternalHeart_3386 = MobSkillId(3386)
val mskillFiresdayNightFever_3387 = MobSkillId(3387)
val mskillRuthlessness_3388 = MobSkillId(3388)
val mskillInexorableStrike_3389 = MobSkillId(3389)
val mskillSelfAggrandizement_3390 = MobSkillId(3390)
val mskillMercilessStrike_3391 = MobSkillId(3391)
val mskillDaybreak_3396 = MobSkillId(3396)
val mskillTartaricSigil_3397 = MobSkillId(3397)
val mskillNullField_3398 = MobSkillId(3398)
val mskillAlabasterBurst_3399 = MobSkillId(3399)
val mskillNobleFrenzy_3400 = MobSkillId(3400)
val mskillFulminousFury_3401 = MobSkillId(3401)
val mskillNoQuarter_3402 = MobSkillId(3402)
val mskillBanefulBlades_3406 = MobSkillId(3406)
val mskillWildwoodIndignation_3407 = MobSkillId(3407)
val mskillDryadsKiss_3408 = MobSkillId(3408)
val mskillDepravedDandia_3409 = MobSkillId(3409)
val mskillMatriarchalFiat_3410 = MobSkillId(3410)
val mskillWingsofGehenna_3411 = MobSkillId(3411)
val mskillDecollation_3412 = MobSkillId(3412)
val mskillNosferatusKiss_3413 = MobSkillId(3413)
val mskillHeliovoid_3414 = MobSkillId(3414)
val mskillDeepSeaDirge_3415 = MobSkillId(3415)
val mskillIllustriousAid_3416 = MobSkillId(3416)
val mskill_3417 = MobSkillId(3417)
val mskill_3418 = MobSkillId(3418)
val mskill_3419 = MobSkillId(3419)
val mskillVehementResolution_3420 = MobSkillId(3420)
val mskillCamaraderieoftheCrevasse_3421 = MobSkillId(3421)
val mskillIntotheLight_3422 = MobSkillId(3422)
val mskillArduousDecision_3423 = MobSkillId(3423)
val mskill12BladesofRemorse_3424 = MobSkillId(3424)
val mskill_3425 = MobSkillId(3425)
val mskill_3426 = MobSkillId(3426)
val mskill_3427 = MobSkillId(3427)
val mskillAurousCharge_3428 = MobSkillId(3428)
val mskillHowlingGust_3429 = MobSkillId(3429)
val mskillRighteousRasp_3430 = MobSkillId(3430)
val mskillStarwardYowl_3431 = MobSkillId(3431)
val mskillStalkingPrey_3432 = MobSkillId(3432)
val mskillShuffle_3433 = MobSkillId(3433)
val mskillDoubleDown_3434 = MobSkillId(3434)
val mskillBludgeon_3435 = MobSkillId(3435)
val mskillDealOut_3436 = MobSkillId(3436)
val mskill_3437 = MobSkillId(3437)
val mskill_3438 = MobSkillId(3438)
val mskill_3439 = MobSkillId(3439)
val mskill_3440 = MobSkillId(3440)
val mskillAscension_3441 = MobSkillId(3441)
val mskillDescension_3442 = MobSkillId(3442)
val mskillExpungeMagic_3443 = MobSkillId(3443)
val mskillHarmonicDisplacement_3444 = MobSkillId(3444)
val mskillSightUnseen_3445 = MobSkillId(3445)
val mskillDarkestHour_3446 = MobSkillId(3446)
val mskillUnceasingDread_3447 = MobSkillId(3447)
val mskillDignifiedAwe_3448 = MobSkillId(3448)
val mskillNaakualsVengeance_3449 = MobSkillId(3449)
val mskillCrossReaver_3450 = MobSkillId(3450)
val mskillCircleBlade_3451 = MobSkillId(3451)
val mskillSwiftBlade_3452 = MobSkillId(3452)
val mskillChantduCygne_3453 = MobSkillId(3453)
val mskillArroganceIncarnate_3454 = MobSkillId(3454)
val mskillVorpalBlade_3455 = MobSkillId(3455)
val mskillDominionSlash_3456 = MobSkillId(3456)
val mskillChantduCygne_3457 = MobSkillId(3457)
val mskillShieldStrike_3458 = MobSkillId(3458)
val mskillRampage_3459 = MobSkillId(3459)
val mskillCalamity_3460 = MobSkillId(3460)
val mskillHavocSpiral_3461 = MobSkillId(3461)
val mskillCloudsplitter_3462 = MobSkillId(3462)
val mskillSpinningScythe_3463 = MobSkillId(3463)
val mskillAmonDrive_3464 = MobSkillId(3464)
val mskillGuillotine_3465 = MobSkillId(3465)
val mskillTachiYukikaze_3466 = MobSkillId(3466)
val mskillTachiGekko_3467 = MobSkillId(3467)
val mskillDragonfall_3468 = MobSkillId(3468)
val mskillTachiKasha_3469 = MobSkillId(3469)
val mskillTachiFudo_3470 = MobSkillId(3470)
val mskillDisorientingWaul_3471 = MobSkillId(3471)
val mskillArroganceIncarnate_3472 = MobSkillId(3472)
val mskillAmonDrive_3473 = MobSkillId(3473)
val mskillSelfDestruct_3474 = MobSkillId(3474)
val mskillSelfDestruct_3475 = MobSkillId(3475)
val mskillAmatsuFuga_3476 = MobSkillId(3476)
val mskillAmatsuKyori_3477 = MobSkillId(3477)
val mskillAmatsuHanadoki_3478 = MobSkillId(3478)
val mskillAmatsuChoun_3479 = MobSkillId(3479)
val mskillAmatsuGachirin_3480 = MobSkillId(3480)
val mskillAmatsuSuien_3481 = MobSkillId(3481)
val mskillRiseFromAshes_3482 = MobSkillId(3482)
val mskill_Shantotto2_3483 = MobSkillId(3483)
val mskillFinalExam_3484 = MobSkillId(3484)
val mskillDoctorsOrders_3485 = MobSkillId(3485)
val mskillEmpiricalResearch_3486 = MobSkillId(3486)
val mskillLessoninPain_3487 = MobSkillId(3487)
val mskillPeccantTyphoon_3488 = MobSkillId(3488)
val mskillCensure_3489 = MobSkillId(3489)
val mskillOsmoticWave_3490 = MobSkillId(3490)
val mskill_3491 = MobSkillId(3491)
val mskill_3492 = MobSkillId(3492)
val mskill_3493 = MobSkillId(3493)
val mskillShearingUndulation_3494 = MobSkillId(3494)
val mskillCellingRupture_3495 = MobSkillId(3495)
val mskillDestitution_3496 = MobSkillId(3496)
val mskillEssenceDevour_3497 = MobSkillId(3497)
val mskillPrimordialSurge_3498 = MobSkillId(3498)
val mskillWaningVigor_3499 = MobSkillId(3499)
val mskillExpunge_3500 = MobSkillId(3500)
val mskillDisembowel_3501 = MobSkillId(3501)
val mskillVertigo_3502 = MobSkillId(3502)
val mskillExtirpatingSalvo_3503 = MobSkillId(3503)
val mskillBeguilingGaze_3504 = MobSkillId(3504)
val mskillBackdraft_3505 = MobSkillId(3505)
val mskillCordonofApathy_3506 = MobSkillId(3506)
val mskillDiscordantNote_3507 = MobSkillId(3507)
val mskillTelsonicTempest_3508 = MobSkillId(3508)
val mskillMementoMori_3509 = MobSkillId(3509)
val mskillDeathTrap_3510 = MobSkillId(3510)
val mskillMogShrapnel_3511 = MobSkillId(3511)
val mskillMogBomb_3512 = MobSkillId(3512)
val mskillFlowerpot_3513 = MobSkillId(3513)
val mskillSomnicShell_3514 = MobSkillId(3514)
val mskillAbsoluteTerror_3515 = MobSkillId(3515)
val mskillHorridRoar_3516 = MobSkillId(3516)
val mskillCycloneWing_3517 = MobSkillId(3517)
val mskillSableBreath_3518 = MobSkillId(3518)
val mskillCycloneWing_3519 = MobSkillId(3519)
val mskillTouchdown_3520 = MobSkillId(3520)
val mskillAbsoluteTerror_3521 = MobSkillId(3521)
val mskillHorridRoar_3522 = MobSkillId(3522)
val mskillGregaleWing_3523 = MobSkillId(3523)
val mskillGlacialBreath_3524 = MobSkillId(3524)
val mskillGregaleWing_3525 = MobSkillId(3525)
val mskillTouchdown_3526 = MobSkillId(3526)
val mskillAbsoluteTerror_3527 = MobSkillId(3527)
val mskillHorridRoar_3528 = MobSkillId(3528)
val mskillTebbadWing_3529 = MobSkillId(3529)
val mskillFieryBreath_3530 = MobSkillId(3530)
val mskillTebbadWing_3531 = MobSkillId(3531)
val mskillTouchdown_3532 = MobSkillId(3532)
val mskillCharm_3533 = MobSkillId(3533)
val mskillMogShrapnel_3534 = MobSkillId(3534)
val mskillRoyalDecree_3535 = MobSkillId(3535)
val mskill_3536 = MobSkillId(3536)
val mskillDoomvoid_3537 = MobSkillId(3537)
val mskillLeafDagger_3538 = MobSkillId(3538)
val mskillRakshaVengeance_3539 = MobSkillId(3539)
val mskillDemonicFlower_3540 = MobSkillId(3540)
val mskillMineBlast_3541 = MobSkillId(3541)
val mskillBadBreath_3542 = MobSkillId(3542)
val mskillSweetBreath_3543 = MobSkillId(3543)
val mskillHeatBreath_3544 = MobSkillId(3544)
val mskillRiddle_3545 = MobSkillId(3545)
val mskillDeadlyHold_3546 = MobSkillId(3546)
val mskillTailSwing_3547 = MobSkillId(3547)
val mskillTailSmash_3548 = MobSkillId(3548)
val mskillGreatSandstorm_3549 = MobSkillId(3549)
val mskillGreatWhirlwind_3550 = MobSkillId(3550)
val mskillShinZantetsuken_3551 = MobSkillId(3551)
val mskillZantetsukenJin_3552 = MobSkillId(3552)
val mskillGospeloftheLost_3553 = MobSkillId(3553)
val mskillVoidofRepentance_3554 = MobSkillId(3554)
val mskillPerfectDefense_3555 = MobSkillId(3555)
val mskillSacredCaper_3556 = MobSkillId(3556)
val mskillPhototrophicBlessing_3557 = MobSkillId(3557)
val mskillPhototrophicWrath_3558 = MobSkillId(3558)
val mskillDeificGambol_3559 = MobSkillId(3559)
val mskillChemicalBombII_3560 = MobSkillId(3560)
val mskillDeathSentence_3561 = MobSkillId(3561)
val mskillSacredCaper_3562 = MobSkillId(3562)
val mskillPhototrophicBlessing_3563 = MobSkillId(3563)
val mskillPhototrophicWrath_3564 = MobSkillId(3564)
val mskillDeificGambol_3565 = MobSkillId(3565)
val mskillGalumph_3566 = MobSkillId(3566)
val mskillCroctastrophe_3567 = MobSkillId(3567)
val mskillSaurianSlide_3568 = MobSkillId(3568)
val mskillJungleWallop_3569 = MobSkillId(3569)
val mskillSaurianSlide_3570 = MobSkillId(3570)
val mskillJungleWallop_3571 = MobSkillId(3571)
val mskillConcentricPulse_3572 = MobSkillId(3572)
val mskillFootKick_3584 = MobSkillId(3584)
val mskillDustCloud_3585 = MobSkillId(3585)
val mskillWhirlClaws_3586 = MobSkillId(3586)
val mskillHeadButt_3587 = MobSkillId(3587)
val mskillDreamFlower_3588 = MobSkillId(3588)
val mskillWildOats_3589 = MobSkillId(3589)
val mskillLeafDagger_3590 = MobSkillId(3590)
val mskillScream_3591 = MobSkillId(3591)
val mskillRoar_3592 = MobSkillId(3592)
val mskillRazorFang_3593 = MobSkillId(3593)
val mskillClawCyclone_3594 = MobSkillId(3594)
val mskillTailBlow_3595 = MobSkillId(3595)
val mskillFireball_3596 = MobSkillId(3596)
val mskillBlockhead_3597 = MobSkillId(3597)
val mskillBrainCrush_3598 = MobSkillId(3598)
val mskillInfrasonics_3599 = MobSkillId(3599)
val mskillSecretion_3600 = MobSkillId(3600)
val mskillLambChop_3601 = MobSkillId(3601)
val mskillRage_3602 = MobSkillId(3602)
val mskillSheepCharge_3603 = MobSkillId(3603)
val mskillSheepSong_3604 = MobSkillId(3604)
val mskillBubbleShower_3605 = MobSkillId(3605)
val mskillBubbleCurtain_3606 = MobSkillId(3606)
val mskillBigScissors_3607 = MobSkillId(3607)
val mskillScissorGuard_3608 = MobSkillId(3608)
val mskillMetallicBody_3609 = MobSkillId(3609)
val mskillNeedleshot_3610 = MobSkillId(3610)
val mskillNeedles_3611 = MobSkillId(3611)
val mskillFrogkick_3612 = MobSkillId(3612)
val mskillSpore_3613 = MobSkillId(3613)
val mskillQueasyshroom_3614 = MobSkillId(3614)
val mskillNumbshroom_3615 = MobSkillId(3615)
val mskillShakeshroom_3616 = MobSkillId(3616)
val mskillSilenceGas_3617 = MobSkillId(3617)
val mskillDarkSpore_3618 = MobSkillId(3618)
val mskillPowerAttack_3619 = MobSkillId(3619)
val mskillHiFreqField_3620 = MobSkillId(3620)
val mskillRhinoAttack_3621 = MobSkillId(3621)
val mskillRhinoGuard_3622 = MobSkillId(3622)
val mskillSpoil_3623 = MobSkillId(3623)
val mskillCursedSphere_3624 = MobSkillId(3624)
val mskillVenom_3625 = MobSkillId(3625)
val mskillSandblast_3626 = MobSkillId(3626)
val mskillSandpit_3627 = MobSkillId(3627)
val mskillVenomSpray_3628 = MobSkillId(3628)
val mskillMandibularBite_3629 = MobSkillId(3629)
val mskillSoporific_3630 = MobSkillId(3630)
val mskillGloeosuccus_3631 = MobSkillId(3631)
val mskillPalsyPollen_3632 = MobSkillId(3632)
val mskillGeistWall_3633 = MobSkillId(3633)
val mskillNumbingNoise_3634 = MobSkillId(3634)
val mskillNimbleSnap_3635 = MobSkillId(3635)
val mskillCyclotail_3636 = MobSkillId(3636)
val mskillToxicSpit_3637 = MobSkillId(3637)
val mskillDoubleClaw_3638 = MobSkillId(3638)
val mskillGrapple_3639 = MobSkillId(3639)
val mskillFilamentedHold_3640 = MobSkillId(3640)
val mskillSpinningTop_3641 = MobSkillId(3641)
val mskillChaoticEye_3642 = MobSkillId(3642)
val mskillBlaster_3643 = MobSkillId(3643)
val mskillSuction_3644 = MobSkillId(3644)
val mskillDrainkiss_3645 = MobSkillId(3645)
val mskillSnowCloud_3646 = MobSkillId(3646)
val mskillWildCarrot_3647 = MobSkillId(3647)
val mskillSuddenLunge_3648 = MobSkillId(3648)
val mskillSpiralSpin_3649 = MobSkillId(3649)
val mskillNoisomePowder_3650 = MobSkillId(3650)
val mskillAcidMist_3651 = MobSkillId(3651)
val mskillTPDrainkiss_3652 = MobSkillId(3652)
val mskillScytheTail_3653 = MobSkillId(3653)
val mskillRipperFang_3654 = MobSkillId(3654)
val mskillChompRush_3655 = MobSkillId(3655)
val mskillChargedWhisker_3656 = MobSkillId(3656)
val mskillPurulentOoze_3657 = MobSkillId(3657)
val mskillCorrosiveOoze_3658 = MobSkillId(3658)
val mskillBackHeel_3659 = MobSkillId(3659)
val mskillJettatura_3660 = MobSkillId(3660)
val mskillChokeBreath_3661 = MobSkillId(3661)
val mskillFantod_3662 = MobSkillId(3662)
val mskillTortoiseStomp_3663 = MobSkillId(3663)
val mskillHardenShell_3664 = MobSkillId(3664)
val mskillAquaBreath_3665 = MobSkillId(3665)
val mskillWingSlap_3666 = MobSkillId(3666)
val mskillBeakLunge_3667 = MobSkillId(3667)
val mskillIntimidate_3668 = MobSkillId(3668)
val mskillRecoilDive_3669 = MobSkillId(3669)
val mskillWaterWall_3670 = MobSkillId(3670)
val mskillSensillaBlades_3671 = MobSkillId(3671)
val mskillTegminaBuffet_3672 = MobSkillId(3672)
val mskillMoltingPlumage_3673 = MobSkillId(3673)
val mskillSwoopingFrenzy_3674 = MobSkillId(3674)
val mskillSweepingGouge_3675 = MobSkillId(3675)
val mskillZealousSnort_3676 = MobSkillId(3676)
val mskillPentapeck_3677 = MobSkillId(3677)
val mskillTicklingTendrils_3678 = MobSkillId(3678)
val mskillStinkBomb_3679 = MobSkillId(3679)
val mskillNectarousDeluge_3680 = MobSkillId(3680)
val mskillNepenthicPlunge_3681 = MobSkillId(3681)
val mskillSomersault_3682 = MobSkillId(3682)
val mskillFoulWaters_3683 = MobSkillId(3683)
val mskillPestilentPlume_3684 = MobSkillId(3684)
val mskillPeckingFlurry_3685 = MobSkillId(3685)
val mskillSickleSlash_3686 = MobSkillId(3686)
val mskillAcidSpray_3687 = MobSkillId(3687)
val mskillSpiderWeb_3688 = MobSkillId(3688)
val mskillInfectedLeech_3689 = MobSkillId(3689)
val mskillGloomSpray_3690 = MobSkillId(3690)
val mskillInsipidNip_3691 = MobSkillId(3691)
val mskillPandemicNip_3692 = MobSkillId(3692)
val mskillCimicineDischarge_3693 = MobSkillId(3693)
val mskillDisembowel_3694 = MobSkillId(3694)
val mskillExtirpatingSalvo_3695 = MobSkillId(3695)
val mskillVenomShower_3696 = MobSkillId(3696)
val mskillMegaScissors_3697 = MobSkillId(3697)
val mskillFrenziedRage_3698 = MobSkillId(3698)
val mskillRhinowrecker_3699 = MobSkillId(3699)
val mskillFluidToss_3700 = MobSkillId(3700)
val mskillFluidSpread_3701 = MobSkillId(3701)
val mskillDigest_3702 = MobSkillId(3702)
val mskillCrossthrash_3703 = MobSkillId(3703)
val mskillPredatoryGlare_3704 = MobSkillId(3704)
val mskillHoofVolley_3705 = MobSkillId(3705)
val mskillNihilitySong_3706 = MobSkillId(3706)
val mskillAutoAttack1_3712 = MobSkillId(3712)
val mskillAutoAttack2_3713 = MobSkillId(3713)
val mskillAutoAttack3_3714 = MobSkillId(3714)
val mskillTurbineCyclone_3715 = MobSkillId(3715)
val mskillGrandSeismicImpact_3716 = MobSkillId(3716)
val mskillFireArmCannon_3717 = MobSkillId(3717)
val mskillEradicator_3718 = MobSkillId(3718)
val mskillIceIncinerator_3719 = MobSkillId(3719)
val mskillBallisticDoubleKick_3720 = MobSkillId(3720)
val mskillScapulaBeam_3721 = MobSkillId(3721)
val mskillAugurSmash_3722 = MobSkillId(3722)
val mskillAreaBombardment_3723 = MobSkillId(3723)
val mskillCauterizingField_3724 = MobSkillId(3724)
val mskillCauterizingField_3725 = MobSkillId(3725)
val mskillTurbineCyclone_3726 = MobSkillId(3726)
val mskillAutoAttack1_3727 = MobSkillId(3727)
val mskillAutoAttack2_3728 = MobSkillId(3728)
val mskillAutoAttack3_3729 = MobSkillId(3729)
val mskillHeadButt_3776 = MobSkillId(3776)
val mskillDreamFlower_3777 = MobSkillId(3777)
val mskillWildOats_3778 = MobSkillId(3778)
val mskillPhotosynthesis_3779 = MobSkillId(3779)
val mskillLeafDagger_3780 = MobSkillId(3780)
val mskillScream_3781 = MobSkillId(3781)
val mskillPetalPirouette_3782 = MobSkillId(3782)
val mskill_3783 = MobSkillId(3783)
val mskillFatalScream_3784 = MobSkillId(3784)
val mskillPainSync_3840 = MobSkillId(3840)
val mskillViewSync_3841 = MobSkillId(3841)
val mskillBlessingSync_3842 = MobSkillId(3842)
val mskillTarget_3843 = MobSkillId(3843)
val mskillEleventhDimension_3844 = MobSkillId(3844)
val mskillSuppressiveSphere_3845 = MobSkillId(3845)
val mskillZeroHour_3846 = MobSkillId(3846)
val mskillDancingFullers_3847 = MobSkillId(3847)
val mskillUnfalteringBravado_3848 = MobSkillId(3848)
val mskillEbullientNullification_3849 = MobSkillId(3849)
val mskillGardez_3850 = MobSkillId(3850)
val mskillProphylaxis_3851 = MobSkillId(3851)
val mskillEternalVanaIllusion_3852 = MobSkillId(3852)
val mskillFiresdayNightFever_3853 = MobSkillId(3853)
val mskillShiningEpilogue_3854 = MobSkillId(3854)
val mskillHandofUllegore_3855 = MobSkillId(3855)
val mskillUllegoresSmash_3856 = MobSkillId(3856)
val mskillUllegoresDullness_3857 = MobSkillId(3857)
val mskillEternalVanaDullness_3858 = MobSkillId(3858)
val mskillShriek_3859 = MobSkillId(3859)
val mskillBilateralShield_3860 = MobSkillId(3860)
val mskillCycloneSlice_3861 = MobSkillId(3861)
val mskillFullOnTackle_3862 = MobSkillId(3862)
val mskillYarkhushta_3863 = MobSkillId(3863)
val mskillFlailingBlow_3864 = MobSkillId(3864)
val mskillRepulsor_3865 = MobSkillId(3865)
val mskillSanguineBlessing_3866 = MobSkillId(3866)
val mskillAetherwell_3867 = MobSkillId(3867)
val mskillBombToss_3868 = MobSkillId(3868)
val mskillFrypan_3869 = MobSkillId(3869)
val mskillCharm_3870 = MobSkillId(3870)
val mskillOreHurl_3871 = MobSkillId(3871)
val mskillHellWhirl_3872 = MobSkillId(3872)
val mskillThousandFists_3873 = MobSkillId(3873)
val mskillFeatherFusillade_3874 = MobSkillId(3874)
val mskillDoublePunt_3875 = MobSkillId(3875)
val mskillRiposte_3876 = MobSkillId(3876)
val mskillStroke_3877 = MobSkillId(3877)
val mskillGutturalRoar_3878 = MobSkillId(3878)
val mskillPristineEvasion_3879 = MobSkillId(3879)
val mskillVorticoseSands_3880 = MobSkillId(3880)
val mskillGoblinFrenzy_3881 = MobSkillId(3881)
val mskillBombHurl_3882 = MobSkillId(3882)
val mskillCrockpot_3883 = MobSkillId(3883)
val mskillSmokeVeil_3884 = MobSkillId(3884)
val mskillCracklingCandle_3885 = MobSkillId(3885)
val mskillNumbingShower_3886 = MobSkillId(3886)
val mskillFixedDice_3887 = MobSkillId(3887)
val mskillFixedDice_3888 = MobSkillId(3888)
val mskillFixedDice_3889 = MobSkillId(3889)
val mskillFixedDice_3890 = MobSkillId(3890)
val mskillFixedDice_3891 = MobSkillId(3891)
val mskillFixedDice_3892 = MobSkillId(3892)
val mskillFixedDice_3893 = MobSkillId(3893)
val mskillFixedDice_3894 = MobSkillId(3894)
val mskillFixedDice_3895 = MobSkillId(3895)
val mskillConcentricPulse_3896 = MobSkillId(3896)
val mskillWildCard_3897 = MobSkillId(3897)
val mskillActivate_3898 = MobSkillId(3898)
val mskillAghorasStorm_3899 = MobSkillId(3899)
val mskillUryanBlade_3900 = MobSkillId(3900)
val mskillNimbuscleaver_3901 = MobSkillId(3901)
val mskillBladeMetsu_3902 = MobSkillId(3902)
val mskill_3903 = MobSkillId(3903)
val mskill_3904 = MobSkillId(3904)
val mskill_3905 = MobSkillId(3905)
val mskill_3906 = MobSkillId(3906)
val mskill_3907 = MobSkillId(3907)
val mskill_3908 = MobSkillId(3908)
val mskill_3909 = MobSkillId(3909)
val mskill_3910 = MobSkillId(3910)
val mskillKathwack_3911 = MobSkillId(3911)
val mskillSlam_3912 = MobSkillId(3912)
val mskillBoobyPrize_3913 = MobSkillId(3913)
val mskillOfnir_3914 = MobSkillId(3914)
val mskillValfodr_3915 = MobSkillId(3915)
val mskillYggr_3916 = MobSkillId(3916)
val mskillSanngetall_3917 = MobSkillId(3917)
val mskillGeirrothr_3918 = MobSkillId(3918)
val mskillZantetsukenX_3919 = MobSkillId(3919)
val mskillHPHoly_3920 = MobSkillId(3920)
val mskillHPHoly_3921 = MobSkillId(3921)
val mskillHPHoly_3922 = MobSkillId(3922)
val mskillHPHoly_3923 = MobSkillId(3923)
val mskillHPHoly_3924 = MobSkillId(3924)
val mskillHPHoly_3925 = MobSkillId(3925)
val mskillGospeloftheLost_3926 = MobSkillId(3926)
val mskillVoidofRepentance_3927 = MobSkillId(3927)
val mskillDivineSpear_3928 = MobSkillId(3928)
val mskillMegaHoly_3929 = MobSkillId(3929)
val mskillRadiantSacrament_3930 = MobSkillId(3930)
val mskillDivineJudgment_3931 = MobSkillId(3931)
val mskillDarkThorn_3932 = MobSkillId(3932)
val mskillPetalineTempest_3933 = MobSkillId(3933)
val mskillDuranceWhip_3934 = MobSkillId(3934)
val mskillSubjugatingSlash_3935 = MobSkillId(3935)
val mskillFatalAllure_3936 = MobSkillId(3936)
val mskillMoonlightVeil_3937 = MobSkillId(3937)
val mskillDarkFlare_3938 = MobSkillId(3938)
val mskillDarkFreeze_3939 = MobSkillId(3939)
val mskillDarkTornado_3940 = MobSkillId(3940)
val mskillDarkQuake_3941 = MobSkillId(3941)
val mskillDarkBurst_3942 = MobSkillId(3942)
val mskillDarkFlood_3943 = MobSkillId(3943)
val mskillDarkMoon_3944 = MobSkillId(3944)
val mskillDarkSun_3945 = MobSkillId(3945)
val mskillAltairBullet_3946 = MobSkillId(3946)
val mskillSavageSwordhand_3947 = MobSkillId(3947)
val mskillForlornImpact_3948 = MobSkillId(3948)
val mskill_3949 = MobSkillId(3949)
val mskill_3950 = MobSkillId(3950)
val mskill_3951 = MobSkillId(3951)
val mskill_3952 = MobSkillId(3952)
val mskill_3953 = MobSkillId(3953)
val mskill_3954 = MobSkillId(3954)
val mskillIniquitousStab_3955 = MobSkillId(3955)
val mskillShockstormEdge_3956 = MobSkillId(3956)
val mskillChoreographedCarnage_3957 = MobSkillId(3957)
val mskillLockandLoad_3958 = MobSkillId(3958)
val mskillSouleater_3959 = MobSkillId(3959)
val mskillSoulEnslavement_3960 = MobSkillId(3960)
val mskillMikage_3961 = MobSkillId(3961)
val mskillFieryBreath_3962 = MobSkillId(3962)
val mskillGlacialBreath_3963 = MobSkillId(3963)
val mskillSableBreath_3964 = MobSkillId(3964)
val mskillAbyssalDrain_3965 = MobSkillId(3965)
val mskillAbyssalStrike_3966 = MobSkillId(3966)
val mskillHyperthermicBreath_3967 = MobSkillId(3967)
val mskillWingsofVengeance_3968 = MobSkillId(3968)
val mskillImposingVisage_3969 = MobSkillId(3969)
val mskillChosenFinale_3970 = MobSkillId(3970)
val mskillBitterElegy_3971 = MobSkillId(3971)
val mskillTornadoII_3972 = MobSkillId(3972)
val mskillLunaticVoice_3973 = MobSkillId(3973)
val mskillHystericAssault_3974 = MobSkillId(3974)
val mskillMixFinalElixir_3975 = MobSkillId(3975)
val mskillPotion_3976 = MobSkillId(3976)
val mskillHiPotion_3977 = MobSkillId(3977)
val mskillXPotion_3978 = MobSkillId(3978)
val mskillHyperPotion_3979 = MobSkillId(3979)
val mskillMaxPotion_3980 = MobSkillId(3980)
val mskillMixMaxPotion_3981 = MobSkillId(3981)
val mskillMixAntidote_3982 = MobSkillId(3982)
val mskillMixParabgone_3983 = MobSkillId(3983)
val mskillMixEyeDrops_3984 = MobSkillId(3984)
val mskillEchoDrops_3985 = MobSkillId(3985)
val mskillHolyWater_3986 = MobSkillId(3986)
val mskillMixVaccine_3987 = MobSkillId(3987)
val mskillMixGoldNeedle_3988 = MobSkillId(3988)
val mskillMixPanacea1_3989 = MobSkillId(3989)
val mskillAntidote_3990 = MobSkillId(3990)
val mskillMixParabgone_3991 = MobSkillId(3991)
val mskillEyeDrops_3992 = MobSkillId(3992)
val mskillEchoDrops_3993 = MobSkillId(3993)
val mskillHolyWater_3994 = MobSkillId(3994)
val mskillMixVaccine_3995 = MobSkillId(3995)
val mskillMixGoldNeedle_3996 = MobSkillId(3996)
val mskillMixPanacea1_3997 = MobSkillId(3997)
val mskillMixDryEtherConcoction_3998 = MobSkillId(3998)
val mskillMixGuardDrink_3999 = MobSkillId(3999)
val mskillMixInsomniant_4000 = MobSkillId(4000)
val mskillMixLifeWater_4001 = MobSkillId(4001)
val mskillMixElementalPower_4002 = MobSkillId(4002)
val mskillMixDragonShield_4003 = MobSkillId(4003)
val mskillMixDarkPotion_4004 = MobSkillId(4004)
val mskillMixSamsonsStrength_4005 = MobSkillId(4005)
val mskillHellTrap_4006 = MobSkillId(4006)
val mskillGloomPhantomRush_4007 = MobSkillId(4007)
val mskillMeebleWarble_4008 = MobSkillId(4008)
val mskillDazbogsDirge_4009 = MobSkillId(4009)
val mskillDazbogsFrenzy_4010 = MobSkillId(4010)
val mskillMaghBihusBlessing_4011 = MobSkillId(4011)
val mskillPumMeLingPunCh_4012 = MobSkillId(4012)
val mskillMarineMayhem_4013 = MobSkillId(4013)
val mskillTiiimbeeer_4014 = MobSkillId(4014)
val mskill_4015 = MobSkillId(4015)
val mskill_4016 = MobSkillId(4016)
val mskill_4017 = MobSkillId(4017)
val mskill_4018 = MobSkillId(4018)
val mskill_4019 = MobSkillId(4019)
val mskill_4020 = MobSkillId(4020)
val mskill_4021 = MobSkillId(4021)
val mskill_4022 = MobSkillId(4022)
val mskillUrielBlade_4023 = MobSkillId(4023)
val mskill_4024 = MobSkillId(4024)
val mskill_4025 = MobSkillId(4025)
val mskill_4026 = MobSkillId(4026)
val mskill_4027 = MobSkillId(4027)
val mskill_4028 = MobSkillId(4028)
val mskill_4029 = MobSkillId(4029)
val mskill_4030 = MobSkillId(4030)
val mskill_4031 = MobSkillId(4031)
val mskill_4032 = MobSkillId(4032)
val mskillTectonicShift_4033 = MobSkillId(4033)
val mskillDenouncement_4034 = MobSkillId(4034)
val mskillSpikeFlail_4035 = MobSkillId(4035)
val mskillSpikeFlail_4036 = MobSkillId(4036)
val mskillAutoattack1_4037 = MobSkillId(4037)
val mskillAutoattack2_4038 = MobSkillId(4038)
val mskillAutoattack3_4039 = MobSkillId(4039)
val mskillCesspool_4040 = MobSkillId(4040)
val mskillFetidEddies_4041 = MobSkillId(4041)
val mskillNullifyingRain_4042 = MobSkillId(4042)
val mskillNoyade_4043 = MobSkillId(4043)
val mskillClobberingWave_4044 = MobSkillId(4044)
val mskillAutoattack1_4045 = MobSkillId(4045)
val mskillAutoattack2_4046 = MobSkillId(4046)
val mskillAutoattack3_4047 = MobSkillId(4047)
val mskillAutoattack4_4048 = MobSkillId(4048)
val mskillTearingGust_4049 = MobSkillId(4049)
val mskillConcussiveShock_4050 = MobSkillId(4050)
val mskillChokehold_4051 = MobSkillId(4051)
val mskillZap_4052 = MobSkillId(4052)
val mskillShriekingGale_4053 = MobSkillId(4053)
val mskillUndulatingShockwave_4054 = MobSkillId(4054)
val mskillAutoattack1_4055 = MobSkillId(4055)
val mskillAutoattack2_4056 = MobSkillId(4056)
val mskillAutoattack3_4057 = MobSkillId(4057)
val mskillAutoattack4_4058 = MobSkillId(4058)
val mskillFeastofArrows_4059 = MobSkillId(4059)
val mskillCruelJoke_4060 = MobSkillId(4060)
val mskillRegurgitatedSwarm_4061 = MobSkillId(4061)
val mskillSettingtheStage_4062 = MobSkillId(4062)
val mskillLastLaugh_4063 = MobSkillId(4063)
val mskillAutoattack1_4064 = MobSkillId(4064)
val mskillAutoattack2_4065 = MobSkillId(4065)
val mskillAutoattack3_4066 = MobSkillId(4066)
val mskillFulminousSmash_4067 = MobSkillId(4067)
val mskillFlamingKick_4068 = MobSkillId(4068)
val mskillIcyGrasp_4069 = MobSkillId(4069)
val mskillFlashflood_4070 = MobSkillId(4070)
val mskillErodingFlesh_4071 = MobSkillId(4071)
val mskillVivisection_4072 = MobSkillId(4072)
val mskillSuperlativePotion_4073 = MobSkillId(4073)
val mskillSuperlativeHiPotion_4074 = MobSkillId(4074)
val mskillSuperlativeElixir_4075 = MobSkillId(4075)
val mskillSuperlativeGuardDrink_4076 = MobSkillId(4076)
val mskillHiPotion_4077 = MobSkillId(4077)
val mskillMaxPotion_4078 = MobSkillId(4078)
val mskillProvoke_4079 = MobSkillId(4079)
val mskillDefender_4080 = MobSkillId(4080)
val mskillSentinel_4081 = MobSkillId(4081)
val mskillRampart_4082 = MobSkillId(4082)
val mskillPalisade_4083 = MobSkillId(4083)
val mskillLastResort_4084 = MobSkillId(4084)
val mskillImplosion_4085 = MobSkillId(4085)
val mskillDoomArc_4086 = MobSkillId(4086)
val mskillAutoAttack1_4087 = MobSkillId(4087)
val mskillAutoAttack2_4088 = MobSkillId(4088)
val mskillAutoAttack3_4089 = MobSkillId(4089)
val mskillCesspool_4090 = MobSkillId(4090)
val mskillFetidEddies_4091 = MobSkillId(4091)
val mskillNullifyingRain_4092 = MobSkillId(4092)
val mskillNoyade_4093 = MobSkillId(4093)
val mskillAutoAttack3_4094 = MobSkillId(4094)
val mskillAutoAttack4_4095 = MobSkillId(4095)
val mskillFeastofArrows_4096 = MobSkillId(4096)
val mskillCruelJoke_4097 = MobSkillId(4097)
val mskillRegurgitatedSwarm_4098 = MobSkillId(4098)
val mskillFulminousSmash_4099 = MobSkillId(4099)
val mskillFlamingKick_4100 = MobSkillId(4100)
val mskillIcyGrasp_4101 = MobSkillId(4101)
val mskillFlashflood_4102 = MobSkillId(4102)
val mskillErodingFlesh_4103 = MobSkillId(4103)
val mskillAutoAttack1_4104 = MobSkillId(4104)
val mskillAutoAttack2_4105 = MobSkillId(4105)
val mskillAutoAttack3_4106 = MobSkillId(4106)
val mskillAutoAttack4_4107 = MobSkillId(4107)
val mskillImpudence_4108 = MobSkillId(4108)
val mskillIncessantVoid_4109 = MobSkillId(4109)
val mskillTenebrousGrip_4110 = MobSkillId(4110)
val mskillDemonfire_4111 = MobSkillId(4111)
val mskillFrozenBlood_4112 = MobSkillId(4112)
val mskillBlastofReticence_4113 = MobSkillId(4113)
val mskillEnsepulcher_4114 = MobSkillId(4114)
val mskillCeaselessSurge_4115 = MobSkillId(4115)
val mskillTorrentialPain_4116 = MobSkillId(4116)
val mskillEternalMisery_4117 = MobSkillId(4117)
val mskillCripplingAgony_4118 = MobSkillId(4118)
val mskillBaneofTartarus_4119 = MobSkillId(4119)
val mskillOverrun_4120 = MobSkillId(4120)
val mskillWingBuffer_4121 = MobSkillId(4121)
val mskillLandfall_4122 = MobSkillId(4122)
val mskillSwoopingAssault_4123 = MobSkillId(4123)
val mskillWrenchingImpale_4124 = MobSkillId(4124)
val mskillSeepingDread_4125 = MobSkillId(4125)
val mskillOppressiveYawp_4126 = MobSkillId(4126)
val mskillLuminousSurge_4127 = MobSkillId(4127)
val mskillTenebrousSurge_4128 = MobSkillId(4128)
val mskillPellucidSurge_4129 = MobSkillId(4129)
val mskillBlackSanctus_4130 = MobSkillId(4130)
val mskillSanativeShadow_4131 = MobSkillId(4131)
val mskillTartarusTocsin_4132 = MobSkillId(4132)
val mskillChainweave_4133 = MobSkillId(4133)
val mskillDissatisfaction_4134 = MobSkillId(4134)
val mskill_4135 = MobSkillId(4135)
val mskill_4136 = MobSkillId(4136)
val mskill_4137 = MobSkillId(4137)
val mskillBatholithicShell_4138 = MobSkillId(4138)
val mskillPerdition_4149 = MobSkillId(4149)